import $ from 'jquery';
import _ from 'underscore';
import Bowser2 from 'bowser';
import Card from 'card';
import Util from 'root/module/util';
import Cache from 'root/cache';
import UI from 'root/ui';
import Constants from 'root/constants';
import Router from 'root/router';
import Bottombar from 'root/module/bottombar';
import Sidebar from 'root/module/sidebar';
import Sidebar_Bg from 'root/module/sidebar_bg';
import Modal from 'root/module/modal';
import Modal_Bg from 'root/module/modal_bg';
import Modal_Fullscreen from 'root/module/modal_fullscreen';
import Form from 'root/module/form';
import Tooltip from 'root/module/tooltip';

import View_Onboarding from 'view/onboarding/index';

import View_Workspace_Select from 'root/view/workspace/login_select';

import Widget_Code from 'view/widget_code';
import View_Browser_Extension from 'view/browser_extension';

import View_Workspace_Create from 'view/workspace/create';

import View_New_Feedback from 'view/new_feedback';

import View_Survey_Response_Sidebar from 'view/survey_response/sidebar';
import View_Feedback_Sidebar from 'view/feedback_sidebar/index';
import View_Feedback_Merge from 'view/feedback_merge';
import View_Integration_Log_Sidebar from 'view/integration_log_sidebar';

import View_Account_Refer from 'view/account_refer';
import View_Expired_Account from 'view/expired_account';
import View_Account_Upgrade_Plan_Select_2022 from 'view/account_upgrade/plan_select_2022';
import View_Account_Upgrade_Plan_Select_2024 from 'view/account_upgrade/plan_select_2024';
import View_Account_Upgrade_Plan_Select_2025 from 'view/account_upgrade/plan_select_2025';
import View_Account_Upgrade_Payment from 'view/account_upgrade/payment';
import View_Account_Upgrade_Payment_2024 from 'view/account_upgrade/payment_2024';
import View_Account_Upgrade_Payment_2025 from 'view/account_upgrade/payment_2025';

import View_Invite_User from 'view/invite_user';
import View_User_Edit from 'view/user/edit';
import View_Member_Access_Edit from 'view/workspace_member/access_edit';
import View_User_Notification from 'view/user/notification';

import View_Portal_Settings_Index from 'page/portal/settings/index';
import View_Portal_Activate from 'view/portal/settings/activate';
import View_Portal_User_Edit from 'view/portal/user_edit';
import View_Portal_Notification from 'view/portal/notification';

import View_User_Identification from 'view/user_identification';
import View_User_Segment_Overview from 'view/user_identification/segment_overview';
import View_User_Segment_Edit from 'view/user_identification/segment_edit';

import View_Create_Project from 'view/project/create_project';
import View_Project_Members from 'view/project/members';
import View_Project_Members_Manage from 'view/project/members_manage';
import View_Project_Domains_Manage from 'view/project/domains_manage';
import View_Code_Install_Verify from 'view/project/code_install_verify';

import View_Project_Settings_Index from 'page/project/edit';
import View_Project_Notification_Editor from 'view/project/notification_editor';

import View_Template_Selection from 'view/template_gallery/selection';
import View_Template_Gallery from 'view/template_gallery/gallery';

import View_Feedback_Csv_Import from 'view/feedback_csv_import/index';
import View_Feedback_Share from 'view/feedback_share';
import View_Feedback_Move from 'view/feedback_move';
import View_Feedback_Comment_Edit from 'view/feedback_comment_edit';
import View_Feedback_Due_Date from 'view/feedback_sidebar/due_date';
import View_Feedback_Template_Edit from 'view/comment_template_edit';

import View_Session_Player from 'view/session_player';
import View_Session_Replay_Share from 'view/session_replay/share';
import View_Session_Replay_Settings from 'view/session_replay/settings';

import View_Survey_Activate from 'view/survey_designer/activate';
import View_Survey_Deactivate from 'view/survey_designer/deactivate';
import View_Survey_Answer from 'view/survey_response/question_condition';

import View_Jira_Connect from 'view/integration/jira_connect';
import View_Jira_Send from 'view/integration/jira_send';
import View_Jira_Edit from 'view/integration/jira_edit';
import View_Github_Send from 'view/integration/github_send';
import View_Github_Edit from 'view/integration/github_edit';
import View_Gitlab_Send from 'view/integration/gitlab_send';
import View_Gitlab_Edit from 'view/integration/gitlab_edit';
import View_Linear_Send from 'view/integration/linear_send';
import View_Linear_Edit from 'view/integration/linear_edit';
import View_Trello_Send from 'view/integration/trello_send';
import View_Trello_Edit from 'view/integration/trello_edit';
import View_Teamwork_Connect from 'view/integration/teamwork_connect';
import View_Teamwork_Edit from 'view/integration/teamwork_edit';
import View_Teamwork_Send from 'view/integration/teamwork_send';
import View_Clickup_Send from 'view/integration/clickup_send';
import View_Clickup_Edit from 'view/integration/clickup_edit';
import View_Slack_Edit from 'view/integration/slack_edit';
import View_Teams_Edit from 'view/integration/teams_edit';
import View_Zendesk_Edit from 'view/integration/zendesk_edit';
import View_Asana_Send from 'view/integration/asana_send';
import View_Asana_Edit from 'view/integration/asana_edit';
import View_Basecamp_Edit from 'view/integration/basecamp_edit';
import View_Monday_Connect from 'view/integration/monday_connect';
import View_Monday_Edit from 'view/integration/monday_edit';
import View_Monday_Send from 'view/integration/monday_send';
import View_Notion_Send from 'view/integration/notion_send';
import View_Notion_Edit from 'view/integration/notion_edit';
import View_Wrike_Send from 'view/integration/wrike_send';
import View_Wrike_Edit from 'view/integration/wrike_edit';
import View_Azure_Devops_Send from 'view/integration/azure_devops_send';
import View_Azure_Devops_Edit from 'view/integration/azure_devops_edit';

import View_Webhook_Edit from 'view/integration/webhook_edit';
import View_Survey_Designer from 'view/survey_designer/index';
import View_Widget_Studio from 'view/widget_studio/index';

import View_Session_Replay_Tags from 'view/session_replay/tags';
import View_Dev_Tools from 'view/dev_tools';
import {changeFeedbacksDueDate} from 'service/feedback';

var Modals = {
    close: function() {
        Modal.close();
    },

    verify50PromoOffer: function() {
        var modal = Modal.open({
            title: 'Claim the offer',
            content: '<div class="text-align-center padding-12">' +
                         '<p class="text-medium-large font-weight-medium margin-bottom-24">To get the <b>50% off your first invoice</b>, you will need to install the Userback Code on your website.</p>' +
                         '<img src="/image/promo-50.gif" class="rounded-corner" width="400" height="225">' +
                         '<div class="text-align-center install-code margin-top-24">' +
                             '<button class="medium shiny" style="width:200px;"><span>Install Code</span></button>' +
                         '</div>' +
                     '</div>'
        });

        modal.find('.install-code button').on('click', function() {
            Modals.getWidgetCode();
        });
    },

    showOnboardingWelcome: function(on_close) {
        var is_reversed_trial = Cache.account.get('signup_plan') !== 'business_plus';

        var content =
        '<div class="modal-onboarding-welcome">' +
            '<div class="padding-32">' +
                '<h2 class="font-weight-semibold margin-bottom-0">' + (is_reversed_trial ? '✨Congratulations, you\'ve been upgraded✨' : '✨Welcome to Userback✨') + '</h2>' +
                (is_reversed_trial ?
                '<p class="padding-left-32 padding-right-32 line-height-150">We\'ve upgraded you to a free 14-day trial of our top plan, Business Plus. Let\'s quickly show you around.</p>' :
                '<p class="padding-left-32 padding-right-32 line-height-150">You\'re all set with a free 14-day trial of our top Business Plus plan. Install the widget to start collecting feedback. But first, let us quickly show you around.</p>') +
            '</div>' +
            '<div><img src="/image/onboarding_welcome.png"></div>' +
            '<div class="flex-c">' +
                '<button type="button" class="feature-tour medium primary">Continue</button>' +
            '</div>' +
        '</div>';

        var modal = Modal.open({
            nopadding: true,
            notitle: true,
            width: 700,
            content: content,
            onclose: () => {
                if (on_close) {
                    on_close();
                }
            }
        });

        modal.find('button.getting-started').on('click', function() {
            Modal.close();
        });

        modal.find('button.feature-tour').on('click', function() {
            Modal.close();

            Cache.app.trackEvent('onboarding_feature_tour');
        });
    },

    launchFeature: function() {
        // trials don't get launch modals
        if (Cache.account.get('is_trial')) {
            return false;
        }

        // not admin login
        if (Cache.app.is_admin_login) {
            return false;
        }

        // not for client roles
        if (Cache.app.isClient()) {
            return false;
        }

        // show launch modal one at a time
        var launch_modals = [Modals.launchEmailForwarding];

        launch_modals.some((launch_func) => {
            var modal_shown = launch_func();

            if (modal_shown) {
                return true; // early exit
            }
        });

    },

    launchNextGenWidget: function() {
        if (Cache.account.get('join_time') >= 1740970800) {
            return false;
        }

        var feature_name = 'userback_next_gen_widget';

        if (Cache.get(feature_name)) {
            return false;
        }

        Cache.add(feature_name, 1, true);

        var content =
        '<div class="promo-video padding-8 cursor-pointer"><img class="rounded-corner" src="/image/next_gen_promo.png"></div>' +
        '<div class="padding-32">' +
            '<h3 class="text-align-center font-weight-semibold">Introducing the Next-Gen AI Assisted Widget</h3>' +
            '<p class="text-align-center">Feedback is crucial, but it shouldn\'t slow anyone down. That\'s why we’ve built a significantly improved widget that streamlines the feedback process with AI-powered tools and an improved user experience, helping you collect better feedback, faster! 👊.</p>' +
            '<div class="divider-24"></div>' +
            '<div class="text-align-center">' +
                '<div><button type="button" class="widget-upgrade shiny medium min"><span>See what\'s new</span></button></div>' +
                '<div class="divider-12"></div>' +
                '<div><a href="#" class="modal-close text-info text-medium">Close</a></div>' +
            '</div>' +
        '</div>';

        var modal = Modal.open({
            notitle: true,
            close: false,
            nopadding: true,
            content: content
        });

        modal.find('.promo-video').on('click', () => {
            Modals.previewVideo('https://static.userback.io/video/widget_next_gen_promo.mp4');
        });

        modal.find('.widget-upgrade').on('click', () => {
            window.open('https://docs.userback.io/changelog/next-gen-ai-assisted-widget', '_blank', 'noopener');
            Modal.close();
        });

        modal.find('.modal-close').on('click', (e) => {
            e.preventDefault();
            Modal.close();
        });

        return true;
    },

    launchAnnouncements: function() {
        var feature_name = 'userback_portal_announcements';

        if (Cache.get(feature_name)) {
            return false;
        }

        if (!Cache.account.hasFeature('portal')) {
            return false;
        }

        Cache.add(feature_name, 1, true);

        var content =
        '<div class="promo-video padding-8 cursor-pointer"><img class="rounded-corner" src="/image/launch/portal_announcements.png"></div>' +
        '<div class="padding-32">' +
            '<h3 class="text-align-center font-weight-semibold">Introducing Portal Announcements in Userback! 🚀</h3>' +
            '<p class="text-align-center">Keeping your users informed just got easier! With Portal Announcements, you can share important updates, product changes, and key messages from inside your ideas portal. <a href="https://support.userback.io/en/articles/10971972-portal-announcements" class="primary font-weight-medium" rel="noopener" target="help">Learn more <i class="fa-solid fa-square-arrow-up-right"></i></a>.</p>' +
            '<div class="divider-24"></div>' +
            '<div class="text-align-center">' +
                '<div><button type="button" class="cta shiny medium min"><span>Turn on in Portal Settings</span></button></div>' +
                '<div class="divider-12"></div>' +
                '<div><a href="#" class="modal-close text-info text-medium">Close</a></div>' +
            '</div>' +
        '</div>';

        var modal = Modal.open({
            notitle: true,
            close: false,
            nopadding: true,
            content: content
        });

        modal.find('.cta').on('click', () => {
            var portal = Cache.portal.findWhere({project_id: Cache.default_project_id});

            if (portal && Cache.app.isAdmin()) {
                window.open(portal.getUrl() + '?settings=1', 'portal');
            } else {
                window.open('https://support.userback.io/en/articles/10971972-portal-announcements', '_blank', 'noopener');
            }

            Modal.close();
        });

        modal.find('.modal-close').on('click', (e) => {
            e.preventDefault();
            Modal.close();
        });

        return true;
    },

    launchEmailForwarding: function() {
        var feature_name = 'userback_email_forwarding';

        if (Cache.get(feature_name)) {
            return false;
        }

        Cache.add(feature_name, 1, true);

        var content =
        '<div class="promo-video padding-8 cursor-pointer"><img class="rounded-corner" src="/image/launch/email_forwarding.png"></div>' +
        '<div class="padding-32">' +
            '<p class="text-align-center">Turn any email into actionable feedback by forwarding it to Userback. Our AI will clean it up, summarize it, and turn it into structured feedback. No more silos. Just fast, actionable feedback.</p>' +
            '<div class="divider-24"></div>' +
            '<div class="text-align-center">' +
                '<div><button type="button" class="cta shiny medium min"><span>Learn more</span></button></div>' +
                '<div class="divider-12"></div>' +
                '<div><a href="#" class="modal-close text-info text-medium">Close</a></div>' +
            '</div>' +
        '</div>';

        var modal = Modal.open({
            notitle: true,
            close: false,
            nopadding: true,
            content: content
        });

        modal.find('.cta').on('click', () => {
            window.open('https://support.userback.io/en/articles/11676508-email-forwarding', '_blank', 'noopener');
            Modal.close();
        });

        modal.find('.modal-close').on('click', (e) => {
            e.preventDefault();
            Modal.close();
        });

        return true;
    },

    onboarding: function() {
        var view = new View_Onboarding();

        Modal.open({
            close: false,
            notitle: true,
            width: 560,
            content: view,
            theme: 'modal-center-form'
        });

        $(document.body).addClass('modal-blur');
    },

    expiredAccount: function() {
        var expired_account_view = new View_Expired_Account({
            is_free: false
        });

        Modal.open({
            close: Cache.app.isAdmin() ? true : false, // non admin users can't see the billing page
            notitle: true,
            nopadding: true,
            width: 600,
            content: expired_account_view
        });
    },

    // shown once when trial is expired
    expiredTrial: function() {
        var view = new View_Expired_Account({
            is_free: false
        });

        if (Cache.app.getUserSetting('expired_trial_prompt')) {
            return;
        }

        if (Cache.app.is_admin_login) {
            return;
        }

        Modal.open({
            notitle: true,
            nopadding: true,
            width: 600,
            content: view
        });

        var timestamp = Math.floor(Date.now() / 1000);
        Cache.app.addUserSetting('expired_trial_prompt', timestamp, false);
    },

    expiredFeedback: function() {
        var expired_account_view = new View_Expired_Account({
            is_free: true
        });

        Modal.open({
            notitle: true,
            nopadding: true,
            width: 600,
            content: expired_account_view
        });
    },

    expiredSurvey: function() {
        var expired_account_view = new View_Expired_Account({
            is_free: true
        });

        Modal.open({
            notitle: true,
            nopadding: true,
            width: 600,
            content: expired_account_view
        });
    },

    closeAccount: function() {
        var content =
        '<form class="compact">' +
            '<p>We are sorry to see you go. Please tell us why you\'re leaving.</p>' +
            '<div>' +
                '<input type="radio" name="reason" value="1" id="r_1"><label for="r_1">Pricing - I do not see enough value to justify the cost</label>' +
            '</div>' +
            '<div>' +
                '<input type="radio" name="reason" value="2" id="r_2"><label for="r_2">Too simple - the product is missing critical features I need</label>' +
            '</div>' +
            '<div>' +
                '<input type="radio" name="reason" value="3" id="r_3"><label for="r_3">I no longer use it</label>' +
            '</div>' +
            '<div>' +
                '<input type="radio" name="reason" value="4" id="r_4"><label for="r_4">Other</label>' +
                '<div class="margin-top-8 margin-left-24"><textarea class="solid" rows="4"></textarea></div>' +
            '</div>' +
        '</form>' +
        '<div class="banner-danger margin-top-24">' +
            '<p>Are you sure? Exciting new pricing and features are coming soon.<br>Deleting your workspace means you\'ll miss out and your data will be <span class="text-danger font-weight-medium">permanently deleted</span>. To keep your account active and see what pricing options are available, <a href="#" class="contact-us">contact us</a>.</p>' +
        '</div>';

        var modal = Modal.open({
            title: 'Delete Workspace',
            content: content,
            button_class: 'secondary',
            button: {
                'Yes, delete': function(e) {
                    var reason_option = modal.find('form input:checked');

                    if (!reason_option.length) {
                        UI.error('Please tell us why you\'re leaving.');
                        return;
                    }

                    var reason = reason_option.next('label').text();

                    if (reason === 'Other') {
                        reason = modal.find('form textarea').val() || 'Other';
                    }

                    modal.find('.modal-button button').addClass('loading').prop('disabled', true);

                    Cache.app.request({
                        action: 'account/delete',
                        data: {
                            reason: reason
                        },
                        success: function(response) {
                            // Intercom
                            Cache.account.set({
                                is_deleted: true
                            });

                            // Intercom & Mixpanel
                            Cache.app.trackEvent('Workspace Deleted');

                            // let trakcing finish
                            setTimeout(() => {
                                window.location = Cache.app.host;
                            }, 1000);
                        }
                    });
                }
            }
        });

        modal.find('form textarea').on('focus', function() {
            modal.find('#r_4').prop('checked', true);
        });

        modal.find('.contact-us').on('click', function(e) {
            e.preventDefault();
            Cache.app.dispatcher.trigger('contactUs');
        });
    },

    openDemo: function(on_close, show_edit) {
        var original_path = window.location.pathname;

        if (original_path.endsWith('/demo')) {
            original_path = original_path.replace(/\/demo$/, '\/');
        }

        Router.navigate(original_path.replace(/\/$/, '') + '/demo', {trigger: false});

        var default_project = Cache.getDefaultProject();
        var project_type = default_project.get('project_type');

        var overlay = $('<div>').addClass('demo-iframe loader').html(
            '<div class="demo-header">' +
                '<div class="demo-project-name">' +
                    '<div class="project-name-inline-edit">' +
                        '<span class="project-type-icon" data-val="' + (project_type) + '"></span>' +
                        '<span class="project-name">' + (default_project.get('name')) + '</span>' +
                    '</div>' +
                '</div>' +
                '<div>' +
                    '<div class="device-type badge-group-tertiary">' +
                        '<span class="min active" data-val="desktop">Desktop</span>' +
                        '<span class="min" data-val="mobile">Mobile</span>' +
                    '</div>' +
                '</div>' +
                '<div class="flex-start">' +
                    (Cache.app.isAdmin() && show_edit ? '<button type="button" class="btn-edit tertiary small min margin-right-8">Edit ' + (project_type === 'survey' ? 'Survey' : 'Widget') + '</button>' : '') +
                    '<button type="button" class="btn-close demo-close">' +
                        '<i class="fa-regular fa-xmark"></i>' +
                    '</button>' +
                '</div>' +
            '</div>' +
            '<div class="demo-window">' +
                '<div class="demo-content">' +
                    '<div class="demo-address-bar">' +
                        '<div class="demo-address-bar-url margin-right-16"><i class="fa-solid fa-lock fa-xs"></i> ' + window.location.origin  +'/demo</div>' +
                        '<button type="button" class="demo-address-bar-refresh tertiary tiny">' +
                            '<i class="fa-solid fa-fw fa-rotate-right"></i>' +
                            '<span class="margin-left-4">Refresh</span>' +
                        '</button>' +
                    '</div>' +
                    '<iframe src="/' + Cache.getDefaultProject().get('project_key') + '/demo"></iframe>' +
                    '<div class="demo-footer">' +
                        '<div class="demo-footer-bar"></div>' +
                    '</div>'+
                '</div>' +
            '</div>').appendTo('body');

        overlay.find('.device-type span').on('click', (e) => {
            overlay.find('.device-type span').removeClass('active');
            $(e.currentTarget).addClass('active');
            overlay.find('.demo-window').attr('data-device', $(e.currentTarget).attr('data-val'));
            $(overlay.find('iframe').get(0).contentWindow.document.body).attr('data-device', $(e.currentTarget).attr('data-val'));
        });

        overlay.find('.btn-edit').on('click', () => {
            var designer_view;

            if (project_type === 'survey') {
                designer_view = new View_Survey_Designer({});
            } else {
                designer_view = new View_Widget_Studio({});
            }

            designer_view.render().$el.appendTo('body');
        });

        overlay.find('.demo-address-bar-refresh').on('click', () => {
            overlay.find('iframe').get(0).contentWindow.postMessage('userback_reload');
        });

        overlay.find('.demo-close').on('click', () => {
            Router.navigate(original_path, {trigger: false});

            overlay.remove();
            window.removeEventListener('message', onMessage);

            if (on_close) {
                on_close();
            }
        });

        var onMessage = (e) => {
            if (e.data.source !== 'demo') {
                return;
            }

            overlay.removeClass('loader');

            window.removeEventListener('message', onMessage);
        };

        window.addEventListener('message', onMessage);
    },

    previewVideo: function(video_url, options) {
        options = options || 'muted controls';

        var overlay = $('<div class="overlay">' +
                            '<video class="video-player-modal" src="' + video_url + '" ' + options + '></video>' +
                            '<button class="video-player-modal-close"><i class="fas fa-times-circle"></i></button>' +
                        '</div>');

        overlay.find('.video-player-modal-close').on('click', function() {
            overlay.remove();
        });

        overlay.appendTo($(document.body));
    },

    scrapeWebsite: function(workflow_id, callback, on_complete) {
        var scrape_finished = false;

        var feedback_ids;

        var modal = Modal.open({
            title: 'Create design from a website',
            content: '<form class="form-fluid" style="min-height:75px;">' +
                         '<div class="row">' +
                             '<div class="field-label">Enter a website URL</div>' +
                             '<input type="url" class="solid medium" name="url" placeholder="https://www.example.com" required>' +
                         '</div>' +
                         '<div>' +
                             '<input type="checkbox" name="device_type" value="desktop" checked><label class="margin-right-12">Desktop</label>' +
                             '<input type="checkbox" name="device_type" value="tablet"><label class="margin-right-12">Tablet</label>' +
                             '<input type="checkbox" name="device_type" value="mobile"><label>Mobile</<label>' +
                         '</div>' +
                         '<button type="submit" class="hidden"></button>' +
                     '</form>',
            button: {
                Submit: function() {
                    if (scrape_finished) {
                        Modal.close();
                        callback(feedback_ids);
                    } else {
                        modal.find('button[type="submit"]').click();
                    }
                }
            }
        });

        var _startPoll = function() {
            Cache.app.request({
                action: 'feedback/poolWebsiteScrape',
                data: {
                    feedback_ids: feedback_ids
                },
                success: function(response) {
                    if (response.success > 0 && response.pending === 0) {
                        // complete
                        modal.find('.meteor-success span').width('100%');
                        modal.find('button.primary').removeClass('loading').prop('disabled', false).text('View my design');
                        modal.find('.upload-status').text('Upload finished');

                        on_complete();

                        scrape_finished = true;
                    } else if (response.success === 0 && response.pending === 0) {
                        // something went wrong
                    } else {
                        // processing
                        var percentage = response.success / (response.success + response.pending);
                        percentage = Math.max(0.05, percentage);
                        modal.find('.meteor-success span').width(percentage * 100 + '%');

                        setTimeout(function() {
                            _startPoll();
                        }, 2000);
                    }
                }
            });
        };

        modal.find('input[name="url"]').focus().val('https://');

        modal.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData($(this));

            modal.find('button.primary').addClass('loading').prop('disabled', true);

            Modal.setContent('<div style="min-height:75px;">' +
                                    '<div class="margin-bottom-8 padding-top-16 upload-status">Uploading...</div>' +
                                    '<div class="meteor-success"><div><span style="width:5%;"></span></div></div>' +
                                '</div>');

            Cache.app.request({
                action: 'feedback/queueWebsiteScrape',
                data: {
                    url: form_data.url,
                    workflow_id: workflow_id,
                    device_type: form_data.device_type
                },
                success: function(response) {
                    feedback_ids = response;

                    setTimeout(function() {
                        _startPoll();
                    }, 2000);
                }
            });
        });
    },

    uploadVideo: function(files, size_limit, xhr_data, callback, on_complete) {
        var complete_count = 0;
        var total_count = files.length;

        var modal = Modal.open({
            width: 500,
            title: 'Upload ' + total_count + ' video file' + (total_count === 1 ? '' : 's'),
            content: '<div class="upload-progress"></div>' +
                        '<div class="text-align-center margin-top-32"><button class="primary view-designs" disabled>View my video file</button></div>'
        });

        var callback_response = [];

        modal.find('.view-designs').on('click', function(e) {
            Modal.close();
            callback(callback_response);
        });

        var _getErrorProgressHTML = function(file_name, error_msg) {
            return '<span class="upload-success text-danger"><i class="fas fa-times-circle"></i></span>' +
                    '<span class="file-preview">' + Util.getFileIcon(file_name, true) + '</span>' +
                    '<span>' + Util.htmlEntities(file_name) + '</span>' +
                    '<div class="margin-left-22 info">' + error_msg  + '</div>';
        };

        _.each(files, function(file) {
            var result = Util.readFile(file, size_limit, function(file_name, file_type, file_result) {
                var is_video = Util.isVideo(file_name);

                if (!is_video) {
                    complete_count++;

                    if (complete_count === total_count) {
                        modal.find('.view-designs').prop('disabled', false);
                    }

                    var progress = $('<div class="img-upload-progress">')
                        .html(_getErrorProgressHTML(file.name, 'Upload a .mp4 or .mov file'))
                        .appendTo(modal.find('.upload-progress'));
                } else {
                    var progress = $('<div class="img-upload-progress">')
                        .html('<span class="upload-success"><i class="fas fa-spin fa-spinner-third info"></i></span>' +
                                '<span class="file-preview">' + Util.getFileIcon(file_name, true) + '</span>' +
                                '<span>' + Util.htmlEntities(file_name) + '</span>')
                        .appendTo(modal.find('.upload-progress'));

                    Cache.app.request({
                        action: 'feedback/createVideoEntry',
                        data: _.extend({
                            name: file_name,
                            type: file_type
                        }, xhr_data),
                        success: function(response) {
                            $.ajax(response.presigned_url, {
                                type: 'PUT',
                                data: Util.dataURItoBlob(file_result),
                                crossDomain: true,
                                processData: false,
                                success: function() {
                                    Cache.app.request({
                                        action: 'feedback/setVideoUrl',
                                        data: {
                                            id        : response.feedback_id,
                                            video_url : response.object_url
                                        },
                                        success: function() {
                                            complete_count++;

                                            progress.find('.upload-success').addClass('text-success').html('<i class="fas fa-check-circle"></i>');

                                            callback_response.push(response);

                                            if (complete_count === total_count) {
                                                modal.find('.view-designs').prop('disabled', false);
                                            }

                                            if (on_complete) {
                                                on_complete(callback_response);
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        });
    },

    uploadFiles: function(files, size_limit, image_only, action, button_text, callback, xhr_data, on_complete, close_text, help_text) {
        var complete_count = 0;
        var error_count    = 0;
        var total_count    = files.length;

        var modal = Modal.open({
            width: 500,
            title: 'Upload ' + total_count + ' design' + (total_count === 1 ? '' : 's'),
            content: '<div class="upload-progress"></div>' +
                        '<div class="text-align-center margin-top-32">' +
                            (help_text ? '<p>' + help_text + '</p>' : '') +
                            (close_text ?
                            '<a href="#" class="modal-close info margin-right-12">' + close_text + '</a>' : '') +
                            '<button class="primary view-designs" disabled>' + button_text + '</button>' +
                        '</div>'
        });

        var callback_response = [];

        modal.find('.view-designs').on('click', function(e) {
            Modal.close();
            callback(callback_response);
        });

        modal.find('a.modal-close').on('click', function(e) {
            e.preventDefault();
            Modal.close();
        });

        var _getErrorProgressHTML = function(file_name, error_msg) {
            return '<span class="upload-success text-danger"><i class="fas fa-times-circle"></i></span>' +
                    '<span class="img-preview img-preview-error"><i class="far fa-ban"></i></span>' +
                    '<span>' + Util.htmlEntities(file_name) + '</span>' +
                    '<div class="margin-left-22 info">' + error_msg  + '</div>';
        };

        _.each(files, function(file) {
            var result = Util.readFile(file, size_limit, function(file_name, file_type, file_content) {
                var is_image = Util.isImage(file_name);

                if (image_only && !is_image) {
                    complete_count++;
                    error_count++;

                    if (complete_count === total_count && error_count !== total_count) {
                        modal.find('.view-designs').prop('disabled', false);
                    }

                    var progress = $('<div class="img-upload-progress">')
                        .html(_getErrorProgressHTML(file.name, 'Upload a .png, .jpg or .gif image'))
                        .appendTo(modal.find('.upload-progress'));
                } else {
                    var progress = $('<div class="img-upload-progress">')
                        .html('<span class="upload-success"><i class="fas fa-spin fa-spinner-third info"></i></span>' +

                                (is_image ?
                                '<span class="img-preview" style="background-image:url(' + file_content + ');"></span>' :
                                '<span class="file-preview">' + Util.getFileIcon(file_name, true) + '</span>') +
                                '<span>' + Util.htmlEntities(file_name) + '</span>')
                        .appendTo(modal.find('.upload-progress'));

                    var data = {
                        name    : file_name,
                        type    : file_type,
                        content : file_content
                    };

                    var _doPost = function() {
                        Cache.app.request({
                            action: action,
                            data: xhr_data ? _.extend(data, xhr_data) : data,
                            success: function(response) {
                                complete_count++;

                                progress.find('.upload-success').addClass('text-success').html('<i class="fas fa-check-circle"></i>');

                                callback_response.push(response);

                                if (complete_count === total_count) {
                                    modal.find('.view-designs').prop('disabled', false);

                                    if (on_complete) {
                                        on_complete(callback_response);
                                    }
                                }
                            }
                        });
                    };

                    if (is_image) {
                        var image = new Image();

                        image.onload = function() {
                            data.width  = image.width;
                            data.height = image.height;

                            _doPost();
                        };

                        image.src = data.content;
                    } else {
                        _doPost();
                    }
                }
            });

            if (result !== true) {
                complete_count++;
                error_count++;

                if (complete_count === total_count && error_count !== total_count) {
                    modal.find('.view-designs').prop('disabled', false);
                }

                var progress = $('<div class="img-upload-progress">')
                    .html(_getErrorProgressHTML(file.name, result))
                    .appendTo(modal.find('.upload-progress'));

                var reader = new FileReader();
                reader.onloadend = function() {
                    progress.find('.img-preview').css('background-image', 'url(' + reader.result + ')')
                };

                reader.readAsDataURL(file);
            }
        });
    },

    choosePlan: function(on_close, on_success, change_user_limit, change_response_limit, change_session_limit, change_portal) {
        var current_location = window.location.pathname + window.location.search;

        if (change_user_limit) {
            Router.navigate('/plan/?s=2', {trigger:false});
        } else if (change_response_limit) {
            Router.navigate('/plan/?s=3', {trigger:false});
        } else if (change_session_limit) {
            Router.navigate('/plan/?s=4', {trigger:false});
        } else if (change_portal) {
            Router.navigate('/plan/?s=5', {trigger:false});
        } {
            Router.navigate('/plan/', {trigger:false});
        }

        $('#app').removeClass('blur');

        var view_choose_plan;
        var view_payment;

        var modal = Modal.open({
            fullscreen: true,
            title: 'Choose your plan',
            theme: 'info-bg',
            onclose: function() {
                Router.navigate(current_location, {trigger:false});
                Router.removeQueryString('upgrade');

                if (view_choose_plan) {
                    view_choose_plan.remove();
                }

                if (view_payment) {
                    view_payment.remove();
                }

                if (typeof on_close === 'function') {
                    on_close();
                }
            }
        });

        if (Cache.account.isPricing2025()) {
            view_choose_plan = new View_Account_Upgrade_Plan_Select_2025();
        } else if (Cache.account.isPricing2024()) {
            view_choose_plan = new View_Account_Upgrade_Plan_Select_2024();
        } else {
            view_choose_plan = new View_Account_Upgrade_Plan_Select_2022();
        }

        view_choose_plan.render().$el.appendTo(modal.find('.modal-content'));

        view_choose_plan.on('continue', function(options) {
            view_choose_plan.$el.hide();

            if (Cache.account.isPricing2025()) {
                view_payment = new View_Account_Upgrade_Payment_2025(options);
            } else if (Cache.account.isPricing2024()) {
                view_payment = new View_Account_Upgrade_Payment_2024(options);
            } else {
                view_payment = new View_Account_Upgrade_Payment(options);
            }

            view_payment.render().$el.appendTo(modal.find('.modal-content'));

            view_payment.on('back', function(options) {
                view_payment.remove();

                view_choose_plan.setOptions(options);
                view_choose_plan.render().$el.show();

                Modal.setTitle('Choose a Plan');
            });


            var is_upgrade = Cache.account.get('is_trial') || Cache.account.get('is_expired') || (Cache.account.get('appsumo') && !Cache.account.get('credit_card_digit'));

            if (is_upgrade) {
                Modal.setTitle('Let\'s finish powering you up!');
            } else {
                Modal.setTitle('Let\'s do this!');
            }
        });

        if (change_user_limit) {
            view_choose_plan.continue();
            modal.find('input[name="user-limit"]').focus();
        } else if (change_response_limit) {
            view_choose_plan.continue();
            modal.find('button.response-limit').focus();
        } else if (change_session_limit) {
            if (Cache.account.isPricing2025()) {
                view_choose_plan.continue(Constants.PLAN_2025_BUSINESS_PLUS);
            } else {
                view_choose_plan.continue();
            }

            modal.find('button.session-limit').focus();
        } else if (change_portal) {
            view_choose_plan.continue();
            modal.find('button.addon-toggle').focus();
        }
    },

    unlockFeature: function(content, button_text, title, on_click) {
        if (!content) {
            content = 'This feature is not available in your plan.<br>Upgrade your account to get access.';
        }

        button_text = button_text || 'Change Plan';
        title       = title || 'Upgrade to unlock';

        var modal = Modal.open({
            width: 500,
            notitle: true,
            content: '<div class="error-dialog">' +
                         '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                         '<h3>' + title + '</h3>' +
                         '<p class="info">' + content + '</p>' +
                         '<button class="upgrade shiny medium"><span>' + button_text + '</span></button>' +
                     '</div>'
        });

        modal.find('button.upgrade').on('click', function() {
            if (Cache.app.isPublicPage()) {
                window.location = '/account';
            } else {
                if (typeof on_click === 'undefined') {
                    Modals.choosePlan();
                } else {
                    on_click();
                }
            }
        });
    },

    createExtensionKey: function(extension_key_id) {
        if (!Cache.account.hasFeature('extension_key')) {
            Modals.unlockFeature('Extension key is not available in your plan.<br>Upgrade your account to get access.', 'Let\'s Go');
            return;
        }

        if (Cache.extension_key.length >= 50) {
            Modal.open({
                title: 'Limit reached',
                content: 'You can only have a maximum of 50 extension keys at a time. Please delete some before creating a new one.',
                button: {
                    OK:  function() {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var extension_key_model;

        if (extension_key_id) {
            extension_key_model = Cache.extension_key.get(extension_key_id);
        }

        var project_options = '';

        Cache.project.where({is_archived: false}).forEach(function(model) {
            if (model.isFeedback()) {
                project_options += '<option value="' + model.id + '">' + model.escape('name')  +'</option>';
            }
        });

        var modal = Modal.open({
            title: extension_key_model ? 'Edit extension key' : 'Create an extension key',
            content: '<form class="form-fluid">' +
                        '<button type="submit" class="hidden"></button>' +
                        '<div class="row">' +
                            '<div class="field-label">Choose a Project</div>' +
                            '<select class="solid medium" name="project_id" required>' + project_options + '</select>' +
                        '</div>' +
                        '<div class="row">' +
                            '<div class="field-label">Label</div>' +
                            '<input type="text" class="solid medium" name="name" maxlength="50" required>' +
                            '<div class="text-small info margin-top-8">Choose a label that is short and easy to remember.</div>' +
                        '</div>' +
                    '</form>',
            button: {
                Create: function() {
                    modal.find('button[type="submit"]').click();
                }
            }
        });

        if (extension_key_model) {
            Form.setData(modal.find('form'), {
                name       : extension_key_model.get('name'),
                project_id : extension_key_model.get('project_id')
            });
        }

        modal.find('input[name="name"]').focus();

        modal.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData($(this));

            modal.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: extension_key_model ? 'extension_key/update' : 'extension_key/create',
                data: extension_key_model ? _.extend(form_data, {id: extension_key_id}) : form_data,
                success: function(response) {
                    if (extension_key_model) {
                        extension_key_model.set({
                            project_id : form_data.project_id,
                            name       : form_data.name
                        });

                        UI.success('Extension key updated');

                        Modal.close();
                    } else {
                        Cache.extension_key.add(response);

                        Modals.shareExtensionKey(response.id);
                        Modal.setTitle('Your new extension key');
                    }
                },
                complete: function() {
                    modal.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    editExtensionKey: function(extension_key_id) {
        Modals.createExtensionKey(extension_key_id);
    },

    deleteExtensionKey: function(extension_key_id) {
        var model = Cache.extension_key.get(extension_key_id);

        var modal = Modal.open({
            title: 'Revoke Extension Key',
            content: 'Are you sure you want to permanently revoke the extension key <b>' + model.escape('name') + '</b>? This cannot be undone.',
            button_class: 'secondary',
            button: {
                'Yes, revoke': function() {
                    modal.find('.modal-button button.primary').addClass('loading').prop('disabled', true);

                    Cache.app.request({
                        action: 'extension_key/delete',
                        context: this,
                        data: {
                            id: extension_key_id
                        },
                        success: function(response) {
                            Cache.extension_key.remove(model);
                            UI.success('Extension key revoked');

                            Modal.close();
                        },
                        complete: function() {
                            modal.find('.modal-button button.primary').removeClass('loading').prop('disabled', false);
                        }
                    });
                }
            }
        });

        Modal.focusButton();
    },

    shareExtensionKey: function(extension_key_id) {
        var model = Cache.extension_key.get(extension_key_id);
        var project = Cache.project.get(model.get('project_id'));

        var modal = Modal.open({
            title: 'Share Extension key',
            content: '<div class="api-token-copy">' +
                            (project ? '<p class="margin-bottom-24">People can use this key to log in browser extension and submit feedback to the <b>' + project.escape('name') + '</b> project.</p>' : '') +
                            '<p>Copy this extension key to share:</p>' +
                            '<div>' +
                                '<pre class="medium"><span class="purple">' + model.get('access_key') + '</span></pre>' +
                                '<button class="copy-token primary small">Copy</button>' +
                            '</div>' +
                            '<div class="copy-success success margin-top-12" style="opacity:0;"><i class="fas fa-check-circle"></i> Extension key copied to clipboard</div>' +
                            '<div style="max-width:400px;margin:auto auto 20px auto;">' +
                            '<div class="hr medium"><span>Or</span></div>' +
                            '</div>' +
                            '<p>Email the extension key: <i class="info fas fa-question-circle tooltip" data-title="Instructions on how to install the extension will be included"></i></p>' +
                            '<form class="copy-input">' +
                                '<div class="margin-bottom-0">' +
                                    '<input type="text" name="email" placeholder="jason@example.com" maxlength="400" required>' +
                                '</div>' +
                                '<button class="primary medium email-send">Send</button>' +
                            '</form>' +
                        '</div>'
        });

        modal.find('.copy-token').on('click', function(e) {
            modal.find('pre').focus();

            try {
                var range = document.createRange();
                range.selectNode(modal.find('pre').get(0));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand('copy');

                modal.find('.copy-success').css('opacity', 1);
            } catch (e) {
            }
        });

        modal.find('form.copy-input').on('submit', function(e) {
            var emails = [];
            var valid  = true;

            var email_input = modal.find('form.copy-input').find('input[name="email"]');
            var email_value = email_input.val().trim();

            $(email_value.split(/[(,)( )(\r\n)(\r)(\n)]+/)).each(function(index, email) {
                email = email.trim();
                if (email.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) && !email.match(/qq\.com/) && !email.match(/163\.com/)) {
                    emails.push(email);
                } else {
                    email_input.get(0).selectionStart = email_value.indexOf(email);
                    email_input.get(0).selectionEnd   = email_value.indexOf(email) + email.length;
                    email_input.focus();

                    valid = false;
                    return false;
                }
            });

            if (!valid || !emails.length) {
                return;
            }

            if (emails.length > 10) {
                UI.error('You can only share with 10 people at a time.');
                return;
            }

            modal.find('.email-send').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'extension_key/share',
                context: this,
                data: {
                    emails: emails,
                    id: model.id
                },
                success: function(response) {
                    Modal.close();
                    UI.success('Email sent');
                },
                complete: function() {
                    modal.find('.email-send').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    createApiToken: function() {
        if (Cache.api_token.length >= 20) {
            Modal.open({
                title: 'Limit reached',
                content: 'You can only have a maximum of 20 API tokens at a time. Please delete some before creating a new one.',
                button: {
                    OK:  function() {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var modal = Modal.open({
            title: 'Create an API token',
            content: '<form class="form-fluid">' +
                         '<button type="submit" class="hidden"></button>' +
                         '<div class="row">' +
                             '<div class="field-label">Label</div>' +
                             '<input type="text" class="solid medium" name="name" maxlength="50" required>' +
                             '<div class="text-medium text-info margin-top-8">Choose a label that is short and easy to remember.</div>' +
                         '</div>' +
                     '</form>',
            button: {
                Create: function() {
                    modal.find('button[type="submit"]').click();
                }
            }
        });

        modal.find('input[name="name"]').focus();

        modal.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData($(this));

            modal.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'api_token/create',
                data: form_data,
                success: function(response) {
                    Cache.api_token.add(response);

                    Modal.setTitle('Your new API token');
                    Modal.setContent('<div class="api-token-copy">' +
                                            '<p>Make sure you copy your new API token. You won’t be able to see this token again.</p>' +
                                            '<div>' +
                                                '<pre class="medium"><span class="purple">' + response.api_token + '</span></pre>' +
                                                '<button class="copy-token primary small">Copy</button>' +
                                            '</div>' +
                                            '<p class="copy-success"><i class="fas fa-check-circle"></i> API token copied to clipboard</p>' +
                                        '</div>');
                    modal.find('.modal-button').remove();

                    modal.find('.copy-token').on('click', function(e) {
                        modal.find('pre').focus();

                        try {
                            var range = document.createRange();
                            range.selectNode(modal.find('pre').get(0));
                            window.getSelection().removeAllRanges();
                            window.getSelection().addRange(range);
                            document.execCommand('copy');

                            modal.find('.copy-success').css('opacity', 1);
                        } catch (e) {
                        }
                    });
                },
                complete: function() {
                    modal.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    deleteApiToken: function(api_token_id) {
        var model = Cache.api_token.get(api_token_id);

        var modal = Modal.open({
            title: 'Revoke API token',
            content: 'Are you sure you want to permanently revoke the API token <b>' + model.escape('name') + '</b>? This cannot be undone.',
            button: {
                'Yes, revoke': function() {
                    modal.find('.modal-button button.primary').addClass('loading').prop('disabled', true);

                    Cache.app.request({
                        action: 'api_token/delete',
                        context: this,
                        data: {
                            id: api_token_id
                        },
                        success: function(response) {
                            Cache.api_token.remove(model);
                            UI.success('API token revoked');

                            Modal.close();
                        },
                        complete: function() {
                            modal.find('.modal-button button.primary').removeClass('loading').prop('disabled', false);
                        }
                    });
                }
            }
        });

        Modal.focusButton();
    },

    emptyFeedbackDescription: function(model) {
        Modal.confirm('Are you sure you want to delete this comment and the replies?', function(e) {
            e.stopPropagation();

            _.each(Cache.feedback_comment.where({reply_comment_id: 0, screen_number: 0, video_time: 0}), function(reply_comment_model) {
                Cache.feedback_comment.remove(reply_comment_model);
            });

            model.set('description', '');

            Cache.app.request({
                action: 'feedback/emptyDescription',
                data: {id: model.id},
                success: function(response) {
                    UI.success('Comment removed');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    deleteThread: function(model) {
        var _doRemove = function() {
            Cache.feedback_comment.where({reply_comment_id: model.id}).forEach(function(reply_comment_model) {
                Cache.feedback_comment.remove(reply_comment_model);
            });

            Cache.feedback_comment.remove(model);

            Cache.app.request({
                action: 'feedback\\comment/delete',
                data: {ids: [model.id]},
                success: function(response) {
                    UI.success('Comment removed');
                }
            });
        };

        if (Cache.feedback_comment.where({reply_comment_id: model.id}).length || model.get('comment')) {
            Modal.confirm('Are you sure you want to delete this comment and the replies?', function(e) {
                e.stopPropagation();

                _doRemove();
            }, this, 'Yes, delete', undefined, 'secondary');
        } else {
            _doRemove();
        }
    },

    editComment: function(model) {
        var view = new View_Feedback_Comment_Edit({model: model});

        Modal.open({
            title: 'Edit Comment',
            content: view,
            button: {
                Save: function() {
                    var comment = view.getComment();

                    if (!comment) {
                        view.focus();
                        return;
                    }

                    if (comment !== model.get('comment')) {
                        model.set({
                            comment: comment,
                            last_edit_time: Math.ceil((new Date()).getTime() / 1000)
                        });

                        Cache.app.request({
                            action: 'feedback\\comment/edit',
                            data: {
                                id: model.id,
                                comment: comment
                            }
                        });
                    }

                    UI.success('Comment updated');

                    Modal.close();
                }
            }
        });
    },

    deleteComment: function(model) {
        var message = 'Are you sure you want to delete this comment and the replies?';

        if (Cache.feedback_comment.findWhere({reply_comment_id: model.id})) {
            message = 'Are you sure you want to delete this comment and the replies?';
        }

        Modal.confirm(message, function(e) {
            e.stopPropagation();

            Cache.feedback_comment.where({reply_comment_id: model.id}).forEach(function(child_model) {
                Cache.feedback_comment.remove(child_model);
            });
            Cache.feedback_comment.remove(model);

            Cache.app.request({
                action: 'feedback\\comment/delete',
                data: {ids: [model.id]},
                success: function(response) {
                    UI.success('Comment removed');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    deletePortalProfile: function() {
        var content = '<p>Are you sure you want to delete your profile? Once deleted, you won\'t be able to log in again.</p>' +
                      '<div class="margin-top-48 text-align-center"><button type="button" class="secondary delete">Yes, delete</button></div>';

        var modal = Modal.open({
            width: 500,
            title: 'Delete Profile',
            content: content
        });

        modal.find('button.delete').on('click', function() {
            $(this).addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'portal_user/deleteMyProfile',
                data: {},
                success: function() {
                    window.location.href = Cache.portal.at(0).getUrl();
                }
            });
        });
    },

    deleteMyProfile: function(email, password, user_id) {
        var content = '<p>Are you sure you want to delete your profile? Once deleted, you won\'t be able to log in anymore.</p>' +
                      '<div class="margin-top-32 text-align-center"><button type="button" class="secondary delete">Yes, delete</button></div>';

        var modal = Modal.open({
            width: 500,
            title: 'Delete Profile',
            content: content
        });

        modal.find('button.delete').on('click', function() {
            $(this).addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'user/deleteMyProfile',
                anon: true,
                data: {
                    email    : email,
                    password : password,
                    user_id  : user_id
                },
                success: function() {
                    UI.success('Profile deleted');

                    setTimeout(() => {
                        window.location = Cache.app.host + '/login/';
                    }, 1000);
                }
            });
        });
    },

    editMemberAccess: function(model) {
        var view = new View_Member_Access_Edit({
            model: model
        });

        Modal.open({
            title: 'Manage role and access',
            content: view,
            width: 500,
            onclose: () => {
                view.remove();
            }
        });
    },

    deleteWorkspaceMember: function(member_id) {
        var workspace_member = Cache.workspace_member.get(member_id);
        var user_id = workspace_member.get('user_id');

        Modal.confirm('<p>Are you sure you want to remove the workspace member? The member will be removed from their assigned feedback and project settings.</p>', function() {
            Cache.app.request({
                action: 'workspace_member/delete',
                data: {
                    ids: [member_id]
                },
                success: function(response) {
                    Cache.workspace_member.remove(Cache.workspace_member.get(member_id));
                    Cache.project_access.searchAndRemove({user_id: user_id});

                    Cache.app.trackEvent('Member Deleted');

                    UI.success('Workspace member removed successfully');
                }
            });
        }, this, 'Yes, remove', undefined, 'secondary');
    },

    reactivateMember: function(member_ids) {
        if (Cache.account.getUserLimit() < (Cache.workspace_member.where({is_disabled: false}).length + member_ids.length)) {
            Modals.unlockFeature('You\'ve reached your member limit. Please add more members to your account plan.', 'Add Members', 'Member Limit Reached', () => {
                Modals.choosePlan(undefined, undefined, true);
            });

            return;
        }

        Modal.confirm('Are you sure you want to reactivate the member' + (member_ids.length === 1 ? '' : 's') + '?', () => {
            Cache.app.request({
                action: 'workspace_member/reactivate',
                data: {
                    member_ids: member_ids
                },
                success: () => {
                    member_ids.forEach((member_id) => {
                        Cache.workspace_member.get(member_id).set({
                            is_disabled: false
                        });
                    });

                    UI.success('Member' + (member_ids.length === 1 ? '' : 's') + ' reactivated');
                }
            });
        }, this, 'Yes, reactivate');
    },

    deactivateMember: function(member_ids) {
        Modal.confirm('Are you sure you want to deactivate the member' + (member_ids.length === 1 ? '' : 's') + '?', () => {
            Cache.app.request({
                action: 'workspace_member/deactivate',
                data: {
                    member_ids: member_ids
                },
                success: () => {
                    member_ids.forEach((member_id) => {
                        Cache.workspace_member.get(member_id).set({
                            is_disabled: true
                        });
                    });

                    Cache.app.trackEvent('Member Deactivated');

                    UI.success('Member' + (member_ids.length === 1 ? '' : 's') + ' deactivated');
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    inviteUser: function() {
        if (Cache.account.get('is_expired')) {
            Modals.expiredAccount();
            return;
        }

        var user_count = Cache.workspace_member.where({is_disabled: false}).length;
        var invitation_count = Cache.user_invitation.length;

        if (user_count + invitation_count >= Cache.account.getUserMax()) {
            Modals.unlockFeature('You\'ve reached your seat limit. Upgrade your plan to invite more team members.', 'Upgrade Plan');
            return;
        }

        if (Cache.account.isSSO()) {
            Modal.open({
                title: 'Invite Members',
                content: '<p>Your account is configured for SSO. To add new members to your account, please contact your IT team.</p>',
                button: {
                    OK: function() {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var invite_user_view = new View_Invite_User;

        var modal = Modal_Fullscreen.open({
            title: 'Invite Members',
            content: invite_user_view
        });

        invite_user_view.on('submit_success', function() {
            invite_user_view.remove();
            Modal_Fullscreen.close();
        });

        modal.find('input[name="emails"]').focus();
    },

    viewProjectInfo: function(project_id, default_tab) {
        var model = Cache.project.get(project_id);
        var view = new View_Project_Members({
            model: model,
            tab: default_tab // about, members
        });

        Sidebar.open({
            html_title: this.getProjectTitle(model),
            width: 480,
            content: view,
            onclose: () => {
                view.remove();
            }
        });
    },

    manageProjectMembers: function(project_id) {
        var model = Cache.project.get(project_id);
        var view = new View_Project_Members_Manage({model: model});

        Modal_Bg.open({
            title_html: this.getProjectTitle(model),
            content: view,
            onclose: () => {
                view.remove();
            }
        });
    },

    resendUserInvitation: function(id) {
        var model = Cache.user_invitation.get(id);

        Modal.confirm('Are you sure you want to resend the invitation to <b>' + model.escape('email') + '</b>?', function() {
            Cache.app.request({
                action: 'user_invitation/resend',
                data: {
                    id: id
                },
                success: function(response) {
                    model.set('time', parseInt((new Date()).getTime() / 1000, 10) - 5);
                    UI.success('Invitation sent to ' + model.get('email'));
                }
            });
        }, this, 'Yes, send');
    },

    deleteUserInvitation: function(id) {
        Modal.confirm('Are you sure you want to delete the invitation?', function() {
            Cache.app.request({
                action: 'user_invitation/delete',
                data: {
                    id: id
                },
                success: function(response) {
                    Cache.app.trackEvent('Member Deleted');

                    Cache.user_invitation.remove(id);
                    UI.success('Invitation deleted');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    editProfile: function(on_close) {
        if (Cache.real_user_id) {
            Modals.editUser(Cache.real_user_id, on_close);
        } else if (Cache.portal_user) {
            Modals.editProfileUser(on_close);
        }
    },

    editProfileUser: function(on_close) {
        var view = new View_Portal_User_Edit({
            on_success: function() {
                Sidebar.close();
            }
        });

        var sidebar = Sidebar.open({
            title: 'My Profile',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();

                if (on_close) {
                    on_close();
                }
            },
            onopen: function() {
                sidebar.find('form input[name="display_name"]').focus();
            }
        });
    },

    editUser: function(user_id, on_close) {
        var user_edit_view = new View_User_Edit({
            user_id: user_id,
            on_success: function() {
                Sidebar.close();
            }
        });

        var sidebar = Sidebar.open({
            title: user_id === Cache.real_user_id ? 'My Profile' : 'Edit User',
            content: user_edit_view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                user_edit_view.remove();

                if (on_close) {
                    on_close();
                }
            },
            onopen: function() {
                sidebar.find('form input[name="email"]').focus();
            }
        });
    },

    editPortalNotifications: function() {
        var notification_view = new View_Portal_Notification();

        Sidebar.open({
            title: 'Set Notifications',
            content: notification_view,
            onclose: function() {
                notification_view.remove();
            }
        });
    },

    editInboxNotification: function() {
        this.editUserNotification(Cache.real_user_id, 'inbox');
    },

    editUserNotification: function(user_id, tab = 'inbox', show_inbox = true) {
        var notification_view = new View_User_Notification({
            user_id: user_id,
            tab: tab,
            show_inbox: show_inbox
        });

        Sidebar.open({
            title: 'Notification Settings',
            content: notification_view,
            onclose: function() {
                notification_view.remove();
            }
        });
    },

    addPortalStatus: function(on_success) {
        var form =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Name</div>' +
                '<input type="text" class="solid medium" name="status_name" maxlength="100" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Color</div>' +
                '<input type="text" class="solid medium colour" name="colour" placeholder="e.g. #222D39" spellcheck="false" required>' +
            '</div>' +
            '<div class="text-align-right">' +
                '<button class="primary">Add</button>' +
            '</div>' +
        '</form>';

        var modal = Modal.open({
            width: 500,
            title: 'New Status',
            content: form
        });

        modal.find('form').on('submit', function() {
            Cache.app.request({
                action: 'portal_status/add',
                data: Form.getData($(this)),
                success: function(response) {
                    Cache.portal_status.add(response);
                    UI.success('Status added');

                    Modal.close();

                    if (on_success) {
                        on_success(Cache.portal_status.get(response.id));
                    }
                }
            });
        });

        Form.setData(modal.find('form'), {
            colour: '#000000'
        });

        modal.find('input:first').focus();
    },

    deletePortalStatus: function(status_id, on_success) {
        if (Cache.portal_status <= 1) {
            Modal.open({
                title: 'Can\'t Delete',
                content: 'You must keep at least one status for your ideas portal.',
                button: {
                    OK: function() {
                        Modal.close();
                    }
                }
            });
            return;
        }

        if (Cache.workflow.findWhere({portal_status_id: status_id})) {
            Modal.open({
                title: 'Can\'t Delete',
                content: 'The <b>"' + Cache.portal_status.get(status_id).escape('status_name') + '"</b> status is not empty. Drag and drop <i class="far fa-arrows"></i> the internal status labels elsewhere and then try again.',
                button: {
                    OK: function() {
                        Modal.close();
                    }
                }
            });
            return;
        }

        Modal.confirm('Are you sure you want to delete the status from your ideas portal?', function() {
            Cache.app.request({
                action: 'portal_status/delete',
                data: {
                    id: status_id
                },
                success: function(response) {
                    Cache.portal_status.remove(status_id);
                    UI.success('Status deleted');

                    Modal.close();

                    if (on_success) {
                        on_success();
                    }
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    editPortalStatusName: function(status_id, on_success) {
        var content =
        '<form>' +
            '<span class="info">Name</span>' +
            '<input type="text" name="status_name" maxlength="50" autofocus required>' +
            '<button type="submit" class="hidden"></button>' +
        '</form>';

        var modal = Modal.open({
            title: 'Edit Name',
            content: content,
            button: {
                Save: function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        var form = modal.find('form');

        Form.setData(form, {
            status_name: Cache.portal_status.get(status_id).get('status_name')
        });

        form.find('input[name="status_name"]').focus();

        form.on('submit', function(e) {
            e.preventDefault();

            var new_name = Form.getData(form, 'status_name');

            Cache.app.request({
                action: 'portal_status/update',
                data: {
                    id          : status_id,
                    status_name : new_name
                },
                success: function(response) {
                    Cache.portal_status.get(status_id).set(response);
                    UI.success('Status name updated');

                    Modal.close();

                    if (on_success) {
                        on_success(new_name);
                    }
                }
            });
        }.bind(this));
    },

    feedbackCsvImport: function(portal_model) {
        var feedback_csv_import = new View_Feedback_Csv_Import({model: portal_model});

        feedback_csv_import.on('submit_success', function() {
            feedback_csv_import.remove();
            Modal_Fullscreen.close();
        });

        Modal_Fullscreen.open({
            title: 'Import ideas from CSV',
            nopadding: true,
            content: feedback_csv_import
        });
    },

    newFeedback: function(options, on_success) {
        var view = new View_New_Feedback(options);

        Sidebar.open({
            title: 'Add Feedback',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onopen: function() {
                view.focus();
            },
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
            UI.success('Feedback created');

            if (on_success) {
                on_success();
            }
        });
    },

    editFeedbackPriority: function(feedback_ids, success) {
        if (feedback_ids.length >= 100) {
            Modal.open({
                title: 'Change Priority',
                content: 'Please note that you can only change status for 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var message =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Select a priority</div>' +
                '<div class="button-dropdown button-dropdown-full" data-update="true">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-priority="urgent"><span class="priority-status-urgent"></span>Urgent</li>' +
                            '<li data-priority="high"><span class="priority-status-high"></span>High</li>' +
                            '<li data-priority="neutral"><span class="priority-status-neutral"></span>Neutral</li>' +
                            '<li data-priority="low"><span class="priority-status-low"></span>Low</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>'+
            '</div>' +
        '</form>' ;

        var dialog = Modal.confirm(message, function() {
            var priority = dialog.find('.dropdown-select li.selected').data('priority');

            Cache.app.request({
                action: 'feedback/setPriority',
                data: {
                    ids: feedback_ids,
                    priority: priority
                },
                success: () => {
                    UI.success('Priority updated');
                    Modal.close();

                    _.each(feedback_ids, (feedback_id) => {
                            var selected_feedback_model = Cache.feedback.get(feedback_id);

                            selected_feedback_model.set({
                                priority : priority,
                                last_update_time: Math.floor((new Date()).getTime() / 1000)
                            });
                        });

                    if (success) {
                        success();
                    }
                }
            });
        }, this, 'Change', 'Change Priority of ' + feedback_ids.length + ' feedback');

        dialog.find('.modal-button button').prop('disabled', true);
        dialog.find('.dropdown > li').on('click', function(e) {
            dialog.find('.modal-button button').prop('disabled', false);
        });
    },


    editFeedbackWorkflow: function(feedback_ids, success) {
        if (feedback_ids.length >= 100) {
            Modal.open({
                title: 'Change Status',
                content: 'Please note that you can only change status for 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var workflows = '';

        // check if any feedback_ids are enabled for auto reply and not all the feedback_ids are resolved
        var should_show_resolve_send = false;

        for (const feedback_id of feedback_ids) {
            const feedback_model = Cache.feedback.get(feedback_id);

            const feedback_autoreply = Cache.feedback_autoreply.findWhere({project_id: feedback_model.get('project_id')});
            const is_autoreply_enabled = feedback_autoreply?.isEnabled(feedback_model.get('feedback_type'));

            const workflow = Cache.workflow.get(feedback_model.get('workflow'));

            if (is_autoreply_enabled && !workflow.isResolved()) {
                should_show_resolve_send = true;
                break; // Exit the loop after the first iteration
            }
        }

        Cache.workflow.where({project_id: Cache.default_project_id}).forEach(function(workflow_model, index) {
            var last = index === Cache.workflow.length - 1;

            if (last) {
                workflows += '<li class="separator"></li>';
            }

            workflows +=
            '<li data-workflow="' + workflow_model.id + '">' +
                '<span class="workflow-option-colour" style="background-color:' + workflow_model.get('colour') + ';"></span>' +
                workflow_model.escape('name') +
            '</li>';

            if (last && should_show_resolve_send) {
                workflows += '<li class="separator"></li>';

                workflows += '<li class="notrim" data-workflow="' + workflow_model.id + '" data-type="resolve-reply">' +
                    '<span class="workflow-option-colour" style="background-color:' + workflow_model.get('colour') + ';"></span>' +
                    workflow_model.escape('name') + ' & Auto-reply'+
                '</li>';
            }
        });

        var message =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Select a status</div>' +
                '<div class="button-dropdown button-dropdown-full" data-update="true">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            workflows +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</form>';

        var dialog = Modal.confirm(message, function() {
            var workflow_id = parseInt(dialog.find('.dropdown-select li.selected').data('workflow'), 10);
            var type = dialog.find('.dropdown-select li.selected').data('type');

            const is_resolved = Cache.workflow.get(workflow_id).isResolved();

            Cache.app.request({
                action: 'feedback/setWorkflow',
                data: {
                    ids: feedback_ids,
                    workflow: workflow_id,
                    send_autoreply: is_resolved && type === 'resolve-reply'
                },
                success: (result) => {
                    if (!result) {
                        return;
                    }

                    UI.success('Status updated');
                    Modal.close();

                    _.each(feedback_ids, (feedback_id) => {
                        var selected_feedback_model = Cache.feedback.get(feedback_id);

                        selected_feedback_model.set({
                            workflow: workflow_id,
                            last_update_time: Math.floor((new Date()).getTime() / 1000)
                        });
                    });

                    if (success) {
                        success(result.autoreply_comments || []);
                    }
                }
            });
        }, this, 'Change', 'Change Status of ' + feedback_ids.length + ' feedback');

        dialog.find('.modal-button button').prop('disabled', true);
        dialog.find('.dropdown > li').on('click', function(e) {
            dialog.find('.modal-button button').prop('disabled', false);
        });
    },

    editFeedbackAssignee: function(feedback_ids, success) {
        if (feedback_ids.length >= 100) {
            Modal.open({
                title: 'Change Assignee',
                content: 'Please note that you can only change assignee for 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var users = '';

        var project_user_models = Cache.app.getUsersByProject(Cache.default_project_id, [Constants.ADMIN, Constants.ASSIGNEE]);
        _.each(project_user_models, function(user) {
            users += '<li data-id="' + user.id + '">' +
                        '<div class="flex-start">' +
                            '<img class="user-24 user-solid" src="' + user.getAvatar(24) + '">' +
                            '<span class="margin-left-4">' + user.escape('name') + '</span>' +
                        '</div>' +
                    '</li>';
        });

        users += '<li class="separator"></li>';
        users += '<li data-id="0">' +
                    '<div class="flex-start">' +
                        '<div class="user-24">?</div>' +
                        '<div class="margin-left-4">Unassigned</div>' +
                    '</div>' +
                '</li>';

        var message =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Select an assignee</div>' +
                '<div class="button-dropdown button-dropdown-full" data-update="true">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                    '<div>' +
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search by user name">' +
                        '</div>' +
                        '<ul class="dropdown dropdown-select">' + users + '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</form>';

        var dialog = Modal.confirm(message, function() {
            var user_id = parseInt(dialog.find('.dropdown-select li.selected').data('id'), 10);

            Cache.app.request({
                action: 'feedback/setUser',
                data: {
                    ids: feedback_ids,
                    user_id: user_id,
                },
                success: () => {
                    UI.success('Assignee updated');
                    Modal.close();

                    _.each(feedback_ids, (feedback_id) => {
                        var selected_feedback_model = Cache.feedback.get(feedback_id);

                        selected_feedback_model.set({
                            user_id  : user_id,
                            last_update_time: Math.floor((new Date()).getTime() / 1000)
                        });
                    });

                    if (success) {
                        success();
                    }
                }
            });
        }, this, 'Change', 'Change Assignee of ' + feedback_ids.length + ' feedback');

        dialog.find('.modal-button button').prop('disabled', true);
        dialog.find('.dropdown > li').on('click', function(e) {
            dialog.find('.modal-button button').prop('disabled', false);
        });
    },

    editFeedbackCategory: function(feedback_ids, success) {
        if (feedback_ids.length >= 100) {
            Modal.open({
                title: 'Change Category',
                content: 'Please note that you can only change category for 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var categories = '';
        var selected_categories = [];

        Cache.feedback_category.where({project_id: Cache.default_project_id}).forEach((option) => {
            categories += '<li class="dropdown-action" data-category="' + option.escape('name') + '">' +
                                '<span>' + option.escape('name') + '</span>' +
                          '</li>';
        });

        var message =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Select a category</div>' +
                '<div class="button-dropdown button-dropdown-full">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                    '<div>' +
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search">' +
                        '</div>' +
                        '<ul class="dropdown dropdown-select">' + categories + '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="row">' +
                '<input type="checkbox" id="feedback_category_remove_all"><label for="feedback_category_remove_all">Remove all the existing categories</label>' +
            '</div>' +
        '</form>';

        var dialog = Modal.confirm(message, function() {
            var category_name = selected_categories.join(',');
            var remove_all = dialog.find('input[type="checkbox"]').prop('checked');

            Cache.app.request({
                action: 'feedback/addCategory',
                data: {
                    feedback_ids: feedback_ids,
                    category_name : category_name,
                    remove_all: remove_all,
                },
                success: () => {
                    UI.success('Category updated');
                    Modal.close();

                    _.each(feedback_ids, (feedback_id) => {
                        var selected_feedback_model = Cache.feedback.get(feedback_id);

                        if (remove_all) {
                            selected_feedback_model.set({
                                category: category_name,
                            });
                        } else {
                            var categories = selected_feedback_model.get('category') ? selected_feedback_model.get('category').split(',') : [];

                            _.each(selected_categories, (item) => {
                                var index = categories.indexOf(item);

                                if (index === -1) {
                                    categories.push(item);
                                }
                            });

                            selected_feedback_model.set({
                                category: categories.join(','),
                            });
                        }
                    });

                    if (success) {
                        success();
                    }
                }
            });
        }, this, 'Change', 'Change Category of ' + feedback_ids.length + ' feedback');

        function updateChangeBtnStatus() {
            var remove_all = dialog.find('input[type="checkbox"]').prop('checked');
            var disabled = selected_categories.length === 0 && !remove_all;

            dialog.find('.modal-button button').prop('disabled', disabled);
        }

        dialog.find('.modal-button button').prop('disabled', true);
        dialog.find('.dropdown > li').on('click', function(e) {
            var category = $(this).data('category');
            var i = selected_categories.indexOf(category);

            if (i === -1) {
                selected_categories.push(category);
                $(this).addClass('selected');
            } else {
                selected_categories.splice(i, 1);
                $(this).removeClass('selected');
            }

            var selected_category_text = selected_categories.join(', ');

            dialog.find('button.dropdown-select').html(selected_category_text);

            updateChangeBtnStatus();
        });

        dialog.find('input[type="checkbox"]').on('change', function() {
            updateChangeBtnStatus();
        });
    },

    editFeedbackIntegration: function(feedback_ids, success) {
        if (feedback_ids.length >= 100) {
            Modal.open({
                title: 'Change Integration',
                content: 'Please note that you can only change integration for 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var integrations_list = [
            {
                integration: Cache.integration_jira.findWhere({project_id: Cache.default_project_id}),
                name: 'Jira',
                icon: '/image/jira_small.png'
            },
            {
                integration: Cache.integration_teamwork.findWhere({project_id: Cache.default_project_id}),
                name: 'Teamwork',
                icon: '/image/teamwork_small.png'
            },
            {
                integration: Cache.integration_trello.findWhere({project_id: Cache.default_project_id}),
                name: 'Trello',
                icon: '/image/trello_small.png'
            },
            {
                integration: Cache.integration_basecamp.findWhere({project_id: Cache.default_project_id}),
                name: 'Basecamp',
                icon: '/image/basecamp_small.png'
            },
            {
                integration: Cache.integration_github.findWhere({project_id: Cache.default_project_id}),
                name: 'GitHub',
                icon: '/image/github_small.png'
            },
            {
                integration: Cache.integration_gitlab.findWhere({project_id: Cache.default_project_id}),
                name: 'GitLab',
                icon: '/image/gitlab_small.png'
            },
            {
                integration: Cache.integration_linear.findWhere({project_id: Cache.default_project_id}),
                name: 'Linear',
                icon: '/image/linear_small.png'
            },
            {
                integration: Cache.integration_asana.findWhere({project_id: Cache.default_project_id}),
                name: 'Asana',
                icon: '/image/asana_small.png'
            },
            {
                integration: Cache.integration_clickup.findWhere({project_id: Cache.default_project_id}),
                name: 'ClickUp',
                icon: '/image/clickup_small.png'
            },
            {
                integration: Cache.integration_wrike.findWhere({project_id: Cache.default_project_id}),
                name: 'Wrike',
                icon: '/image/wrike_small.png'
            },
            {
                integration: Cache.integration_azure_devops.findWhere({project_id: Cache.default_project_id}),
                name: 'Azure DevOps',
                icon: '/image/azure_devops_small.png'
            },
            {
                integration: Cache.integration_monday.findWhere({project_id: Cache.default_project_id}),
                name: 'Monday',
                icon: '/image/monday_small.png'
            },
            {
                integration: Cache.integration_notion.findWhere({project_id: Cache.default_project_id}),
                name: 'Notion',
                icon: '/image/notion_small.png'
            },
            {
                integration: Cache.integration_zendesk.findWhere({project_id: Cache.default_project_id}),
                name: 'Zendesk',
                icon: '/image/zendesk_small.png'
            },
        ];

        var selected_feedbacks = [];

        _.each(feedback_ids, (feedback_id) => {
            var selected_feedback_model = Cache.feedback.get(feedback_id);

            selected_feedbacks.push(selected_feedback_model);
        });

        var integrations    = '';
        var connected_count = 0;
        var connected_name  = '';

        _.each(integrations_list, (option) => {
            if (option.integration && option.integration.isConnected()) {
                connected_count += 1;
                connected_name = option.name;
                integrations += '<li data-integration="' + option.name + '">' +
                                    '<img class="icon-img" src="' + option.icon + '">' +
                                    option.name +
                                '</li>';
            }
        });

        if (connected_count === 0) {
            return;
        }

        if (connected_count === 1) {
            var integration_type = connected_name.replace(' ', '_').toLowerCase();
            var url_key          = integration_type + '_url';

            var is_all_send  = true;

            _.each(selected_feedbacks, (model) => {
                if (!model.get(url_key)) {
                    is_all_send = false;
                }
            });

            if (is_all_send) {
                Modal.confirm('The selected feedback has been send to ' + connected_name + ' already.', function() {
                    if (success) {
                        success(false);
                    }
                });
            } else {
                Modal.confirm('Are you sure you want to send the selected feedback to ' + connected_name + '?', function() {
                    Cache.app.request({
                        action: 'integration/sendBulkFeedbackToIntegration',
                        data: {
                            feedback_ids    : feedback_ids,
                            integration_type: integration_type,
                        },
                        success: () => {
                            _.each(selected_feedbacks, (model) => {
                                model.set({
                                    [url_key] : model.get(url_key) ? model.get(url_key) : 'processing',
                                });
                            });

                            UI.success('The selected feedback is sent to ' + connected_name);

                            if (success) {
                                success(true);
                            }
                        },
                    });
                }, this, 'Send', 'Send ' + feedback_ids.length + ' feedback to ' + connected_name);
            }

            return;
        }

        var message =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Select a integration</div>' +
                '<div class="button-dropdown button-dropdown-full">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' + integrations + '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</form>';

        var dialog = Modal.confirm(message, function() {
            var integration_name = dialog.find('.dropdown-select li.selected').data('integration');
            var integration_type = integration_name.replace(' ', '_').toLowerCase();
            var url_key          = integration_type + '_url';

            var is_all_send  = true;

            _.each(selected_feedbacks, (model) => {
                if (!model.get(url_key)) {
                    is_all_send = false;
                }
            });

            if (is_all_send) {
                UI.success('The selected feedback has been send to ' + integration_name + ' already.');

                if (success) {
                    success(false);
                }
                return;
            }

            Cache.app.request({
                action: 'integration/sendBulkFeedbackToIntegration',
                data: {
                    feedback_ids    : feedback_ids,
                    integration_type: integration_type,
                },
                success: () => {
                    _.each(selected_feedbacks, (model) => {
                        model.set({
                            [url_key] : model.get(url_key) ? model.get(url_key) : 'processing',
                        });
                    });

                    UI.success('The selected feedback is sent to ' + integration_name);

                    if (success) {
                        success(true);
                    }
                },
            });
        }, this, 'Send', 'Send ' + feedback_ids.length + ' feedback to integration');

        dialog.find('.modal-button button').prop('disabled', true);
        dialog.find('.dropdown > li').on('click', function(e) {
            dialog.find('button.dropdown-select').html($(this).html());
            dialog.find('.dropdown > li').removeClass('selected');
            $(this).addClass('selected');
            dialog.find('.modal-button button').prop('disabled', false);
        });
    },

    editFeedbackDueDate: function(feedback_ids, success) {
        var view = new View_Feedback_Due_Date({ feedback_ids: feedback_ids });

        Modal.open({
            title: 'Set due date',
            content: view
        });

        view.on('Submit:DueDate', function(due_date) {
            var selected_feedback = Cache.feedback.where({selected: true});

            var ids = [];
            _.each(selected_feedback, (model) => {
                ids.push(model.id);
            });

            // due_date is either 'tomorrow', 'next_monday', or a date string
            // do validation checks here
            if (!due_date && due_date !== 'tomorrow' && due_date !== 'next_monday' && due_date !== 'clear' && isNaN((new Date(due_date)).getTime())) {
                return;
            }

            changeFeedbacksDueDate(ids, due_date, (response) => {
                if (response && response.length > 0) {
                    // update the due date of the selected feedback
                    _.each(selected_feedback, (model) => {
                        var updated_feedback = _.findWhere(response, {feedback_id: model.id});

                        if (updated_feedback) {
                            model.set('due_date', updated_feedback.due_date);
                        }
                    });

                    UI.success('Due date updated');
                }
            });

            view.remove();
            Modal.close();
        });
    },

    mergeFeedback: function(primary_feedback_id, initial_merge_feedback_ids, options, success) {
        var merge_feedback_ids = initial_merge_feedback_ids || [];

        if (merge_feedback_ids.length >= 100) {
            Modal.open({
                title: 'Merge Feedback',
                content: 'Please note that you can only merge up to 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var primary_feedback = Cache.feedback.get(primary_feedback_id);
        var project_id = primary_feedback.get('project_id');
        var default_search_feedbacks = Cache.feedback
            .where({ primary_feedback_id: 0 })
            .filter((model) => model.id !== primary_feedback_id);

        var view = new View_Feedback_Merge({
            primary_feedback_id: primary_feedback_id,
            initial_merge_feedback_ids: initial_merge_feedback_ids,
            initial_search_feedbacks:
                options && options.initial_search_feedbacks
                    ? options.initial_search_feedbacks
                    : default_search_feedbacks,
            project_id: project_id,
        });

        var dialog = Modal.open({
            title: 'Merge Feedback',
            content : view,
            button: Cache.account.hasFeature('merge_feedback') ? {
                'Merge': () => {
                    if (merge_feedback_ids.length >= 100) {
                        Modal.open({
                            title: 'Merge Feedback',
                            content: 'Please note that you can only merge up to 100 feedback at a time.',
                            button: {
                                OK: () => {
                                    Modal.close();
                                }
                            }
                        });
                        return;
                    }

                    Cache.app.request({
                        action: 'feedback/mergeFeedback',
                        data: {
                            primary_feedback_id: primary_feedback_id,
                            merge_feedback_ids: merge_feedback_ids,
                            project_id: project_id
                        },
                        success: (response) => {
                            if (!response) {
                                return;
                            }

                            UI.success('Feedback merged');
                            Modal.close();

                            Cache.feedback.set(response.modified, {
                                add: false,
                                remove: false,
                            });

                            if (success) {
                                success();
                            }
                        }
                    });
                },
            } : undefined
        });

        view.on('merged-feedback:change', function(values) {
            merge_feedback_ids = values;

            dialog.find('.modal-button button').prop('disabled', !merge_feedback_ids.length);
        });


        dialog.find('.modal-button button').prop('disabled', !merge_feedback_ids.length);
    },

    unmergeFeedback: function(feedback_id, complete) {
        Modal.confirm('Are you sure you want to unmerge this feedback?', function() {
            Cache.app.request({
                action: 'feedback/unmergeFeedback',
                data: {
                    id: feedback_id,
                },
                success: function(response) {
                    Cache.feedback.set(response.modified, {
                        add: false,
                        remove: false
                    });

                    UI.success('Feedback unmerged');

                    if (complete) {
                        complete();
                    }
                }
            });
        }, this, 'Yes, unmerge')
    },

    moveFeedback: function(feedback_ids, success) {
        if (feedback_ids.length >= 100) {
            Modal.open({
                title: 'Move Feedback',
                content: 'Please note that you can only move 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        // if only one project or only one active project
        if (Cache.project.where({is_archived: false}).length === 1) {
            Modal.open({
                title: 'Move Feedback',
                content: 'You need to have 2 or more projects to move.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var view = new View_Feedback_Move({ feedback_ids: feedback_ids });

        Modal.open({
            title: 'Move ' + feedback_ids.length + ' feedback',
            content: view,
            onclose: function() {
                view.remove();
            },
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    // TODO: APP-787: remove this if we decide not to use modal way.
    filterSurveyResponseAnswer: function(condition, complete, clear) {
        var view = new View_Survey_Answer(condition);

        Modal.open({
            title: 'Survey Question Filter',
            content: view,
            onclose: function() {
                view.remove();
            },
            button: {
                'Apply': function() {
                    var condition = view.getConditions();
                    complete(condition);
                    Modal.close();
                }
            },
            text_link: {
                'Clear': function(e) {
                    clear();
                    Modal.close();
                }
            }
        });
    },

    deleteSurveyResponse: function(survey_id, survey_response_ids, before, complete, success) {
        // survey_response_ids can be either a string 'all' or an array of ids
        if (survey_response_ids.length >= 100) {
            Modal.open({
                title: 'Delete Survey Response',
                content: 'Please note that you can only delete up to 100 survey response at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        Modal.open({
            title: 'Confirm',
            content: survey_response_ids.length > 1 ?
                'Are you sure you want to delete the selected responses?' :
                'Are you sure you want to delete the response?',
            button_class: 'secondary',
            button: {
                'Yes, delete': (e, modal) => {
                    if (before) {
                        before();
                    }

                    Cache.app.request({
                        action: 'survey_response/delete',
                        data: {
                            survey_id: survey_id,
                            ids: survey_response_ids
                        },
                        success: () => {
                            UI.success('Survey responses deleted');
                            Cache.survey_response.remove(survey_response_ids);
                            Modal.close();

                            if (success) {
                                success();
                            }
                        },
                        complete: () => {
                            if (complete) {
                                complete();
                            }
                        }
                    });
                }
            }
        })
    },

    cancelSurveySchedule: function(survey_id, success, complete) {
        Modal.open({
            title: 'Cancel schedule',
            content: 'Are you sure you want to cancel this existing schedule?',
            button_class: 'secondary',
            button: {
                'Cancel Schedule': function() {
                    Cache.app.request({
                        action: 'survey/schedule',
                        data: {
                            survey_id: survey_id
                        },
                        success: (response) => {
                            Cache.survey.get(survey_id).set(response);

                            UI.success('Survey schedule cancelled');

                            if (success) {
                                success();
                            }

                            Modal.close();

                            Cache.statistics.syncProjectCount(Cache.default_project_id);
                        },
                        complete: () => {
                            if (complete) {
                                complete();
                            }
                        }
                    });
                }
            },
            text_link: {
                'Keep Schedule': function(e) {
                    e.preventDefault();
                    Modal.close();
                }
            }
        });
    },

    toggleWidget: function(widget_model) {
        if (!Cache.app.isAdmin()) {
            return;
        }

        var doToggle = () => {
            var is_active = !widget_model.get('is_active');

            widget_model.set('is_active', is_active);

            Cache.app.request({
                action: 'widget/setLive',
                data: {
                    widget_id : widget_model.id,
                    is_active : is_active
                },
                success: () => {
                    if (is_active) {
                        UI.success('Widget is live');
                    } else {
                        UI.success('Widget is paused');
                    }
                }
            });

            Cache.app.trackProjectOnboarding('activate_widget', 1, widget_model.get('project_id'));
        };

        if (widget_model.get('is_active')) {
            Modal.confirm('Are you sure you want to pause the feedback widget?', doToggle, this, 'Yes, pause', undefined, 'secondary');
        } else {
            Modal.confirm('Are you sure you want to set the feedback widget live?', doToggle, this, 'Yes, set live');
        }
    },

    activateSurvey: function(survey_model) {
        var survey_clone = survey_model.clone();
        var view_survey_activate = new View_Survey_Activate({ model: survey_clone });

        Modal.open({
            title: 'Activate survey',
            content: view_survey_activate,
            button_class: 'secondary',
            button: {
                Confirm: function() {
                    Cache.app.request({
                        action: 'survey/schedule',
                        data: {
                            survey_id: survey_clone.id,
                            ...view_survey_activate.getData()
                        },
                        success: function(response) {
                            survey_model.set(response);
                            UI.success('Survey activated');

                            Modal.close();

                            Cache.statistics.syncProjectCount(Cache.default_project_id);
                        }
                    });

                    Cache.app.trackProjectOnboarding('activate_survey', 1, survey_model.get('project_id'));
                }
            },
            text_link: {
                'Cancel': function(e) {
                    e.preventDefault();
                    Modal.close();
                }
            },
            onclose: function() {
                view_survey_activate.remove();
            }
        })
    },

    deactivateSurvey: function(survey, success) {
        var view_survey_deactivate = new View_Survey_Deactivate({ model: survey });

        Modal.open({
            title: 'Deactivate survey form',
            content: view_survey_deactivate,
            button_class: 'secondary',
            button: {
                Confirm: function() {
                    Cache.app.request({
                        action: 'survey/schedule',
                        data: {
                            survey_id: survey.id,
                            ...view_survey_deactivate.getData()
                        },
                        success: (response) => {
                            Cache.survey.get(survey.id).set(response);

                            UI.success('Survey deactivated');

                            if (success) {
                                success(response);
                            }

                            Modal.close();

                            Cache.statistics.syncProjectCount(Cache.default_project_id);
                        }
                    });
                }
            },
            text_link: {
                'Cancel': function(e) {
                    e.preventDefault();
                    Modal.close();
                }
            },
            onclose: function() {
                view_survey_deactivate.remove();
            }
        })
    },

    shareSurvey: function(survey) {
        var shrae_url = survey.getShareUrl();

        var doCopy = function(modal) {
            var range = document.createRange();
            range.selectNode(modal.find('.url-share > div:first').get(0));
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);

            Util.copyText(shrae_url, () => {
                UI.success('Share URL copied');
            });
        };

        var modal = Modal.open({
            title: 'Share survey form',
            content: '<div class="box-small-large flex-between url-share cursor-pointer"><div class="font-weight-medium text-regular">' + shrae_url + '</div><div class="text-icon"><i class="fa-solid fa-copy"></i></div></div>',
            button: {
                'Copy URL': () => {
                    doCopy(modal);
                }
            }
        });

        modal.find('.url-share').on('click', function() {
            doCopy(modal);
        });
    },

    deleteFeedback: function(feedback_ids, before, complete, success) {
        if (feedback_ids.length >= 100) {
            Modal.open({
                title: 'Delete Feedback',
                content: 'Please note that you can only delete up to 100 feedback at a time.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var feedback_model = Cache.feedback.get(feedback_ids[0]);

        if (!feedback_model) {
            return;
        }

        var feedback_type = feedback_model.isPdf() || feedback_model.isDesign() || feedback_model.isVideoUpload() ? 'design' : 'feedback';
        var include_primary_feedback = feedback_ids.some((id) => {
            const model = Cache.feedback.get(id);
            return model ? model.isPrimaryFeedback() : false;
        });

        var id = _.uniqueId();

        var modal = Modal.open({
            title: 'Confirm',
            content: feedback_ids.length > 1 ?
                'Are you sure you want to delete the selected ' + feedback_type + '?' :
                'Are you sure you want to delete the ' + feedback_type + '?',
            button_html: include_primary_feedback && feedback_type === 'feedback' ?
                '<div class="modal-checkbox">' +
                    '<input type="checkbox" class="include-merged-feedback" id="' + id + '"><label for="' + id + '">Also delete all merged feedback</label>' +
                '</div>': '',
            button_class: 'secondary',
            button: {
                'Yes, delete': (e, modal) => {
                    if (before) {
                        before();
                    }

                    var include_merged_feedback = modal.find('.include-merged-feedback').prop('checked');

                    modal.find('.modal-button button').prop('disabled', true).addClass('loading');

                    Cache.app.request({
                        action: 'feedback/delete',
                        data: {
                            ids: feedback_ids,
                            include_merged_feedback: include_merged_feedback
                        },
                        success: (response) => {
                            Modal.close();
                            UI.success(Util.cap(feedback_type) + ' deleted');

                            Cache.feedback.remove(response.deleted);
                            Cache.feedback.set(response.modified, {
                                add: false,
                                remove: false,
                            });

                            // TODO: delete other related models
                            // feedback comment, feedback screenshots

                            if (success) {
                                success();
                            }
                        },
                        complete: () => {
                            modal.find('.modal-button button').prop('disabled', false).removeClass('loading');

                            if (complete) {
                                complete();
                            }
                        }
                    });
                }
            }
        });
    },

    renameFeedback: function(feedback_id) {
        var form =  '<form class="form-fluid">' +
                        '<div>' +
                            '<button type="submit" class="hidden"></button>' +
                            '<div class="field-label">Title</div>' +
                            '<input type="text" class="solid medium" name="title" maxlength="80">' +
                        '</div>' +
                    '</form>';

        var modal = Modal.open({
            title: 'Edit Feedback Title',
            content: form,
            button: {
                Save: function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        var feedback_model = Cache.feedback.get(feedback_id);

        var form = modal.find('form');
        Form.setData(form, {
            title: feedback_model.get('title')
        });

        form.find('input:first').focus();

        form.on('submit', function(e) {
            e.preventDefault();

            var data = Form.getData(form);

            modal.find('button.primary').addClass('loading').prop('disabled', true);

            feedback_model.set({
                title: data.title,
                last_update_time: Math.floor((new Date()).getTime() / 1000)
            });

            Cache.app.request({
                action: 'feedback/updateTitle',
                data: {
                    id: feedback_id,
                    title: data.title
                },
                success: function() {
                    UI.success('Feedback title updated');
                    Modal.close();
                },
                complete: function() {
                    modal.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    renameDesign: function(feedback_id) {
        var form =  '<form class="form-fluid">' +
                        '<button type="submit" class="hidden"></button>' +
                        '<div>' +
                            '<div class="field-label">Name</div>' +
                            '<input type="text" class="solid medium" name="name" maxlength="100" autofocus required>' +
                        '</div>' +
                    '</form>';

        var modal = Modal.open({
            title: 'Edit Name',
            content: form,
            button: {
                Save: function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        var feedback_model = Cache.feedback.get(feedback_id);

        var form = modal.find('form');
        Form.setData(form, {
            name: feedback_model.get('page')
        });

        form.find('input:first').focus();

        form.on('submit', function(e) {
            e.preventDefault();

            var data = Form.getData(form);

            modal.find('button.primary').addClass('loading').prop('disabled', true);

            feedback_model.set({
                page: data.name,
                last_update_time: Math.floor((new Date()).getTime() / 1000)
            });

            Cache.app.request({
                action: 'feedback/rename',
                data: {
                    id: feedback_id,
                    name: data.name
                },
                success: function() {
                    UI.success('Name updated');
                    Modal.close();
                },
                complete: function() {
                    modal.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    editReporterDetails: function(feedback_id) {
        var form =  '<form class="form-fluid">' +
                        '<div>' +
                            '<button type="submit" class="hidden"></button>' +
                            '<div class="field-label">Name</div>' +
                            '<input type="text" class="solid medium" name="name" maxlength="80">' +
                            '<div class="field-label margin-top-8">Email</div>' +
                            '<input type="email" class="solid medium" name="email" maxlength="80">' +
                        '</div>' +
                    '</form>';

        var modal = Modal.open({
            title: 'Edit Reporter Details',
            content: form,
            button: {
                Save: function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        var feedback_model = Cache.feedback.get(feedback_id);

        var form = modal.find('form');
        Form.setData(form, {
            name: feedback_model.get('name'),
            email: feedback_model.get('email')
        });

        form.find('input:first').focus();

        form.on('submit', function(e) {
            e.preventDefault();

            var data = Form.getData(form);

            modal.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'feedback/updateDetails',
                data: {
                    id: feedback_id,
                    name: data.name,
                    email: data.email
                },
                success: function(res) {
                    var user_id = feedback_model.get('uploader_user_id');
                    var email = feedback_model.get('email');

                    feedback_model.set({
                        uploader_user_id: res.user_id,
                        name: data.name,
                        email: data.email,
                        last_update_time: Math.floor((new Date()).getTime() / 1000)
                    });

                    const where = {
                        feedback_id: feedback_id,
                        user_id: user_id,
                    };

                    if (!user_id) {
                        where.anon_email= email;
                    }

                    Cache.feedback_comment.where(where).forEach((model) => {
                        model.set({
                            user_id: res.user_id,
                            anon_email: res.user_id ? '' : data.email,
                            anon_name: res.user_id ? '' : data.name,
                        });
                    });

                    UI.success('Reporter Email updated');
                    Modal.close();

                },
                complete: function() {
                    modal.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    deleteFeedbackRevision: function(screenshot_id, screenshot_num, callback) {
        if (Cache.feedback_screenshot.length === 1) {
            Modal.open({
                title: 'Delete Version',
                content: 'This is the last version. It cannot be deleted.',
                button: {
                    OK: function(e) {
                        Modal.close();
                    }
                }
            });
            return;
        }

        Modal.confirm('Are you sure you want to delete the selected version? All the comments on the version will be deleted too.', function() {
            Cache.feedback_screenshot.remove(screenshot_id);

            var models_to_remove = [];
            Cache.feedback_comment.each(function(model) {
                if (model.get('screenshot_num') === screenshot_num && model.get('reply_comment_id') === 0) {
                    models_to_remove.push(model);
                    models_to_remove = models_to_remove.concat(Cache.feedback_comment.where({reply_comment_id: model.id}));
                }
            });

            Cache.feedback_comment.remove(models_to_remove);

            Cache.feedback_comment.each(function(model) {
                if (model.get('screenshot_num') > screenshot_num) {
                    model.set('screenshot_num', model.get('screenshot_num') - 1);
                }
            });

            Cache.app.request({
                action: 'feedback\\screenshot/delete',
                data: {
                    id: screenshot_id,
                    screenshot_num: screenshot_num
                },
                success: function(response) {
                    UI.success('Version ' + (screenshot_num + 1) + ' deleted');
                }
            });

            if (callback) {
                callback();
            }
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    approveFeedbackImageRevision: function(screenshot_id, screenshot_num) {
        var screenshot_model = Cache.feedback_screenshot.get(screenshot_id);
        var feedback_model   = Cache.feedback.get(screenshot_model.get('feedback_id'));
        var total_versions   = Cache.feedback_screenshot.where({feedback_id: screenshot_model.get('feedback_id')}).length;

        if (screenshot_model.get('is_approved')) {
            Modal.open({
                width: 500,
                title: 'Approve',
                content: 'The selected version has already been approved.',
                button: {
                    OK: function() {
                        Modal.close();
                    }
                }
            });
            return;
        }

        Modal.confirm('Are you sure you want to approve ' + (total_versions > 1 ? '<b>Version ' + (screenshot_num + 1) + '</b> of ' : '') + '<b>' + feedback_model.get('page') + '</b>?', function() {
            screenshot_model.set({
                'is_approved': true,
                'approved_by': Cache.real_user_id
            });

            _.each(Cache.feedback_screenshot.where({feedback_id: screenshot_model.get('feedback_id')}), function(model) {
                if (model.id !== screenshot_id) {
                    model.set('is_approved', false);
                }
            });

            Cache.app.request({
                action: 'feedback/approveRevision',
                data: {
                    id: screenshot_id
                },
                success: function(response) {
                    UI.success(feedback_model.get('page') + '(v' + (screenshot_num + 1) + ') approved');

                    // update feedback in parent
                    if (Cache.app.isFeedbackViewer()) {
                        try {
                            var parent_window = window.parent;

                            if (parent_window !== window) {
                                if (!window.updated_approval_ids) {
                                    window.updated_approval_ids =[];
                                }

                                if (window.updated_approval_ids.indexOf(feedback_model.id) === -1) {
                                    window.updated_approval_ids.push(feedback_model.id);
                                }
                            }
                        } catch (e) {
                        }
                    }
                }
            });
        }, this, 'Yes, approve');
    },

    shareFeedback: function(feedback_model, hide_share) {
        if (Cache.account.get('is_expired')) {
            Modals.expiredAccount();
            return;
        }

        if (feedback_model.isExpired()) {
            Modals.expiredFeedback();
            return;
        }

        if (feedback_model.get('load_type') === 'upload' && !Cache.account.hasFeature('image_feedback')) {
            Modals.unlockFeature();
            return;
        }

        var is_design = feedback_model.isDesign() || feedback_model.isPdf();

        var view = new View_Feedback_Share({
            model      : feedback_model,
            hide_share : hide_share
        });

        Modal.open({
            width: 650,
            title: is_design ? 'Share Design' : 'Share Feedback',
            content: view
        });

        view.on('Submit:Success', function() {
            // update feedback in parent
            if (Cache.app.isFeedbackViewer()) {
                try {
                    var parent_window = window.parent;

                    if (parent_window !== window) {
                        if (!window.updated_approval_ids) {
                            window.updated_approval_ids =[];
                        }

                        if (window.updated_approval_ids.indexOf(feedback_id) === -1) {
                            window.updated_approval_ids.push(feedback_id);
                        }
                    }
                } catch (e) {
                }
            }

            Modal.close();
        });

        view.on('Invite:People', function() {
            if (Cache.account.getUserLimit() <= Cache.user.length) {
                Modals.unlockFeature('Upgrade your plan to create more users.');
            } else {
                Modal.close();
                this.inviteUser();
            }
        }.bind(this));

        return;
    },

    sessionRecordingSettings: function() {
        if (!Cache.account.hasFeature('full_session_recording')) {
            Modals.unlockFeature();
            return;
        }

        var view = new View_Session_Replay_Settings();

        Modal_Bg.open({
            width: 750,
            title: 'Full Session Replay Settings',
            content: view
        });
    },

    shareSessionRecording: function(session_recording_id, options) {
        if (Cache.account.get('is_expired')) {
            Modals.expiredAccount();
            return;
        }

        var openModal = (model) => {
            var view = new View_Session_Replay_Share({model: model, ...options});

            Modal.open({
                width: 650,
                title: 'Share Session Replay',
                content: view
            });
        };

        var session_recording_model = Cache.session_recording.get(session_recording_id);

        if (!session_recording_model) {
            // the "sessions" page always has the model loaded in the global collection
            // the feedback page doesn't, so when trying to share a session from the feedback page,
            // we need to load the model first
            Cache.app.request({
                action: 'session_recording/search',
                data: {
                    session_recording_id: session_recording_id
                },
                success: (response) => {
                    if (response.data && response.data.length) {
                        session_recording_model = Cache.session_recording.add(response.data[0]);
                        openModal(session_recording_model);
                    } else {
                        UI.error('Session replay not found');
                    }
                },
                error: () => {
                    UI.error('Session replay not found');
                }
            });

            return;
        }

        openModal(session_recording_model);
    },

    deleteFeedbackCommentAttachment: function(feedback_comment_id) {
        Modal.confirm('Are you sure you want to delete the attachment?', function() {
            Cache.app.request({
                action: 'feedback\\comment/deleteAttachment',
                data: {id: feedback_comment_id},
                success: function(response) {
                    Cache.feedback_comment.get(feedback_comment_id).set('attachment', '');
                    UI.success('Attachment deleted');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    deleteFeedbackAttachment: function(feedback_id) {
        Modal.confirm('Are you sure you want to delete the attachment?', function() {
            Cache.app.request({
                action: 'feedback/deleteAttachment',
                data: {id: feedback_id},
                success: function(response) {
                    Cache.feedback.get(feedback_id).set('attachment', '');
                    UI.success('Attachment deleted');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    newFeedbackCategory: function(callback) {
        var form =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Category Name</div>' +
                '<input type="text" class="solid medium" name="category" maxlength="255" placeholder="Category A, Category B, Category C" data-nonempty="true" required autofocus>' +
            '</div>' +
            '<div class="text-align-right">' +
                '<button class="primary">Add</button>' +
            '</div>' +
        '</form>';

        var modal = Modal.open({
            title: 'New Category',
            content: form
        });

        modal.find('form').on('submit', function() {
            var data = Form.getData($(this));

            Modal.close();
            callback(data.category);
        });

        modal.find('input:first').focus();
    },

    portalSettings: function(portal, onClose) {
        if (!Cache.app.isAdmin()) {
            return;
        }

        var view = new View_Portal_Settings_Index({
            model: portal
        });

        Modal_Bg.open({
            width: 800,
            nopadding: true,
            title: 'Portal Settings',
            content: view,
            onclose: () => {
                if (onClose) {
                    onClose();
                }
            }
        });
    },

    getProjectTitle: function(project_model) {
        return '' +
        '<div class="flex-start">' +
            (project_model.get('logo') ?
            '<span class="project-logo-icon" style="background-image:url(' + project_model.escape('logo') + ');"></span>' :
            '<span class="project-type-icon" data-val="' + (project_model.isFeedback() ? 'feedback' : 'survey') + '"></span>') +
            '<span class="margin-left-12">' + Util.htmlEntities(Util.trim(project_model.get('name'), 30)) + '</span>' +
        '</div>';
    },

    projectSettings: function(project_id, menu, onclose) {
        if (!Cache.app.isAdmin()) {
            return;
        }

        var project_model = Cache.project.get(project_id);

        var view = new View_Project_Settings_Index({
            model: project_model,
            menu: menu
        });

        Modal_Bg.open({
            width: 720,
            nopadding: true,
            title_html: this.getProjectTitle(project_model),
            content: view,
            onclose: () => {
                if (onclose) {
                    onclose();
                }
            }
        });
    },

    editProjectName: function(project_id) {
        var project_model = Cache.project.get(project_id);

        var content =
            '<form class="form-fluid">' +
                '<button type="submit" class="hidden">Submit</button>' +
                '<div class="row">' +
                    '<div class="field-label">Project Name</div>' +
                    '<input type="text" class="solid medium" name="name" maxlength="100" required>' +
                    '<div class="maxlength-help"></div>' +
                '</div>' +
            '</form>';

        var modal = Modal.open({
            title_html: this.getProjectTitle(project_model),
            content: content,
            button: {
                Save: function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        var form = modal.find('form');

        Form.setData(form, {
            name: project_model.get('name')
        });

        modal.find('input[name="name"]').focus();

        form.on('submit', function(e) {
            var name = Form.getData(form, 'name');

            Cache.app.request({
                action: 'project/update',
                data: {
                    project_id: project_id,
                    name: name
                },
                success: () => {
                    project_model.set('name', name);
                    UI.success('Project name updated');

                    Modal.close();
                }
            });
        });
    },

    verifyCodeInstallation: function(project_id) {
        var view = new View_Code_Install_Verify({
            project_id: project_id
        });

        Modal.open({
            title: 'Verify Code Installation',
            content: view,
            onclose: () => {
                view.remove();
            }
        });
    },

    editProjectDomains: function(project_id) {
        var project_model = Cache.project.get(project_id);

        var view = new View_Project_Domains_Manage({
            model: project_model,
            show_save: true,
            show_help: true
        });

        Modal_Bg.open({
            title_html: this.getProjectTitle(project_model),
            content: view,
            onclose: () => {
                view.remove();
            }
        });

        view.on('Submit:Success', () => {
            Modal.close();
        });
    },

    editProjectDomain: function(domain, callback) {
        var content =  '<form>' +
                            '<span class="info">Name</span>' +
                            '<input type="text" name="domain" maxlength="50" autofocus required>' +
                            '<button type="submit" class="hidden"></button>' +
                        '</form>';

        var modal = Modal.open({
            title: 'Edit Domain',
            content: content,
            button: {
                Save: function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        var form = modal.find('form');

        var old_name = domain;

        Form.setData(form, {
            domain: old_name
        });

        form.find('input[name="domain"]').focus();

        form.on('submit', function(e) {
            e.preventDefault();
            Modal.close();

            var domain = Form.getData(form).domain;

            domain = domain.replace(/^https?:\/\//, ''); // remove protocol
            domain = domain.split('/')[0];// remove path
            domain = domain.split(':')[0];// remove port number

            callback(domain);
        }.bind(this));
    },

    addProjectDomain: function(project_id, do_xhr_save, callback) {
        var content = '<p>Add your project domains here. Put every domain on a new line.</p>' +
                        '<form>' +
                            '<textarea class="solid" rows="6" placeholder="www.example.com" autofocus required></textarea>' +
                        '</form>';

        var modal = Modal.open({
            title: 'Project Domains',
            content: content,
            button: {
                'Add': function(e, dialog) {
                    var domains = [];

                    $(dialog.find('textarea').val().split(/[,|\r\n|\r|\n]+/)).each(function(index, domain) {
                        domain = domain.trim();

                        if (domain) {
                            domain = domain.replace(/^https?:\/\//, ''); // remove protocol
                            domain = domain.split('/')[0];// remove path
                            domain = domain.split(':')[0];// remove port number
                            domains.push(domain);
                        }
                    });

                    if (!domains.length) {
                        dialog.find('textarea').focus();
                        return;
                    }

                    if (do_xhr_save) {
                        var button = $(e.target);
                        button.text('Saving...').addClass('loading').prop('disabled', true);

                        Cache.app.request({
                            action: 'project_domain/create',
                            data: {
                                project_id: project_id,
                                domains: domains
                            },
                            success: function(response) {
                                Modal.close();
                                Cache.project_domain.add(response);
                                UI.success(domains.length + ' domain' + (domains.length === 1 ? '' : 's') + ' added');
                            },
                            complete: function() {
                                button.text('Add').removeClass('loading').prop('disabled', false);
                            }
                        });
                    }

                    if (callback) {
                        Modal.close();
                        callback(_.uniq(domains));
                    }
                }
            }
        });

        modal.find('textarea').focus();
    },

    editProjectBasicAuth: function(project_model) {
        var form =
        '<p>When your website requires basic authentication, you will need to whitelist our servers. Userback\'s rendering engine needs access to your site\'s static resources (images + stylesheets) to accurately render your screens.</p>' +
        '<p><i class="fas fa-question-circle text-info"></i> <a href="https://support.userback.io/en/articles/5209187" target="help" rel="noopener">Learn more about how to whitelist our servers.</a></p>' +
        '<p>Alternatively, you can provide us your basic authentication credentials in the form below:</p>' +
        '<form class="form-fluid">' +
            '<div class="row"><div class="field-label">Username</div><input type="text" name="username" class="solid medium" maxlength="255" autocomplete="basic_auth" required></div>' +
            '<div class="row"><div class="field-label">Password</div><input type="password" name="password" class="solid medium" maxlength="255" autocomplete="basic_auth" required></div>' +
            '<div class="text-align-right"><button class="primary">Save</button></div>' +
        '</form>';

        var modal = Modal.open({
            title: 'Basic Authentication',
            content: form
        });

        var is_update = project_model.get('basic_auth') ? true : false;

        var on_submit = function() {
            modal.find('button.success').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'project/setBasicAuth',
                data: _.extend({project_id: project_model.id}, Form.getData(modal.find('form'))),
                success: function() {
                    Modal.close();
                    project_model.set('basic_auth', 'yes');

                    if (is_update) {
                        UI.success('Basic authentication updated');
                    } else {
                        UI.success('Basic authentication added');
                    }
                },
                complete: function() {
                    modal.find('button.success').removeClass('loading').prop('disabled', false);
                }
            });
        };

        modal.find('form').on('submit', on_submit);
        modal.find('input[name="username"]').focus();
    },

    editConfirmationEmail: function(project_id) {
        var view_project_notification = new View_Project_Notification_Editor({project_id: project_id, type: 'confirmation_email'});

        Modal.open({
            title: 'Edit Confirmation Email',
            content: view_project_notification,
            button_class: 'secondary',
            width: 720
        });

        view_project_notification.on('Submit:Success', function() {
            Modal.close();
            UI.success('Reporter notification updated');
        });
    },

    editAutoReplyContent: function(project_id) {
        var view_project_notification = new View_Project_Notification_Editor({project_id: project_id, type: 'auto_reply'});

        Modal.open({
            title: 'Edit Auto-reply Content',
            content: view_project_notification,
            button_class: 'secondary',
            width: 720
        });

        view_project_notification.on('Submit:Success', function() {
            Modal.close();
            UI.success('Auto-reply content updated');
        });
    },

    deleteProjectBasicAuth: function(project_model) {
        Modal.confirm('Are you sure you want to remove the basic authentication from the project?', function() {
            Cache.app.request({
                action: 'project/deleteBasicAuth',
                data: {
                    project_id: project_model.id
                },
                success: function(response) {
                    Modal.close();
                    UI.success('Basic authentication removed');
                    project_model.set('basic_auth', '');
                }
            });
        }, this, 'Yes, remove', undefined, 'secondary');
    },

    editProjectHttpHeaders: function(project_model) {
        var getRowTemplate = function(key, value) {
            return '<div class="data-row grid-10-2 margin-bottom-8">' +
                        '<div class="grid-6-6">' +
                            '<div class="margin-right-4">' +
                                '<input type="text" name="key" maxlength="50" class="solid compact"' + (key ? ' value="' + Util.htmlEntities(key) + '"' : '') + '>' +
                            '</div>' +
                            '<div class="margin-left-4">' +
                                '<input type="text" name="value" maxlength="128" class="solid compact"' + (value ? ' value="' + Util.htmlEntities(value) + '"' : '') + '>' +
                            '</div>' +
                        '</div>' +
                        '<div>' +
                            '<button type="button" class="data-row-delete text-info small round"><i class="fa-solid fa-circle-minus text-icon"></i></button>' +
                        '</div>' +
                    '</div>';
        }

        var existing_header_rows = '';

        if (project_model.get('http_header')) {
            JSON.parse(project_model.get('http_header')).forEach(function(header) {
                existing_header_rows += getRowTemplate(header.key, header.value);
            });
        }

        var form = '<p>Userback\'s rendering engine needs access to your site\'s static resources (images + stylesheets) to accurately render your screens. When your site is in a protected environment, you can add extra HTTP headers in order to identify requests made from our screenshot servers and whitelist them accordingly.</p>' +
                    '<p><i class="fas fa-question-circle text-info"></i> <a href="https://support.userback.io/en/articles/5209187" target="help" rel="noopener">Learn more about how to whitelist our servers</a>.</p>' +
                    '<form class="compact margin-top-32">' +
                        '<div class="grid-10-2 margin-bottom-8">' +
                            '<div class="grid-6-6">' +
                                '<div class="font-weight-medium">Key</div>' +
                                '<div class="font-weight-medium">Value</div>' +
                            '</div>' +
                        '</div>' +
                        (existing_header_rows || getRowTemplate()) +
                        '<div class="margin-top-24">' +
                            '<a href="#" class="data-row-add primary underline hover-underline"><i class="fas fa-plus margin-right-4"></i>Add</a>' +
                        '</div>' +
                        '<div class="text-align-right"><button type="submit" class="primary">Save</button></div>' +
                    '</form>';

        var modal = Modal.open({
            title: 'HTTP Headers',
            content: form
        });

        var checkLimit = function() {
            modal.find('.data-row-add').toggle(modal.find('.data-row').length < 5);
        };

        modal.find('input:first').focus();
        checkLimit();

        modal.find('.data-row-add').on('click', function(e) {
            e.preventDefault();

            var row = $(getRowTemplate());
            row.insertAfter(modal.find('.data-row:last'));
            row.find('input:first').focus();

            checkLimit();
        });

        modal.on('click', '.data-row-delete', function(e) {
            var data_row = $(e.currentTarget).parents('.data-row:first');

            if (modal.find('.data-row').length > 1) {
                data_row.remove();
            } else {
                data_row.find('input').val('');
            }

            checkLimit();
        });

        modal.find('form').on('submit', function(e) {
            var http_header = [];

            modal.find('.data-row').each(function() {
                var key   = $(this).find('input[name="key"]').val().replace(/\s/g, '').replace(/:/g, '');
                var value = $(this).find('input[name="value"]').val().replace(/\s/g, '');

                if (key && value) {
                    http_header.push({
                        key   : key,
                        value : value
                    });
                }
            });

            modal.find('button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'project/setHttpHeaders',
                data: {
                    project_id: project_model.id,
                    http_header: http_header
                },
                success: function() {
                    Modal.close();

                    if (http_header.length) {
                        project_model.set('http_header', JSON.stringify(http_header));
                        UI.success('HTTP headers updated');
                    } else {
                        project_model.set('http_header', '');
                        UI.success('HTTP headers removed');
                    }
                },
                complete: function() {
                    modal.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    archiveProjectWarning: function() {
        Modal.confirm('You will need at least one active project in your account.', function() {
        });
    },

    deleteProject: function(project_id) {
        if (!Cache.project.get(project_id).get('is_archived') && Cache.project.where({is_archived: false}).length <= 1) {
            Modals.archiveProjectWarning();
        } else {
            Modal.open({
                width: 640,
                title: 'Delete Project',
                content: 'Are you sure you want to delete the project?',
                button: {
                    'Yes, delete': (e, modal) => {
                        modal.find('.modal-button button').addClass('loading').prop('disabled', true);

                        Cache.app.request({
                            action: 'project/delete',
                            data: {
                                id: project_id
                            },
                            success: () => {
                                Cache.project.remove(Cache.project.get(project_id));
                                Cache.project_access.searchAndRemove({project_id: project_id});
                                Router.navigate('/project/', {trigger: true});
                                UI.success('Project deleted');

                                Modal.close();
                            }
                        });
                    }
                },
                button_class: 'secondary'
            });
        }
    },

    archiveProject: function(project_id) {
        var active_total = Cache.project.where({is_archived: false}).length;

        if (active_total <= 1) {
            Modals.archiveProjectWarning();
        } else {
            Modal.confirm('Are you sure you want to archive the project? Integrations will be deactivated after the project is archived.', function() {
                Cache.app.request({
                    action: 'project/archive',
                    data:    {
                        id: project_id
                    },
                    success: function(response) {
                        Cache.project.get(project_id).set({
                            'is_archived'  : true,
                            'archive_time' : Math.floor((new Date()).getTime() / 1000)
                        });

                        if (project_id === Cache.default_project_id) {
                            Router.navigate('/project/', {trigger: true});
                        }

                        UI.success('Project archived');
                    }
                });
            }, this, 'Yes, archive');
        }
    },

    restoreProject: function(project_id) {
        var project_model = Cache.project.get(project_id);
        var active_total = Cache.project.where({is_archived: false}).length;

        if (project_model.isSurvey() && !Cache.account.hasFeature('survey')) {
            return;
        }

        if (Cache.account.getProjectLimit() <= active_total) {
            Modals.unlockFeature('Upgrade your plan to have more active projects.');
        } else {
            Modal.confirm('Are you sure you want to restore the project?', function() {
                Cache.app.request({
                    action: 'project/restore',
                    data:    {
                        id: project_id
                    },
                    success: (response) => {
                        project_model.set({
                            'is_archived'  : false,
                            'archive_time' : Math.floor((new Date()).getTime() / 1000)
                        });
                        UI.success('Project restored');
                    }
                });
            }, this, 'Yes, restore');
        }
    },

    activatePortal: function() {
        var view = new View_Portal_Activate();

        Modal.open({
            width: 800,
            notitle: true,
            content: view
        });
    },

    deletePortal: function(portal_id) {
        var message = 'Are you sure you want to delete the ideas portal?' +
        '<ul>' +
            '<li>This can\'t be undone.</li>' +
            '<li>Deleting the portal will not delete any feedback.</li>' +
        '</ul>';

        Modal.confirm(message, function() {
            Cache.app.request({
                action: 'portal/delete',
                data: {
                    portal_id: portal_id
                },
                success: function() {
                    Cache.portal.remove(Cache.portal.get(portal_id));
                    Cache.portal_status.where({portal_id: portal_id}).forEach(function(portal_status) {
                        Cache.portal_status.remove(portal_status);

                        Cache.workflow.where({portal_status_id: portal_status.id}).forEach(function(workflow) {
                            workflow.set('portal_status_id', 0);
                        });
                    });

                    UI.buildPage('portal_settings');
                    UI.success('Ideas portal deleted');


                }
            });
        }, this, 'Yes, delete', 'Delete Portal', 'secondary');
    },

    deleteAnnouncement: function(announcement_id) {
        var message = 'Are you sure you want to delete the announcement?';

        Modal.confirm(message, function() {
            Cache.app.request({
                action: 'portal_announcement/delete',
                data: {
                    id: announcement_id,
                },
                success: function() {
                    var model = Cache.portal_announcement.get(announcement_id);
                    var tag = model.get('category');
                    var tag_list = tag ? tag.split(',') : [];

                    var next_announcement_tags = Cache.get('announcement_categories')
                        .map((item) => {
                            if (tag_list.includes(item.category)) {
                                return {
                                    category: item.category,
                                    count: item.count - 1,
                                };
                            }

                            return item;
                        })
                        .filter((item) => {
                            return item.count > 0;
                        });

                    Cache.add('announcement_categories', next_announcement_tags);

                    Cache.portal_announcement.remove(model);
                    UI.success('Announcement deleted');
                }
            });
        }, this, 'Yes, delete', 'Delete announcement', 'secondary');
    },

    changePassword: function(user_id, is_portal_user) {
        var password_form =
        '<form class="form-fluid">' +
            '<div class="row"><div class="field-label">Old Password</div><input type="password" name="old_password" class="solid medium" maxlength="255" autocomplete="new-password" required autofocus></div>' +
            '<div class="row"><div class="field-label">New Password</div><input type="password" name="new_password" class="solid medium" maxlength="255" autocomplete="new-password" required></div>' +
            '<div class="text-align-right"><button class="primary">Change</button></div>' +
        '</form>';

        var modal = Modal.open({
            width: 500,
            title: 'Change Password',
            content: password_form
        });

        var on_submit = function() {
            var form_data = Form.getData($(this));

            modal.find('button.success').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: is_portal_user ? 'portal_user/changePassword' : 'user/changePassword',
                data: is_portal_user ? form_data : _.extend({user_id: user_id}, form_data),
                success: function() {
                    UI.success('Password updated');
                    Modal.close();
                },
                complete: function() {
                    modal.find('button.success').removeClass('loading').prop('disabled', false);
                }
            });
        };

        modal.find('form').on('submit', on_submit);
        modal.find('input[name="old_password"]').focus();
    },

    emailWidgetCode: function(project_id) {
        var modal = Modal.open({
            title: 'Email Widget Code',
            content: '<p>We\'ll send an email to your colleague with the widget code and instructions on how to install Userback.</p>' +
                     '<form class="form-fluid margin-top-30">' +
                         '<div class="field-label">Recipient\'s Email</div>' +
                         '<input type="email" name="email" class="medium solid" placeholder="jason@example.com" required>' +
                         '<button type="submit" class="hidden"></button>' +
                     '</form>',
            button: {
                'Send Email': function(e) {
                    modal.find('button[type="submit"]').click();
                }
            }
        });

        modal.find('input[name="email"]').focus();

        modal.find('form').on('submit', function(e) {
            e.preventDefault();

            var email = modal.find('input[name="email"]').val().trim();

            modal.find('.modal-button button').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'account/emailWidgetCode',
                data: {
                    email: email,
                    project_id: project_id
                },
                success: function() {
                    Modal.close();
                    UI.success('Email sent');
                }
            });
        });
    },

    getBrowserExtension: function() {
        var browser_extension_view = new View_Browser_Extension();

        var modal = Modal.open({
            title: 'Browser Extension',
            content: '<p>Install browser extension to capture feedback on your websites.</p>',
            width: 720,
            onclose: function() {
                browser_extension_view.remove();
            }
        });

        browser_extension_view.render().$el.appendTo(modal.find('.modal-content'));
    },

    tryBrowserExtension: function() {
        var chrome_link  = 'https://chrome.google.com/webstore/detail/userback/mpodoaaiifocfbchaphabldebijoilgp';
        var firefox_link = 'https://addons.mozilla.org/en-US/firefox/addon/userback/';
        var edge_link    = 'https://microsoftedge.microsoft.com/addons/detail/userback/giehcmiicobbgcijnnimmdnbgjijplga';

        var modal = Modal.open({
            width: 540,
            title: 'Try Browser Extension',
            content: '<img src="/image/try_extension.png">' +
                     '<div class="modal-try-extension">' +
                         '<p>Userback extension is also available for popular browsers like <a href="' + chrome_link +'" class="primary font-weight-medium" target="extension" rel="noopener">Chrome</a>, <a href="' + firefox_link + '" class="primary font-weight-medium" target="extension" rel="noopener">Firefox</a>, and <a href="' + edge_link +'" class="primary font-weight-medium" target="extension" rel="noopener">Edge</a>.</p>' +
                         '<p>Add the extension to your browser and explore what’s possible with Userback.</p>' +
                         '<button type="button" class="add-extension primary medium">Add extension</button>' +
                     '</div>'
        });

        modal.find('.add-extension').on('click', function() {
            var bowser = Bowser2.getParser(navigator.userAgent);
            var browser_name = bowser.getBrowserName().toLowerCase();

            if (browser_name === 'microsoft edge') {
                window.open(edge_link, 'extension');
            } else if (browser_name === 'firefox') {
                window.open(firefox_link, 'extension');
            } else {
                // chrome
                window.open(chrome_link, 'extension');
            }
        });
    },

    migrateWidget: function(widget_id) {
        var content =
        '<div class="promo-video padding-8 cursor-pointer"><img class="rounded-corner" src="/image/next_gen_promo.png"></div>' +
        '<div class="padding-32">' +
            '<h3 class="text-align-center font-weight-semibold">Switch to the Next-Gen AI Assisted Widget</h3>' +
            '<p class="text-align-center padding-left-24 padding-right-24">Enjoy a faster, smarter feedback experience by switching to the new AI Assisted Widget. This change is permanent, so be sure it’s the right fit before switching! <a class="primary font-weight-medium" href="https://support.userback.io/en/articles/10647393-introducing-userbacks-new-next-gen-ai-assisted-widget" target="_blank" rel="noopener">Learn more <i class="fa-solid fa-square-arrow-up-right"></i></a>.</p>' +
            '<div class="divider-24"></div>' +
            '<div class="text-align-center">' +
                '<div><button type="button" class="widget-upgrade shiny medium min"><span>Switch now</span></button></div>' +
                '<div class="divider-12"></div>' +
                '<div><a href="#" class="modal-close text-info text-medium">Close</a></div>' +
            '</div>' +
        '</div>';

        var modal = Modal.open({
            notitle: true,
            close: false,
            nopadding: true,
            content: content
        });

        modal.find('.promo-video').on('click', () => {
            Modals.previewVideo('https://static.userback.io/video/widget_next_gen_promo.mp4');
        });

        modal.find('.widget-upgrade').on('click', () => {
            modal.find('.widget-upgrade').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'widget/upgradeNextGen',
                data: {
                    widget_id: widget_id
                },
                success: (response) => {
                    if (response) {
                        window.location.href = '/' + Cache.getDefaultProject().get('project_key') + '/dashboard/designer?msg=Widget upgraded';
                    }
                }
            });
        });

        modal.find('.modal-close').on('click', (e) => {
            e.preventDefault();
            Modal.close();
        });
    },

    openWidgetStudio: function(template_code = null, hide_animation = false, on_exit, main_tab) {
        var options = {
            hide_animation: hide_animation,
            onExit: () => {
                delete this.widget_studio;

                if (on_exit) {
                    on_exit();
                }
            }
        };

        if (template_code) {
            options.template_code = template_code;
        }

        if (main_tab) {
            options.main_tab = main_tab;
        }

        if (this.widget_studio instanceof View_Widget_Studio) {
            this.widget_studio.remove();
        }

        this.widget_studio = new View_Widget_Studio(options);
        this.widget_studio.render().$el.appendTo('body');

        this.widget_studio.on('Widget_Studio::TemplateSelected', (template_code) => {
            Modals.openWidgetStudio(template_code, true, on_exit);
        });
    },

    openSurveyStudio: function(hide_animation = false, on_exit) {
        var options = {
            hide_animation: hide_animation,
            onExit: () => {
                delete this.survey_studio;

                if (on_exit) {
                    on_exit();
                }
            }
        };


        if (this.survey_studio instanceof View_Survey_Designer) {
            this.survey_studio.remove();
        }

        this.survey_studio = new View_Survey_Designer(options);
        this.survey_studio.render().$el.appendTo('body');
    },

    getWidgetCode: function(show_all_projects, on_close) {
        var widget_code_view = new Widget_Code({
            show_all_projects: !!show_all_projects,
            verify_project_id: 0, // all projects
            show_verify: true
        });

        Modal_Fullscreen.open({
            title: 'Install Userback',
            content: widget_code_view,
            onclose: function() {
                widget_code_view.remove();

                if (on_close) {
                    on_close();
                }
            }
        });
    },

    copyProject: function(project_id) {
            var dialog = Modal.open({
            title: 'Copy Project',
            content: '<p>Are you sure you want to copy <b>' + Cache.project.get(project_id).escape('name') + '</b> Project?</p><p>You will need to setup Project Access, Integrations and Notifications for the new project.</p>',
            button: {
                'Yes, copy': function() {
                    dialog.find('.modal-button button.primary').addClass('loading').prop('disabled', true);

                    Cache.app.request({
                        action: 'project/copy',
                        data: {
                            project_id: project_id
                        },
                        success: function(response) {
                            Modal.close();

                            // project access
                            Cache.project_access.add(response.project_access);

                            // project domain
                            Cache.project_domain.add(response.project_domain);

                            // project categories
                            Cache.feedback_category.add(response.feedback_categories);

                            // project
                            Cache.project.add(response.project);

                            // update project count
                            Cache.statistics.syncProjectCount();

                            UI.success('Project "' + response.project.name + '" created');
                        },
                        complete: function() {
                            dialog.find('.modal-button button.primary').removeClass('loading').prop('disabled', false);
                        }
                    });
                }
            }
        });
    },

    switchWorkspace: function() {
        var view = new View_Workspace_Select({
            show_create: false
        });

        Modal.open({
            notitle: true,
            content: view
        });
    },

    createWorkspace: function() {
        var count = 0;
        Cache.workspace.each((workspace_model) => {
            if (Cache.app.isWorkspaceOwner(workspace_model.id)) {
                count++;
            }
        });

        if (count >= Cache.account.getWorkspaceLimit()) {
            this.unlockFeature('Limit reached. You can not create new workspaces.', 'OK', 'Too many workspaces', () => {
                Modal.close();
            });
            return;
        }

        var view = new View_Workspace_Create();

        Modal_Fullscreen.open({
            title: 'Create Workspace',
            content: view,
            onclose: function() {
            }
        });
    },

    resetWorkspaceJoinCode: function() {
        Modal.confirm('<p>Are you sure you want to reset the invite link? Your old one can no longer be used.</p>', () => {
            Cache.app.request({
                action: 'workspace/resetJoinCode',
                success: (response) => {
                    Cache.getDefaultWorkspace().set('join_code', response.join_code);
                    UI.success('Invite link reset');
                }
            });
        }, this, 'Yes, reset');
    },

    createProject: function(template_code) {
        var view = new View_Create_Project(template_code);

        var modal = Modal.open({
            notitle: true,
            content: view,
            theme: 'modal-center-form',
            onclose: function() {
                if (view) {
                    view.remove();
                }
            }
        });

        modal.find('input:first').focus();
    },

    openFeedbackCommentTemplate: function() {
        var view = new View_Feedback_Template_Edit();
        var modal = Modal_Bg.open({
            title_html: '<div class="flex-between"><div>Reply Templates</div><button type="button" class="primary small min inline new-template margin-right-24"><i class="fas fa-plus"></i> New template</button></div>',
            width: 1280,
            nopadding: true,
            content: view,
            onclose: function() {
                if (view) {
                    view.remove();
                }
            }
        });

        modal.find('.new-template').on('click', function() {
            view.newTemplate();
        });
    },

    openFeedbackCommentDeleteModal: function(template_id, success) {
        Modal.confirm('Are you sure you want to delete this template?', () => {
            Cache.app.request({
                action: 'feedback\\Comment_Template/delete',
                data: {
                    feedback_comment_template_id: template_id
                },
                success: () => {
                    Cache.feedback_comment_template.remove(template_id);
                    success();
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    openTemplateGallery: function(initial_template_code, complete, options = {}, project_type = '') {
        var view;
        var title = 'Select project type';

        if (!Cache.account.hasFeature('survey')) {
            view = new View_Template_Gallery({
                initial_template_code: initial_template_code,
                project_type: 'feedback',
                show_loader_on_select: !!options.show_loader_on_select
            });
            title = 'Select a widget template';
        } else {
            view = new View_Template_Selection({
                show_loader_on_select: !!options.show_loader_on_select
            });

            if (project_type) {
                view = new View_Template_Gallery({
                    initial_template_code: initial_template_code,
                    project_type: project_type,
                    show_loader_on_select: !!options.show_loader_on_select
                });
                title = 'Select a survey template';
            }
        }

        Modal_Fullscreen.open({
            title: title,
            content: view,
            onclose: function() {
                if (view) {
                    view.remove();
                }
            }
        });

        view.on('nav', (project_type) => {
            if (project_type === 'feedback') {
                Modal_Fullscreen.setTitle('Select a widget template');
            } else if (project_type === 'survey') {
                Modal_Fullscreen.setTitle('Select a survey template');
            } else {
                Modal_Fullscreen.setTitle('Select project type');
            }
        });

        view.on('submit:success', (template_code, template) => {
            if (complete) {
                complete(template_code, template);
            }

            if (options.close_on_success !== false) {
                Modal_Fullscreen.close();
            }
        });
    },

    editWebhook: function(add_new) {
        var view = new View_Webhook_Edit({
            add_new : add_new,
        });

        Sidebar.open({
            title: 'Webhook Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
     },

    oauthPopup: function(popup_url, popup_width, popup_height, callback) {
        var left = Math.max(0, (screen.availWidth - popup_width) / 2);
        var top  = Math.max(0, (screen.availHeight - popup_height) / 2);

        window.open(popup_url, 'oauth_popup', 'width=' + popup_width + ',height=' + popup_height + ',left=' + left + ',top=' + top);

        $(window).on('message.oauthpopup', (e) => {
            var event = e.originalEvent;

            if (event.data.oauth_callback) {
                $(window).off('message.oauthpopup');
            } else {
                return;
            }

            callback(event);
        });
    },

    reconnectConnectedApp: function(app_type, model, callback) {
        var reconnect_method;

        switch (app_type) {
            case 'trello':
                reconnect_method = this.oauthTrello;
                break;
            case 'slack':
                reconnect_method = this.oauthSlack;
                break;
            case 'teams':
                reconnect_method = this.oauthTeams;
                break;
            case 'clickup':
                reconnect_method = this.oauthClickup;
                break;
            case 'github':
                reconnect_method = this.oauthGithub;
                break;
            case 'gitlab':
                reconnect_method = this.oauthGitlab;
                break;
            case 'linear':
                reconnect_method = this.oauthLinear;
                break;
            case 'intercom':
                reconnect_method = this.oauthIntercom;
                break;
            case 'asana':
                reconnect_method = this.oauthAsana;
                break;
            case 'basecamp':
                reconnect_method = this.oauthBasecamp;
                break;
            case 'wrike':
                reconnect_method = this.oauthWrike;
                break;
            case 'azure_devops':
                reconnect_method = this.oauthAzureDevops;
                break;
            case 'notion':
                reconnect_method = this.oauthNotion;
                break;
            case 'zendesk':
                // zendesk has a different workflow
                // there is not need to continue the code
                this.connectZendesk(() => {
                    UI.success('App reconnected');
                }, model.id);

                return;
                break;
        }

        reconnect_method((access_token, refresh_token, expires_at) => {
            Cache.app.request({
                action: 'integration/addConnectedApp',
                data: {
                    type          : app_type,
                    app_id        : model.id,
                    access_token  : access_token,
                    refresh_token : refresh_token,
                    expires_at    : expires_at
                },
                success: (response) => {
                    model.set(response);
                    UI.success('App reconnected');

                    if (callback) {
                        callback();
                    }
                }
            });
        });
    },

    renameConnectedApp: function(app_type, model) {
        var form =
        '<form>' +
            '<div>' +
                '<span class="helper">Name</span>' +
                '<input type="text" name="custom_name" maxlength="100" autofocus required>' +
            '</div>'+
            '<button type="submit" class="hidden"></button>' +
        '</form>';

        var modal = Modal.open({
            title: 'Edit Name',
            content: form,
            button: {
                Save: function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        Form.setData(modal.find('form'), {
            custom_name: model.get('custom_name')
        });

        modal.find('form').on('submit', function() {
            var form_data = Form.getData(modal.find('form'));

            Cache.app.request({
                action: 'integration/renameConnectedApp',
                data: {
                    type        : app_type,
                    app_id      : model.id,
                    custom_name : form_data.custom_name
                },
                success: () => {
                    model.set('custom_name', form_data.custom_name);
                    UI.success('Account renamed successfully');

                    Modal.close();
                }
            });
        });
    },

    removeConnectedApp: function(app_type, model) {
        var connected_app_collection;
        var integration_collection;
        var connection_name;

        switch (app_type) {
            case 'jira':
                connected_app_collection = Cache.connected_app_jira;
                integration_collection = Cache.integration_jira;
                connection_name = 'Jira';
                break;
            case 'trello':
                connected_app_collection = Cache.connected_app_trello;
                integration_collection = Cache.integration_trello;
                connection_name = 'Trello';
                break;
            case 'teamwork':
                connected_app_collection = Cache.connected_app_teamwork;
                integration_collection = Cache.integration_teamwork;
                connection_name = 'Teamwork';
                break;
            case 'monday':
                connected_app_collection = Cache.connected_app_monday;
                integration_collection = Cache.integration_monday;
                connection_name = 'monday';
                break;
            case 'slack':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_slack;
                connection_name = 'Slack';
                break;
            case 'teams':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_teams;
                connection_name = 'teams';
                break;
            case 'clickup':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_clickup;
                connection_name = 'ClickUp';
                break;
            case 'github':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_github;
                connection_name = 'GitHub';
                break;
            case 'gitlab':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_gitlab;
                connection_name = 'GitLab';
                break;
            case 'linear':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_linear;
                connection_name = 'Linear';
                break;
            case 'intercom':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_intercom;
                connection_name = 'Intercom';
                break;
            case 'asana':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_asana;
                connection_name = 'Asana';
                break;
            case 'basecamp':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_basecamp;
                connection_name = 'Basecamp';
                break;
            case 'wrike':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_wrike;
                connection_name = 'Wrike';
                break;
            case 'azure_devops':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_azure_devops;
                connection_name = 'Azure DevOps';
                break;
            case 'notion':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_notion;
                connection_name = 'Notion';
                break;
            case 'zendesk':
                connected_app_collection = Cache.connected_app_oauth;
                integration_collection = Cache.integration_zendesk;
                connection_name = 'Zendesk';
                break;
        }

        Modal.confirm('<p>Are you sure you want to delete the ' + connection_name + ' connection? Deleting it will also deactivate all the integrations.</p>', () => {
            Cache.app.request({
                action: 'integration/deleteConnectedApp',
                data: {
                    type: app_type,
                    app_id: model.id
                },
                success: () => {
                    connected_app_collection.remove(model);

                    integration_collection.where({app_id: model.id}).forEach((integration_model) => {
                        integration_collection.remove(integration_model);
                    });

                    UI.success('Connection deleted');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    sendToIntegration: function(integration_type, feedback_model) {
        var integrations = {
            'jira'         : ['jira_url',         this.sendToJira],
            'clickup'      : ['clickup_url',      this.sendToClickup],
            'wrike'        : ['wrike_url',        this.sendToWrike],
            'azure_devops' : ['azure_devops_url', this.sendToAzureDevops],
            'teamwork'     : ['teamwork_url',     this.sendToTeamwork],
            'trello'       : ['trello_url',       this.sendToTrello],
            'asana'        : ['asana_url',        this.sendToAsana],
            'monday'       : ['monday_url',       this.sendToMonday],
            'github'       : ['github_url',       this.sendToGithub],
            'gitlab'       : ['gitlab_url',       this.sendToGitlab],
            'linear'       : ['linear_url',       this.sendToLinear],
            'notion'       : ['notion_url',       this.sendToNotion],
        };

        if (typeof integrations[integration_type] !== 'undefined') {
            var url_name  = integrations[integration_type][0];
            var send_func = integrations[integration_type][1];

            if (feedback_model.get(url_name)) {
                window.open(feedback_model.get(url_name), 'url_name', 'noopener');
            } else {
                send_func(feedback_model.id);
            }
        } else {
            switch (integration_type) {
                case 'basecamp':
                    if (feedback_model.get('basecamp_url')) {
                        window.open(feedback_model.get('basecamp_url'), 'basecamp', 'noopener');
                    } else {
                        feedback_model.set('basecamp_url', 'processing');

                        Cache.app.request({
                            action: 'integration/sendFeedbackToBasecamp',
                            data: {
                                feedback_id: feedback_model.get('id')
                            },
                            success: (response) => {
                                feedback_model.set('basecamp_url', response.basecamp_url);
                                UI.success('Todo item created in Basecamp');
                            },
                            error: () => {
                                UI.error('Error occured, please check your Basecamp integration details and try again.');
                            }
                        });
                    }

                    break;

                case 'zendesk':
                    if (feedback_model.get('zendesk_url')) {
                        window.open(feedback_model.get('zendesk_url'), 'zendesk', 'noopener');
                    } else {
                        feedback_model.set('zendesk_url', 'processing');

                        Cache.app.request({
                            action: 'integration/sendFeedbackToZendesk',
                            data: {
                                feedback_id: feedback_model.get('id')
                            },
                            success: (response) => {
                                feedback_model.set('zendesk_url', response.zendesk_url);
                                UI.success('Ticket created in Zendesk');
                            },
                            error: () => {
                                UI.error('Error occured, please check your Zendesk integration details and try again.');
                            }
                        });
                    }

                    break;
            }
        }
    },

    activateWebhook: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        return this.editWebhook(true);
    },

    deactivateWebhook: function() {
        Modal.confirm('Are you sure you want to deactivate Webhook?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'webhook'
                },
                success: function() {
                    UI.success('Webhook integration deactivated');

                    var model = Cache.integration_webhook.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_webhook.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Webhook' });
                }
            });
        });
    },

    changeSlackChannel: function() {
        var form = '<p><a href="https://my.slack.com/services/new/incoming-webhook/" target="_blank" rel="noopener">Get your Slack Webhook URL here</a></p>' +
                    '<form class="compact">' +
                        '<div><span class="helper">Slack Webhook URL</span><input type="url" name="slack_url" maxlength="255" required></div>' +
                        '<div><span class="helper">Slack Channel (e.g. #general)</span><input type="text" name="channel" maxlength="255" required></div>' +
                        '<button type="submit" class="hidden"></button>' +
                    '</form>';

        var modal = Modal.open({
            title: 'Slack Integration',
            content: form,
            button: {
                'Update': function(e, dialog) {
                    modal.find(':submit').click();
                }
            }
        });

        var slack_form = modal.find('form');

        Form.setData(slack_form, Cache.integration_slack.findWhere({project_id: Cache.default_project_id}).attributes);

        slack_form.on('submit', function(e) {
            e.preventDefault();

            var data = Form.getData(slack_form);
            var channel = data.channel;

            if (data.channel.charAt(0) !== '#' && data.channel.charAt(0) !== '@') {
                channel = '#' + data.channel;
            }

            modal.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'integration/update',
                data: {
                    type    : 'slack',
                    url     : data.slack_url,
                    channel : channel
                },
                success: function() {
                    UI.success('Slack integration updated');
                    Cache.integration_slack.findWhere({project_id: Cache.default_project_id}).set({
                        'slack_url' : data.slack_url,
                        'channel'   : channel
                    });

                    Modal.close();
                },
                complete: function() {
                    modal.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    oauthSlack: function(callback) {
        Modals.oauthPopup('/oauth/slack/?step=auth', 800, 800, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    activateSlack: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'slack', is_disabled: false});

        if (apps.length) {
            var view = new View_Slack_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthSlack((access_token) => {
                this.editSlack(access_token);
            });
        }
    },

    deactivateSlack: function() {
        Modal.confirm('Are you sure you want to deactivate Slack?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'slack'
                },
                success: function() {
                    UI.success('Slack integration deactivated');

                    var model = Cache.integration_slack.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_slack.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Slack' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editSlack: function(token) {
        var view = new View_Slack_Edit({
            is_new : token ? true : false,
            token  : token
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    oauthTeams: function(callback) {
        Modals.oauthPopup('/oauth/teams/?step=auth', 800, 800, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token, event.data.refresh_token, event.data.expires_at);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    activateTeams: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'teams', is_disabled: false});

        if (apps.length) {
            var view = new View_Teams_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthTeams((access_token, refresh_token, expires_at) => {
                this.editTeams(access_token, refresh_token, expires_at);
            });
        }
    },

    deactivateTeams: function() {
        Modal.confirm('Are you sure you want to deactivate Microsoft Teams?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'teams'
                },
                success: function() {
                    UI.success('Microsoft Teams integration deactivated');

                    var model = Cache.integration_teams.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_teams.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Teams' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editTeams: function(access_token, refresh_token, expires_at) {
        var view = new View_Teams_Edit({
            is_new        : access_token ? true : false,
            access_token  : access_token,
            refresh_token : refresh_token,
            expires_at    : expires_at
        });

        var sidebar = Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    connectJira: function(model_id, callback) {
        var connect_view = new View_Jira_Connect();

        var sidebar = Sidebar.open({
            title: 'Connect Jira',
            content: connect_view,
            theme: 'sidebar-sticky-bottom',
            onopen: function() {
                sidebar.find('form input:first').focus();
            },
            onclose: function() {
                connect_view.remove();
            }
        });

        sidebar.find('form').on('submit', function(e) {
            sidebar.find('button:submit').addClass('loading').prop('disabled', true);

            var form_data = Form.getData(sidebar.find('form'));

            Cache.app.request({
                action: 'integration/addConnectedApp',
                data: {...form_data, type: 'jira', app_id: model_id},
                success: (response) => {
                    if (model_id) {
                        Cache.connected_app_jira.get(model_id).set(response);

                        if (Cache.integration_jira.findWhere({project_id: Cache.default_project_id}).get('app_id') === model_id) {
                            Cache.integration_jira.findWhere({project_id: Cache.default_project_id}).set('is_disabled', false);
                        }
                    } else {
                        Cache.connected_app_jira.add(response);
                    }

                    UI.success('Jira account connected');

                    Sidebar.close();

                    if (callback) {
                        callback();
                    }
                },
                complete: () => {
                    sidebar.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    activateJira: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var edit_view;

        var apps = Cache.connected_app_jira.where({is_disabled: false});

        if (apps.length) {
            edit_view = new View_Jira_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: edit_view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    edit_view.remove();
                }
            });

            edit_view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            var connect_view = new View_Jira_Connect({
                submit_button: 'Next'
            });

            var sidebar = Sidebar.open({
                title: 'Step 1 - Connect to your Jira account',
                content: connect_view,
                theme: 'sidebar-sticky-bottom',
                onopen: function() {
                    sidebar.find('form input:first').focus();
                }
            });

            sidebar.find('form').on('submit', function(e) {
                e.preventDefault();

                sidebar.find('button:submit').addClass('loading').prop('disabled', true);

                var form_data = Form.getData(sidebar.find('form'));

                Cache.app.request({
                    action: 'integration/verifyJira',
                    data: form_data,
                    success: function(response) {
                        // after verified
                        edit_view = new View_Jira_Edit({
                            is_new    : true,
                            jira_host : form_data.jira_host,
                            username  : form_data.username,
                            password  : form_data.password
                        });

                        Sidebar.setContent('');
                        Sidebar.setTitle('Step 2 - Integration Settings');

                        edit_view.render().$el.appendTo(sidebar.find('.sidebar-content'));

                        edit_view.on('submit:success', function() {
                            Sidebar.close();
                        });
                    },
                    error: function() {
                        sidebar.find('button:submit').removeClass('loading').prop('disabled', false);
                        UI.error('Authentication failed. Please verify your Jira login details.');
                        return;
                    },
                    onclose: function() {
                        if (edit_view) {
                            edit_view.remove();
                        }
                    }
                });
            });
        }
    },

    editJira: function() {
        var view = new View_Jira_Edit();

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    deactivateJira: function() {
        Modal.confirm('Are you sure you want to deactivate Jira?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'jira'
                },
                success: function() {
                    UI.success('Jira integration deactivated');

                    var model = Cache.integration_jira.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_jira.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Jira' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    migrateJiraOptions: function(text, done) {
        Modal.confirm(text, function() {
            done();
        }, this, 'Yes', undefined, 'secondary');
    },

    sendToJira: function(feedback_id) {
        var model = Cache.feedback.get(feedback_id);

        if (!model) {
            return;
        }

        var view = new View_Jira_Send({model: model});

        Modal.open({
            title_html: '<img src="/image/integration/jira.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    connectMonday: function(model_id, callback) {
        var connect_view = new View_Monday_Connect();

        var sidebar = Sidebar.open({
            title: 'Connect Monday',
            content: connect_view,
            theme: 'sidebar-sticky-bottom',
            onopen: function() {
                sidebar.find('form input:first').focus();
            },
            onclose: function() {
                connect_view.remove();
            }
        });

        sidebar.find('form').on('submit', function(e) {
            e.preventDefault();

            sidebar.find('button.primary').addClass('loading').prop('disabled', true);

            var form_data = Form.getData(sidebar.find('form'));

            Cache.app.request({
                action: 'integration/addConnectedApp',
                data: {...form_data, type: 'monday', app_id: model_id},
                success: (response) => {
                    if (model_id) {
                        Cache.connected_app_monday.get(model_id).set(response);

                        if (Cache.integration_monday.get('app_id') === model_id) {
                            Cache.integration_monday.set('is_disabled', false);
                        }
                    } else {
                        Cache.connected_app_monday.add(response);
                    }

                    UI.success('Monday account connected');

                    Sidebar.close();

                    if (callback) {
                        callback();
                    }
                },
                error: () => {
                    UI.error('Your Monday account couldn\'t be connected.');
                },
                complete: () => {
                    sidebar.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    activateMonday: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var edit_view;

        var apps = Cache.connected_app_monday.where({is_disabled: false});

        if (apps.length) {
            edit_view = new View_Monday_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: edit_view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    edit_view.remove();
                }
            });

            edit_view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            var connect_view = new View_Monday_Connect({
                submit_button: 'Next'
            });

            var sidebar = Sidebar.open({
                title: 'Step 1 - Connect to your Monday account',
                content: connect_view,
                theme: 'sidebar-sticky-bottom',
                onopen: function() {
                    sidebar.find('form input:first').focus();
                }
            });

            sidebar.find('form').on('submit', function(e) {
                e.preventDefault();
                sidebar.find('button.primary').addClass('loading').prop('disabled', true);

                var form_data = Form.getData(sidebar.find('form'));

                Cache.app.request({
                    action: 'integration/verifyMonday',
                    data: {
                        api_token: form_data.api_token
                    },
                    context: this,
                    success: function(response) {
                        if (response.verified) {
                            // after verified
                            var edit_view = new View_Monday_Edit({
                                is_new      : true,
                                monday_host : form_data.monday_host,
                                api_token   : form_data.api_token
                            });

                            Sidebar.setContent('');
                            Sidebar.setTitle('Step 2 - Monday Settings');

                            edit_view.render().$el.appendTo(sidebar.find('.sidebar-content'));

                            edit_view.on('submit:success', function() {
                                edit_view.remove();
                                Sidebar.close();
                            });
                        } else {
                            UI.error('Your Monday account couldn\'t be connected.');
                        }

                    },
                    complete: function() {
                        sidebar.find('button.primary').removeClass('loading').prop('disabled', false);
                    }
                });
            });
        }
    },

    deactivateMonday: function() {
        Modal.confirm('Are you sure you want to deactivate Monday?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'monday'
                },
                success: function() {
                    UI.success('Monday integration deactivated');

                    var model = Cache.integration_monday.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_monday.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Monday' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editMonday: function(monday_host, api_token) {
        var view = new View_Monday_Edit({
            is_new      : monday_host ? true : false,
            monday_host : monday_host,
            api_token   : api_token
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    sendToMonday: function(feedback_id) {
        var view = new View_Monday_Send({model: Cache.feedback.get(feedback_id)});

        var modal = Modal.open({
            title_html: '<img src="/image/integration/monday.png">',
            nopadding: true,
            onclose: function() {
                view.remove();
            }
        });

        view.render().$el.appendTo(modal.find('.modal-content'));

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },


    oauthZendesk: function(subdomain, callback) {
        Modals.oauthPopup('/oauth/zendesk/?step=auth&subdomain=' + encodeURIComponent(subdomain), 700, 700, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    connectZendesk: function(callback, app_id) {
        var form = '<form>' +
                        '<div class="form-label">Zendesk Support Host</div>' +
                        '<span class="form-field-inline">https://</span>' +
                        '<input class="form-field-inline" type="text" name="subdomain" style="width:200px;" maxlength="100" required>' +
                        '<span class="form-field-inline">.zendesk.com</span>' +
                    '</form>';

        var modal = Modal.open({
            width: 500,
            title: 'Activate Zendesk',
            content: form,
            button: {
                'Next': function(e, dialog) {
                    var subdomain = modal.find('input[name="subdomain"]').val().trim();

                    Modals.oauthZendesk(subdomain, (access_token) => {
                        Cache.app.request({
                            action: 'integration/addConnectedApp',
                            data: {
                                type          : 'zendesk',
                                access_token  : access_token,
                                app_id        : app_id, // existing oauth app_id for reconnect
                                app_host      : 'https://' + subdomain + '.zendesk.com'
                            },
                            success: (response) => {
                                Cache.connected_app_oauth.add(response);
                                callback(response.id);
                            }
                        });
                    });

                    Modal.close();
                }
            }
        });

        modal.find('input[name="subdomain"]').focus();

        modal.find('form').on('submit', function(e) {
            e.preventDefault();
            modal.find('.modal-button button').click();
        });
    },

    activateZendesk: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'zendesk', is_disabled: false});

        if (apps.length) {
            var view = new View_Zendesk_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.connectZendesk((app_id) => {
                this.editZendesk(app_id);
            });
        }
    },

    deactivateZendesk: function() {
        Modal.confirm('Are you sure you want to deactivate Zendesk?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'zendesk'
                },
                success: function() {
                    UI.success('Zendesk integration deactivated');

                    var model = Cache.integration_zendesk.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_zendesk.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Zendesk' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editZendesk: function(app_id) {
        var view = new View_Zendesk_Edit({
            is_new: app_id ? true : false,
            app_id: app_id
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    connectTeamwork: function(model_id, callback) {
        var connect_view = new View_Teamwork_Connect();

        var sidebar = Sidebar.open({
            title: 'Connect Teamwork',
            content: connect_view,
            theme: 'sidebar-sticky-bottom',
            onopen: function() {
                sidebar.find('form input:first').focus();
            },
            onclose: function() {
                connect_view.remove();
            }
        });

        sidebar.find('form').on('submit', function(e) {
            e.preventDefault();

            sidebar.find('button.primary').addClass('loading').prop('disabled', true);

            var form_data = Form.getData(sidebar.find('form'));

            Cache.app.request({
                action: 'integration/addConnectedApp',
                data: {...form_data, type: 'teamwork', app_id: model_id},
                success: (response) => {
                    if (model_id) {
                        Cache.connected_app_teamwork.get(model_id).set(response);

                        if (Cache.integration_teamwork.findWhere({project_id: Cache.default_project_id}).get('app_id') === model_id) {
                            Cache.integration_teamwork.findWhere({project_id: Cache.default_project_id}).set('is_disabled', false);
                        }
                    } else {
                        Cache.connected_app_teamwork.add(response);
                    }

                    UI.success('Teamwork account connected');

                    Sidebar.close();

                    if (callback) {
                        callback();
                    }
                },
                error: () => {
                    UI.error('Your teamwork account couldn\'t be connected.');
                },
                complete: () => {
                    sidebar.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    activateTeamwork: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var edit_view;

        var apps = Cache.connected_app_teamwork.where({is_disabled: false});

        if (apps.length) {
            edit_view = new View_Teamwork_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: edit_view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    edit_view.remove();
                }
            });

            edit_view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            var connect_view = new View_Teamwork_Connect({
                submit_button: 'Next'
            });

            var sidebar = Sidebar.open({
                title: 'Step 1 - Connect to your Teamwork account',
                content: connect_view,
                theme: 'sidebar-sticky-bottom',
                onopen: function() {
                    sidebar.find('form input:first').focus();
                }
            });

            sidebar.find('form').on('submit', function(e) {
                e.preventDefault();

                sidebar.find('button.primary').addClass('loading').prop('disabled', true);

                var form_data = Form.getData(sidebar.find('form'));

                Cache.app.request({
                    action: 'integration/verifyTeamwork',
                    data: form_data,
                    success: function(response) {
                        if (response.verified) {
                            // after verified
                            edit_view = new View_Teamwork_Edit({
                                is_new        : true,
                                teamwork_host : form_data.teamwork_host,
                                api_key       : form_data.api_key
                            });

                            Sidebar.setContent('');
                            Sidebar.setTitle('Step 2 - Choose a Task List');

                            edit_view.render().$el.appendTo(sidebar.find('.sidebar-content'));

                            edit_view.on('submit:success', function() {
                                edit_view.remove();
                                Sidebar.close();
                            });
                        } else {
                            UI.error('Your teamwork account couldn\'t be connected.');
                        }
                    },
                    error: function() {
                        sidebar.find('button:submit').removeClass('loading').prop('disabled', false);
                    }
                });
            });
        }
    },

    editTeamwork: function() {
        var view = new View_Teamwork_Edit({
            is_new        : false,
            teamwork_host : '',
            api_key       : ''
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    deactivateTeamwork: function() {
        Modal.confirm('Are you sure you want to deactivate Teamwork?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'teamwork'
                },
                success: function() {
                    UI.success('Teamwork integration deactivated');

                    var model = Cache.integration_teamwork.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_teamwork.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Teamwork' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    // Notion
    oauthNotion: function(callback) {
        Modals.oauthPopup('/oauth/notion/?step=auth', 800, 840, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token);
            } else if (event.data.error) {
                UI.error('Error: ' + event.data.error);
            } else {
                UI.error('Your Notion account couldn\'t be authorized, please try again.');
            }
        });
    },

    activateNotion: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'notion', is_disabled: false});

        if (apps.length) {
            var view = new View_Notion_Edit({
                is_new: true,
                app_id: apps[0].id
            });
            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });
            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthNotion((access_token) => {
                this.editNotion(access_token);
            });
        }
    },

    deactivateNotion: function() {
        Modal.confirm('Are you sure you want to deactivate Notion?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'notion'
                },
                success: function() {
                    UI.success('Notion integration deactivated');

                    var model = Cache.integration_notion.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_notion.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Notion' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editNotion: function(token) {
        var view = new View_Notion_Edit({
            is_new : token ? true : false,
            token  : token
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    sendToNotion: function(feedback_id) {
        var view = new View_Notion_Send({model: Cache.feedback.get(feedback_id)});

        var modal = Modal.open({
            title_html: '<img src="/image/integration/notion.png">',
            nopadding: true,
            onclose: function() {
                view.remove();
            }
        });

        view.render().$el.appendTo(modal.find('.modal-content'));

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    editTrello: function(token) {
        var view = new View_Trello_Edit({
            is_new : token ? true : false,
            token  : token
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    oauthTrello: function(callback) {
        Modals.oauthPopup('/oauth/trello/?step=auth', 800, 800, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    activateTrello: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_trello.where({is_disabled: false});

        if (apps.length) {
            var view = new View_Trello_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthTrello((token) => {
                this.editTrello(token);
            });
        }
    },

    deactivateTrello: function() {
        Modal.confirm('Are you sure you want to deactivate Trello?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'trello'
                },
                success: function() {
                    UI.success('Trello integration deactivated');

                    var model = Cache.integration_trello.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_trello.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Trello' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    sendToTrello: function(feedback_id) {
        var view = new View_Trello_Send({model: Cache.feedback.get(feedback_id)});

        Modal.open({
            title_html: '<img src="/image/integration/trello.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    oauthBasecamp: function(callback) {
        Modals.oauthPopup('/oauth/basecamp/?step=auth', 800, 800, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token, event.data.refresh_token, event.data.expires_at);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    activateBasecamp: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'basecamp', is_disabled: false});

        if (apps.length) {
            var view = new View_Basecamp_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthBasecamp((access_token, refresh_token, expires_at) => {
                this.editBasecamp(access_token, refresh_token, expires_at);
            });
        }
    },

    editBasecamp: function(access_token, refresh_token, expires_at) {
        var view = new View_Basecamp_Edit({
            is_new        : access_token ? true : false,
            access_token  : access_token,
            refresh_token : refresh_token,
            expires_at    : expires_at
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    deactivateBasecamp: function() {
        Modal.confirm('Are you sure you want to deactivate Basecamp?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'basecamp'
                },
                success: function() {
                    UI.success('Basecamp integration deactivated');

                    var model = Cache.integration_basecamp.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_basecamp.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Basecamp' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    oauthGithub: function(callback) {
        Modals.oauthPopup('/oauth/github/?step=auth', 700, 700, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    activateGithub: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'github', is_disabled: false});

        if (apps.length) {
            var view = new View_Github_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthGithub((access_token) => {
                this.editGithub(access_token);
            });
        }
    },

    editGithub: function(access_token) {
        var view = new View_Github_Edit({
            access_token: access_token,
            is_new: access_token ? true : false
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    deactivateGithub: function() {
        Modal.confirm('Are you sure you want to deactivate GitHub?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'github'
                },
                success: function() {
                    UI.success('GitHub integration deactivated');

                    var model = Cache.integration_github.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_github.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Github' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    sendToGithub: function(feedback_id) {
        var view = new View_Github_Send({model: Cache.feedback.get(feedback_id)});

        Modal.open({
            title_html: '<img src="/image/integration/github.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    oauthGitlab: function(callback) {
        Modals.oauthPopup('/oauth/gitlab/?step=auth', 800, 600, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token, event.data.refresh_token, event.data.expires_at);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    activateGitlab: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'gitlab', is_disabled: false});

        if (apps.length) {
            var view = new View_Gitlab_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthGitlab((access_token, refresh_token, expires_at) => {
                this.editGitlab(access_token, refresh_token, expires_at);
            });
        }
    },

    editGitlab: function(access_token, refresh_token, expires_at) {
        var view = new View_Gitlab_Edit({
            is_new        : access_token ? true : false,
            access_token  : access_token,
            refresh_token : refresh_token,
            expires_at    : expires_at
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    deactivateGitlab: function() {
        Modal.confirm('Are you sure you want to deactivate GitLab?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'gitlab'
                },
                success: function() {
                    UI.success('Gitlab integration deactivated');

                    var model = Cache.integration_gitlab.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_gitlab.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Gitlab' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    sendToGitlab: function(feedback_id) {
        var view = new View_Gitlab_Send({model: Cache.feedback.get(feedback_id)});

        Modal.open({
            title_html: '<img src="/image/integration/gitlab.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    oauthLinear: function(callback) {
        Modals.oauthPopup('/oauth/linear/?step=auth', 700, 700, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    oauthIntercom: function(callback) {
        // Intercom is different since we expect an app store install, so we will send them back to the installation url in a new tab
        const url = `${Cache.app.configs.api_host}intercom/install`;
        window.open(url);
    },

    activateLinear: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'linear', is_disabled: false});

        if (apps.length) {
            var view = new View_Linear_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthLinear((access_token) => {
                this.editLinear(access_token);
            });
        }
    },

    editLinear: function(access_token) {
        var view = new View_Linear_Edit({
            access_token: access_token,
            is_new: access_token ? true : false
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    deactivateLinear: function() {
        Modal.confirm('Are you sure you want to deactivate Linear?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'linear'
                },
                success: function() {
                    UI.success('Linear integration deactivated');

                    var model = Cache.integration_linear.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_linear.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Linear' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    sendToLinear: function(feedback_id) {
        var view = new View_Linear_Send({model: Cache.feedback.get(feedback_id)});

        var modal = Modal.open({
            title_html: '<img src="/image/integration/linear.png">',
            nopadding: true,
            onclose: function() {
                view.remove();
            }
        });

        view.render().$el.appendTo(modal.find('.modal-content'));

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    oauthAsana: function(callback) {
        Modals.oauthPopup('/oauth/asana/?step=auth', 800, 700, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token, event.data.refresh_token, event.data.expires_at);
            } else {
                UI.error('Error occurred, please try again.');
            }
        });
    },

    activateAsana: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'asana', is_disabled: false});

        if (apps.length) {
            var view = new View_Asana_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthAsana((access_token, refresh_token, expires_at) => {
                this.editAsana(access_token, refresh_token, expires_at);
            });
        }
    },

    deactivateAsana: function() {
        Modal.confirm('Are you sure you want to deactivate Asana?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'asana'
                },
                success: function() {
                    UI.success('Asana integration deactivated');

                    var model = Cache.integration_asana.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_asana.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Asana' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editAsana: function(access_token, refresh_token, expires_at) {
        var view = new View_Asana_Edit({
            is_new        : access_token ? true : false,
            access_token  : access_token,
            refresh_token : refresh_token,
            expires_at    : expires_at
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    sendToAsana: function(feedback_id) {
        var view = new View_Asana_Send({model: Cache.feedback.get(feedback_id)});

        Modal.open({
            title_html: '<img src="/image/integration/asana.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    sendToTeamwork: function (feedback_id) {
        var view = new View_Teamwork_Send({model: Cache.feedback.get(feedback_id)});

        var modal = Modal.open({
            title_html: '<img src="/image/integration/teamwork.png">',
            nopadding: true,
            onclose: function() {
                view.remove();
            }
        });

        view.render().$el.appendTo(modal.find('.modal-content'));

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    sendToClickup: function(feedback_id) {
        var view = new View_Clickup_Send({model: Cache.feedback.get(feedback_id)});

        Modal.open({
            title_html: '<img src="/image/integration/clickup.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    oauthClickup: function(callback) {
        Modals.oauthPopup('/oauth/clickup/?step=auth', 500, 700, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token);
            } else if (event.data.error) {
                UI.error('Error: ' + event.data.error);
            } else {
                UI.error('Your ClickUp account couldn\'t be authorized, please try again.');
            }
        });
    },

    activateClickup: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'clickup', is_disabled: false});

        if (apps.length) {
            var view = new View_Clickup_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthClickup((access_token) => {
                this.editClickup(access_token);
            });
        }
    },

    editClickup: function(access_token) {
        var view = new View_Clickup_Edit({
            is_new: access_token ? true : false,
            access_token: access_token
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    deactivateClickup: function() {
        Modal.confirm('Are you sure you want to deactivate ClickUp?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'clickup'
                },
                success: function() {
                    UI.success('ClickUp integration deactivated');

                    var model = Cache.integration_clickup.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_clickup.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Clickup' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    oauthWrike: function(callback) {
        Modals.oauthPopup('/oauth/wrike/?step=auth', 650, 750, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token, event.data.refresh_token, event.data.expires_at, event.data.wrike_host);
            } else if (event_data.error) {
                UI.error('Error: ' + error_data.error);
            } else {
                UI.error('Your Wrike account couldn\'t be authorized, please try again.');
            }
        });
    },

    activateWrike: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'wrike', is_disabled: false});

        if (apps.length) {
            var view = new View_Wrike_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthWrike((access_token, refresh_token, expires_at, wrike_host) => {
                this.editWrike(access_token, refresh_token, expires_at, wrike_host);
            });
        }
    },

    deactivateWrike: function() {
        Modal.confirm('Are you sure you want to deactivate Wrike?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'wrike'
                },
                success: function() {
                    UI.success('Wrike integration deactivated');

                    var model = Cache.integration_wrike.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_wrike.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Wrike' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editWrike: function(access_token, refresh_token, expires_at, wrike_host) {
        var view = new View_Wrike_Edit({
            is_new        : access_token ? true : false,
            wrike_host    : wrike_host,
            access_token  : access_token,
            refresh_token : refresh_token,
            expires_at    : expires_at
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    sendToWrike: function(feedback_id) {
        var view = new View_Wrike_Send({model: Cache.feedback.get(feedback_id)});

        Modal.open({
            title_html: '<img src="/image/integration/wrike.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    oauthAzureDevops: function(callback) {
        Modals.oauthPopup('/oauth/azure_devops/?step=auth', 800, 840, (event) => {
            if (event.data.access_token) {
                callback(event.data.access_token, event.data.refresh_token, event.data.expires_at);
            } else {
                UI.error('Your Azure DevOps account couldn\'t be authorized, please try again.');
            }
        });
    },

    activateAzureDevops: function() {
        if (!Cache.app.isAdmin()) {
            Modal.open({
                title: 'Admin required',
                content: 'You\'ll need to ask an account admin to enable this integration.',
                button: {
                    OK: () => {
                        Modal.close();
                    }
                }
            });
            return;
        }

        var apps = Cache.connected_app_oauth.where({app_type: 'azure_devops', is_disabled: false});

        if (apps.length) {
            var view = new View_Azure_Devops_Edit({
                is_new: true,
                app_id: apps[0].id
            });

            Sidebar.open({
                title: 'Integration Settings',
                content: view,
                theme: 'sidebar-sticky-bottom',
                onclose: function() {
                    view.remove();
                }
            });

            view.on('submit:success', function() {
                Sidebar.close();
            });
        } else {
            this.oauthAzureDevops((access_token, refresh_token, expires_at) => {
                this.editAzureDevops(access_token, refresh_token, expires_at);
            });
        }
    },

    deactivateAzureDevops: function() {
        Modal.confirm('Are you sure you want to deactivate Azure DevOps?', function() {
            Cache.app.request({
                action: 'integration/deactivate',
                data: {
                    type: 'azure_devops'
                },
                success: function() {
                    UI.success('Azure DevOps integration deactivated');

                    var model = Cache.integration_azure_devops.findWhere({project_id: Cache.default_project_id});
                    Cache.integration_azure_devops.remove(model);

                    Cache.app.trackEvent('Integration Removed', { integration: 'Azure' });
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    editAzureDevops: function(access_token, refresh_token, expires_at) {
        var view = new View_Azure_Devops_Edit({
            is_new        : access_token ? true : false,
            access_token  : access_token,
            refresh_token : refresh_token,
            expires_at    : expires_at
        });

        Sidebar.open({
            title: 'Integration Settings',
            content: view,
            theme: 'sidebar-sticky-bottom',
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            Sidebar.close();
        });
    },

    sendToAzureDevops: function(feedback_id) {
        var view = new View_Azure_Devops_Send({model: Cache.feedback.get(feedback_id)});

        Modal.open({
            title_html: '<img src="/image/integration/azure_devops.png">',
            nopadding: true,
            content: view,
            onclose: function() {
                view.remove();
            }
        });

        view.on('submit:success', function() {
            view.remove();
            Modal.close();
        });
    },

    toggleQueueMonitor: function(queue_name, queue_status, callback) {
        var action = queue_status === Constants.QUEUE_MONITOR_RUNNING ? 'on' : 'off';

        Cache.app.request({
            action: 'admin/toggleQueueMonitor',
            data: {
                queue_name: queue_name,
                queue_status: action
            },
            success: function(response) {
                callback();
                UI.success('"' + queue_name + '" queue process turned ' + action);
            }
        });
    },

    changePaymentMethod: function(invoice_id) {
        var amount = 0;

        if (invoice_id) {
            var invoice = Cache.invoice.get(invoice_id);
            amount  = invoice.get('amount') / 100;
        }

        var upgrade_form = '<div class="margin-20 margin-0-phone overflow-hidden">' +
                            '<div class="grid-6">' +
                                '<form class="compact margin-right-40 margin-0-phone">' +
                                    '<div>' +
                                        '<span class="helper">Credit Card Number <i class="tooltip fas fa-exclamation-triangle" style="display:none;"></i></span>' +
                                        '<input type="text" name="number" class="compact" maxlength="255" placeholder="xxxx xxxx xxxx xxxx" required autofocus>' +
                                    '</div>' +
                                    '<div>' +
                                        '<span class="helper">Name on Card <i class="tooltip fas fa-exclamation-triangle" style="display:none;"></i></span>' +
                                        '<input type="text" name="name" class="compact" maxlength="255" placeholder="' + Cache.getRealUser().escape('name') + '" required>' +
                                    '</div>' +
                                    '<div class="grid-6 grid-fixed">' +
                                        '<div class="row">' +
                                            '<span class="helper">Expiry Date <i class="tooltip fas fa-exclamation-triangle" style="display:none;"></i></span>' +
                                            '<input type="text" name="expiry" class="compact" maxlength="255" placeholder="MM/YY" required>' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="grid-6 grid-fixed">' +
                                        '<div class="row margin-left-20">' +
                                            '<span class="helper">CVC <i class="tooltip fas fa-exclamation-triangle" style="display:none;"></i></span>' +
                                            '<input type="text" name="cvc" class="compact" data-validation="string" maxlength="255" placeholder="3 or 4 digits" required>' +
                                        '</div>' +
                                    '</div>' +
                                    '<button class="success full margin-top-0">' + (amount ? 'Pay $' + amount.toFixed(2) : 'Update') + '</button>' +
                                '</form>' +
                                '<div class="text-align-center margin-top-40 phone-only">' +
                                    '<div class="font-weight-medium text-success"><i class="fad fa-shield-check"></i> Secure credit card payment</div>' +
                                    '<div class="info margin-top-4">This is a secure 128-bit SSL encrypted payment</div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="grid-6 phone-hidden">' +
                                '<div class="card-wrapper"></div>' +
                                '<div class="text-align-center margin-top-40">' +
                                    '<div class="font-weight-medium text-success"><i class="fad fa-shield-check"></i> Secure credit card payment</div>' +
                                    '<div class="info margin-top-4">This is a secure 128-bit SSL encrypted payment</div>' +
                                '</div>' +
                            '</div>' +
                            '</div>';

        var modal = Modal.open({
            title: 'Credit Card Details',
            content: upgrade_form,
            width: 750,
            onclose: function() {
                Tooltip.removeAll();
            }
        });

        Form.setPlaceholder(modal.find('form'));
        modal.find('input[name="number"]').focus();

        var credit_card_form = modal.find('form');

        window.jQuery = $;
        var card = new Card({
            debug: true,
            form: credit_card_form.get(0),
            container: '.card-wrapper',
            formatting: true
        });

        if (typeof Stripe === 'undefined') {
            var script = document.createElement('script');
            script.src = 'https://js.stripe.com/v2/';
            document.head.appendChild(script);
        }

        credit_card_form.on('submit', function(e) {
            e.preventDefault();

            if (typeof Stripe === 'undefined') {
                UI.error('Failed to load Stripe payment. Please refresh the page and try again.');
                return;
            }

            credit_card_form.find('button').addClass('loading').prop('disabled', true);
            credit_card_form.find('input[name="number"]').prev('span').children('i').hide().trigger('mouseleave');
            credit_card_form.find('input[name="expiry"]').prev('span').children('i').hide().trigger('mouseleave');
            credit_card_form.find('input[name="cvc"]').prev('span').children('i').hide().trigger('mouseleave');

            var form_data = Form.getData(credit_card_form);
            form_data.number = form_data.number.toString().replace(/ /g, '');

            var exp_month = 0;
            var exp_year  = 0;

            if (form_data.expiry.toString().split('/').length === 2) {
                exp_month = form_data.expiry.toString().split('/')[0].trim();
                exp_year  = form_data.expiry.toString().split('/')[1].trim();
            }

            credit_card_form.find('i.fa').hide().trigger('mouseleave');
            credit_card_form.find('input.invalid').removeClass('invalid');

            Stripe.setPublishableKey(Cache.app.configs.stripe_publishable_key);
            Stripe.createToken({
                number    : form_data.number,
                exp_month : exp_month,
                exp_year  : exp_year,
                cvc       : form_data.cvc
            }, function(status, response) {
                if (status == 200) {
                    if (!response.id) {
                        UI.error('Credit card token failed to create. Please refresh and try again.');
                    }

                    Cache.app.request({
                        action: 'account/updatePaymentMethod',
                        data : {
                            invoice_id        : invoice_id ? invoice_id : 0,
                            source            : response.id,
                            name              : form_data.name,
                            credit_card_digit : form_data.number.slice(form_data.number.length - 4, form_data.number.length)
                        },
                        success: function(response) {
                            Modal.close();

                            Cache.account.set({
                                'credit_card_digit': form_data.number.slice(form_data.number.length - 4, form_data.number.length)
                            });

                            if (invoice_id) {
                                Cache.invoice.get(invoice_id).set({
                                    status: Constants.PAID,
                                    paid_time: new Date().getTime() / 1000
                                });
                                UI.success('Invoice has been paid successfully');
                            } else {
                                UI.success('Credit card detais updated');
                            }
                        },
                        error: function() {
                            UI.error('Credit Card declined, please check your Credit Card details and try again.');
                        },
                        complete: function() {
                            credit_card_form.find('button').removeClass('loading').prop('disabled', false);
                        }
                    });
                } else {
                    if (response.error) {
                        credit_card_form.find('button').removeClass('loading').prop('disabled', false);

                        switch (response.error.param) {
                            case 'number':
                                credit_card_form.find('input[name="number"]').addClass('invalid').select();
                                credit_card_form.find('input[name="number"]').prev('span').children('i').data('title', response.error.message).show().trigger('mouseenter');
                                break;
                            case 'exp_month':
                            case 'exp_year':
                                credit_card_form.find('input[name="expiry"]').addClass('invalid').select();
                                credit_card_form.find('input[name="expiry"]').prev('span').children('i').data('title', response.error.message).show().trigger('mouseenter');
                                break;
                            case 'cvc':
                                credit_card_form.find('input[name="cvc"]').addClass('invalid').select();
                                credit_card_form.find('input[name="cvc"]').prev('span').children('i').data('title', response.error.message).show().trigger('mouseenter');
                                break;
                        }

                        if (response.error.code) {
                            switch (response.error.code) {
                                case 'card_declined':
                                    UI.error('Credit Card declined, please check your Credit Card details and try again.');
                                    break;
                                case 'incorrect_cvc':
                                    UI.error('Incorrect CVC, please check your Credit Card details and try again.');
                                    break;
                                case 'expired_card':
                                    UI.error('Credit Card expired, please check your Credit Card details and try again.');
                                    break;
                                case 'processing_error':
                                    UI.error('Processing error, please check your Credit Card details and try again.');
                                    break;
                            }
                        }
                    } else {
                        UI.error('Credit card token failed to create. Please refresh and try again.');
                    }
                }
            });
        });
    },

    withdrawReferralFee: function() {
        if (!Cache.app.isAdmin()) {
            UI.error('Please log in as an Admin');
            return;
        }

        if (Cache.account.get('referral_balance') <= 0) {
            var modal = Modal.open({
                title: 'Withdraw Referral Credit',
                content: 'Oops. Your referral balance is <b>$0.00</b>. To earn more referral credit you will need to invite more friends to join Userback with your <a href="#" class="referral-link">referral link</a>.',
                button: {
                    'OK': function() {
                        Modal.close();
                    }
                }
            });

            modal.find('a.referral-link').on('click', function(e) {
                e.preventDefault();
                Modals.referAccount();
            });

            return;
        }

        if (!Cache.app.isOwner()) {
            Modal.open({
                title: 'Withdraw Referral Credit',
                content: 'PayPal transfer is only available to account owner.',
                button: {
                    OK: function() {
                        Modal.close();
                    }
                }
            });

            return;
        }

        var modal = Modal.open({
            title: 'Withdraw Referral Credit',
            content : '<p>Please enter your PayPal email address for us to transfer <b>$' + (Cache.account.get('referral_balance') / 100).toFixed(2) + '</b> referral credit.</p>' +
                        '<form>' +
                            '<div>' +
                                '<span class="helper placeholder">PayPal Email</span>' +
                                '<input type="email" name="email" maxlength="255" required autofocus>' +
                            '</div>' +
                            '<button type="submit" class="hidden"></button>' +
                        '</form>',
            button: {
                'Submit': function() {
                    modal.find('form button[type="submit"]').click();
                }
            }
        });

        modal.find('form input').focus();

        modal.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData(modal.find('form'));

            modal.find('.modal-button button').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'account/withdrawReferralFeeToPaypal',
                data: {
                    amount: Cache.account.get('referral_balance'),
                    email: form_data.email
                },
                success: function(response) {
                    Modal.close();

                    Cache.account.set({
                        referral_balance: response.referral_balance
                    });

                    Cache.referral_invoice.reset(response.transactions);
                    UI.success('Referral Credit has been transferred to your PayPal account');
                },
                complete: function() {
                    modal.find('.modal-button button').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    cancelPlanChange: function() {
        var modal = Modal.confirm('Are you sure you want cancel the plan change?', function() {
            modal.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'account/cancelPlanChange',
                data: {},
                success: function(response) {
                    Modal.close();

                    Cache.account.set('plan_provision', undefined);
                    UI.success('Account plan change has been cancelled');
                },
                complete: function() {
                    modal.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    viewInvoice: function(invoice_id) {
        var modal = Sidebar.open({
            title: 'Invoice #' + invoice_id,
            content: '<iframe></iframe>' +
                     '<div class="mask-light loader"></div>' +
                     '<button class="tertiary small print" style="position:absolute;top:20px;right:80px;"><i class="fas fa-print"></i> Print</button>',
            width: 950,
            nopadding: true
        });

        modal.find('.print').on('click', function() {
            var iframe = modal.find('iframe').get(0);
            iframe = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
            iframe.window.print();
        });

        Cache.app.request({
            action: 'invoice/view',
            data: {
                id: invoice_id
            },
            success: (response) => {
                modal.find('.mask-light').remove();

                var iframe = modal.find('iframe').get(0);
                iframe = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
                iframe.document.open();
                iframe.document.write(response);
                iframe.document.close();
            },
            error: () => {
                UI.error('The invoice could not be found.');
            }
        });
    },

    payInvoice: function(invoice_id) {
        this.changePaymentMethod(invoice_id);
    },

    warnOverdueInvoice: function() {
        Modal.open({
            notitle: true,
            close: Cache.account.get('overdue_days') >= 7 ? false : true,
            content: '<div class="error-dialog">' +
                            '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                            '<h3> Overdue invoice</h3>' +
                            '<p class="info large">There is an overdue invoice in your account, please pay it immediately to avoid account suspension.</p>' +
                            '<button class="primary large navigation" href="/account/billing">Pay my invoice</button>' +
                        '</div>'
        });
    },

    sendEmailConfirmation: function(message) {
        message = message || 'Before activating notifications';

        var email_address, action;

        if (Cache.real_user_id) {
            email_address = Cache.getRealUser().get('email');
            action        = 'user/sendEmailConfirmation';
        } else if (Cache.portal_user) {
            email_address = Cache.portal_user.get('email');
            action        = 'portal_user/sendEmailConfirmation';
        }

        var modal = Modal.open({
            title: 'Verify Email Address',
            content: message + ', you need to confirm your email address by clicking the link we sent to <b>' + email_address + '</b>.',
            button: {
                'Resend confirmation email': function() {
                    modal.find('.modal-button button.primary').addClass('loading').prop('disabled', true);

                    Cache.app.request({
                        action: action,
                        success: function() {
                            Modal.close();
                            UI.success('A confirmation link has been sent to ' + email_address);
                        },
                        complete: function() {
                            modal.find('.modal-button button.primary').removeClass('loading').prop('disabled', false);
                        }
                    });
                }
            }
        });
    },

    sendBrandingEmailConfirmation: function(email) {
        Modal.open({
            title: 'Verify my Email Address',
            content: 'Before the sender email can be used, you need to confirm the email address by clicking the link we sent to <b>' + email + '</b>.',
            button: {
                'Resend confirmation email': function() {
                    Modal.close();

                    Cache.app.request({
                        action: 'branding/sendEmailConfirmation'
                    });

                    UI.success('A confirmation link has been sent to ' + email);
                }
            }
        });
    },

    addRecordingRule: function(project_id) {
        var html = '';

        html += '<form class="form-fluid">' +
                    '<button type="submit" class="hidden"></button>' +
                    '<div class="row">' +
                        '<div class="field-label">Selector</div>' +
                        '<input type="text" class="solid medium" name="selector" placeholder=".userback-ignore" maxlength="60" required>' +
                    '</div>' +
                '</form>';

        var modal = Modal.open({
            title: 'New Rule',
            content: html,
            button: {
                'Save': function() {
                    modal.find('button:submit').click();
                }
            }
        });

        var form = modal.find('form');

        form.find('input[name="selector"]').focus();

        form.on('submit', function(e) {
            var selector = Form.getData(form)['selector'];

            try {
                document.querySelector(selector);
            } catch(e) {
                UI.error('Please enter a valid CSS selector');
                return;
            }

            Cache.app.request({
                action:  'project_recording_rule/add',
                data: {
                    project_id: project_id,
                    selector: selector
                },
                success: function(response) {
                    Cache.project_recording_rule.add(response);
                    UI.success('Screenshot rule added.');

                    Modal.close();
                },
                complete: function() {
                    form.find('.modal-button button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    // account session recording rules
    editSessionRecordingRule: function(rule_type) {
        if (rule_type === 'block' || rule_type === 'ignore') {
            var content =
            '<form class="form-fluid">' +
                '<button type="submit" class="hidden"></button>' +
                '<div>' +
                    '<div class="field-label">Class Name</div>' +
                    '<input type="text" class="solid medium" name="selector" placeholder=".userback-' + rule_type + '" maxlength="60" required>' +
                '</div>' +
            '</form>';

            var recording_rule = Cache.session_recording_rule.findWhere({rule_type: rule_type});
            var selector = '';
            if (recording_rule) {
                selector = recording_rule.get('selector');
            }

            var modal = Modal.open({
                title: Util.cap(rule_type) + ' Rule',
                content: content,
                button: {
                    Save: () => {
                        modal.find('button:submit').click();
                    }
                }
            });

            var $form = modal.find('form');

            Form.setData($form, {
                selector: selector
            });

            modal.find('input:first').focus();

            $form.on('submit', function(e) {
                var class_name = Form.getData($form)['selector'].replace(/[^A-Za-z0-9_-]/g, '');

                if (class_name.charAt(0) !== '.') {
                    class_name = '.' + class_name;
                }

                Cache.app.request({
                    action: 'session_recording_rule/update',
                    data: {
                        rule_type : rule_type,
                        selectors : [class_name]
                    },
                    success: (response) => {
                        Cache.session_recording_rule.reset(response);
                        UI.success(Util.cap(rule_type) + ' rule updated');
                    }
                });

                Modal.close();
            });
        } else if (rule_type === 'mask') {
            var selectors_available = [
                'textarea',
                'input[type="password"]',
                'input[type="email"]',
                'input[type="text"]',
                'input[type="color"]',
                'input[type="date"]',
                'input[type="datetime-local"]',
                'input[type="month"]',
                'input[type="number"]',
                'input[type="range"]',
                'input[type="search"]',
                'input[type="tel"]',
                'input[type="time"]',
                'input[type="url"]',
                'input[type="week"]'
            ];

            var selector_html = '';

            selectors_available.forEach((option)  => {
                selector_html +=
                '<div class="flex-between">' +
                    '<span class="text-code text-small font-weight-semibold">' + option + '</span>' +
                    '<button type="button" class="' + (Cache.session_recording_rule.findWhere({rule_type: 'mask', selector: option}) ? 'switch-on' : 'switch-off') + ' fields-toggle small"></button>' +
                '</div>';
            });

            var content =
                '<p>Select what fields to mask</p>' +
                '<div class="box-small-large overflow-auto grid-gap-16" style="height:420px;">' + selector_html + '</div>';

            var modal = Modal.open({
                title: 'Mask Rule',
                width: 500,
                content: content
            });

            modal.find('.fields-toggle').on('click', function(e) {
                var selector = $(e.currentTarget).prev('.text-code').text();

                if ($(this).hasClass('switch-on')) {
                    $(this).removeClass('switch-on').addClass('switch-off');

                    Cache.app.request({
                        action: 'session_recording_rule/delete',
                        data: {
                            rule_type: 'mask',
                            selector: selector
                        },
                        success: () => {
                            var model = Cache.session_recording_rule.findWhere({
                                rule_type: 'mask',
                                selector: selector
                            });
                            Cache.session_recording_rule.remove(model);
                        }
                    });
                } else {
                    $(this).removeClass('switch-off').addClass('switch-on');

                    Cache.app.request({
                        action: 'session_recording_rule/add',
                        data: {
                            rule_type: 'mask',
                            selector: selector
                        },
                        success: (response) => {
                            Cache.session_recording_rule.add(response);
                        }
                    });
                }

                UI.success('Mask rule updated!');
            });
        }
    },

    // project recording rules
    editRecordingRule: function(project_id, rule_type, rule_id) {
        var html = '';
        var selector = '';
        var modal_title = 'Edit Recording Rule';
        var recording_model;

        if (rule_type === 'ignore' || rule_type === 'block') {
            recording_model  = Cache.project_recording_rule.findWhere({project_id: project_id, rule_type: rule_type});
            selector         = recording_model ? recording_model.get('selector') : '';
            modal_title      = rule_type === 'block' ? 'Block Rule' : 'Ignore Rule';

            html += '<form class="form-fluid">' +
                        '<button type="submit" class="hidden"></button>' +
                        '<div>' +
                            '<div class="field-label">Class Name</div>' +
                            '<input type="text" class="solid medium" name="selector" placeholder=".userback-' + rule_type + '" maxlength="60" required>' +
                        '</div>' +
                    '</form>';
        } else if (rule_type === 'mask') {
            modal_title = 'Mask Rule';

            var selectors_available = [
                'textarea',
                'input[type="password"]',
                'input[type="email"]',
                'input[type="text"]',
                'input[type="color"]',
                'input[type="date"]',
                'input[type="datetime-local"]',
                'input[type="month"]',
                'input[type="number"]',
                'input[type="range"]',
                'input[type="search"]',
                'input[type="tel"]',
                'input[type="time"]',
                'input[type="url"]',
                'input[type="week"]'
                //'select'
            ];

            var selector_html = '';

            selectors_available.forEach(function(option) {
                selector_html += '<div class="padding-top-8 padding-bottom-8 solid-line-bottom">' +
                                        '<span class="code-selector-medium">' + option + '</span>' +
                                        '<button type="button" class="' + (Cache.project_recording_rule.findWhere({project_id: project_id, rule_type: 'mask', selector: option}) ? 'switch-on' : 'switch-off') + ' field-toggle small float-right"></button>' +
                                    '</div>';
            });

            html += '<form class="form-fluid">' +
                        '<button type="submit" class="hidden"></button>' +
                        '<div>' +
                            '<div class="field-label">Select what fields to mask</div>' +
                            '<div class="solid-line-top">' + selector_html + '</div>' +
                        '</div>' +
                    '</form>';
        } else if (rule_type === 'screenshot') {
            recording_model  = Cache.project_recording_rule.get(rule_id);
            selector         = recording_model ? recording_model.get('selector') : '';
            modal_title      = 'Edit Screenshot Rule';

            html += '<form class="form-fluid">' +
                        '<button type="submit" class="hidden"></button>' +
                        '<div>' +
                            '<div class="field-label">Selector</div>' +
                            '<input type="text" class="solid medium" name="selector" placeholder=".userback-ignore" maxlength="60" required>' +
                        '</div>' +
                    '</form>';
        }

        var modal = Modal.open({
            title: modal_title,
            content: html,
            inner_scroll: true,
            button: {
                'Save': function() {
                    modal.find('button:submit').click();
                }
            },
            text_link: rule_type === 'screenshot' ? {
                'Delete': function(e) {
                    Modal.confirm('Are you sure you want to delete the screenshot rule?', function() {
                        Cache.app.request({
                            action:  'project_recording_rule/delete',
                            data: {
                                id: recording_model.id
                            },
                            success: function() {
                                Cache.project_recording_rule.remove(recording_model);
                                Modal.close();

                                UI.success('Screenshot rule deleted.');
                            }
                        });
                    }, this, 'Yes, delete', undefined, 'secondary');
                }
            } : null
        });

        var form = modal.find('form');

        if (rule_type === 'ignore' || rule_type === 'block' || rule_type === 'screenshot') {
            Form.setData(form, {
                selector: selector
            });

            form.find('input[name="selector"]').focus();
        }

        form.find('.field-toggle').on('click', function() {
            if ($(this).hasClass('switch-on')) {
                $(this).removeClass('switch-on').addClass('switch-off');
            } else {
                $(this).removeClass('switch-off').addClass('switch-on');
            }
        });

        form.on('submit', function(e) {
            var selector = [];
            var screenshot_rule = '';

            if (rule_type === 'ignore' || rule_type === 'block') {
                var class_name = Form.getData(form)['selector'].replace(/[^A-Za-z0-9_-]/g, '');

                if (class_name.charAt(0) !== '.') {
                    class_name = '.' + class_name;
                }

                selector.push(class_name);
            } else if (rule_type === 'screenshot') {
                try {
                    document.querySelector(Form.getData(form)['selector']);
                } catch(e) {
                    UI.error('Please enter a valid CSS selector');
                    return;
                }

                screenshot_rule = Form.getData(form)['selector'];
            } else {
                form.find('button.switch-on').each(function() {
                    selector.push($(this).prev('.code-selector-medium').text());
                });
            }

            form.find('.modal-button button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action:  rule_type === 'screenshot' ? 'project_recording_rule/updateScreenshot' : 'project_recording_rule/updateSessionRecording',
                data: rule_type === 'screenshot' ? {id: rule_id, selector : screenshot_rule} : {rule_type: rule_type, selector : selector},
                success: function(response) {
                    if (rule_type === 'screenshot') {
                        var recording_model  = Cache.project_recording_rule.get(rule_id);

                        if (recording_model) {
                            recording_model.set(response);
                        }
                    } else {
                        Cache.project_recording_rule.where({
                            project_id: project_id,
                            rule_type: rule_type
                        }).forEach(function(model) {
                            Cache.project_recording_rule.remove(model);
                        });

                        Cache.project_recording_rule.add(response);
                    }

                    if (rule_type === 'screenshot') {
                        UI.success('Screenshot rule saved.');
                    } else {
                        UI.success('Recording rule saved.');
                    }

                    Modal.close();
                },
                complete: function() {
                    form.find('.modal-button button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    editWorkflow: function() {
        if (Cache.account.get('is_expired')) {
            Modals.expiredAccount();
            return;
        }

        Modals.projectSettings(Cache.default_project_id, 'workflow');
    },

    deleteWorkflow: function(workflow_id) {
        var workflow_model = Cache.workflow.get(workflow_id);

        Modal.confirm('Are you sure you want to delete the status "<b>' + workflow_model.escape('name') + '"</b>? Feedback in the status will be deleted too.', function() {
            Cache.feedback.where({workflow: workflow_id}).forEach(function(feedback_model) {
                Cache.feedback_comment.remove(Cache.feedback_comment.where({feedback_id: feedback_model.id}));
                Cache.feedback_screenshot.remove(Cache.feedback_screenshot.where({feedback_id: feedback_model.id}));
                Cache.feedback_approver.remove(Cache.feedback_approver.where({feedback_id: feedback_model.id}));

                Cache.feedback.remove(feedback_model);
            });

            Cache.workflow.remove(workflow_model);

            Cache.app.request({
                action:  'workflow/delete',
                data: {
                    workflow_id: workflow_id
                },
                context: this,
                success: function(response) {
                    UI.success('Status deleted');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    viewZapierTemplates: function() {
        var modal = Modal.open({
            width: 800,
            nopadding: true,
            title: 'Zapier Templates',
            content: '<iframe style="height:calc(100vh - 280px);"></iframe>' +
                        '<div class="mask-light loader"></div>'
        });

        setTimeout(function() {
            modal.find('.mask-light').remove();

            var iframe = modal.find('iframe').get(0);
            iframe = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
            iframe.document.open();
            iframe.document.write('<style>body {padding:20px;}</style>' +
                                    '<script src="https://zapier.com/apps/embed/widget.js?services=userback&limit=12"></script>');
            iframe.document.close();
        }, 500);
    },

    deleteSessionRecording: function(session_recording_ids, success) {
        Modal.open({
            title: 'Delete Session Replay',
            content: session_recording_ids.length > 1 ?
                'Are you sure you want to delete the selected session replays?' :
                'Are you sure you want to delete this session replay?',
            button_class: 'secondary',
            button: {
                'Yes, delete': (e, modal) => {
                    modal.find('.modal-button button').prop('disabled', true).addClass('loading');

                    Cache.app.request({
                        action: 'session_recording/delete',
                        data: {
                            ids: session_recording_ids
                        },
                        success: () => {
                            Modal.close();
                            Cache.session_recording.remove(session_recording_ids);
                            UI.success('Session replay' + (session_recording_ids.length === 1 ? '' : 's') + ' deleted');

                            if (success) {
                                success();
                            }
                        },
                        complete: () => {
                            modal.find('.modal-button button').prop('disabled', false).removeClass('loading');
                        }
                    });
                }
            }
        });
    },

    openSessionRecording: function(session_recording_id, start_timestamp, open_devtools) {
        var session_player = new View_Session_Player({
            session_recording_id : session_recording_id,
            auto_load            : true,
            show_dev_tools       : true,
            show_events          : true,
            show_close           : true,
            show_share           : true,
            show_tag             : true,
            start_timestamp      : start_timestamp,
            open_devtools: open_devtools,
        });

        var overlay = $('<div>').addClass('session-player-overlay overlay').appendTo($(document.body));

        session_player.render().$el.appendTo(overlay);

        session_player.on('close', function() {
            overlay.remove();
        });

        return session_player;
    },

    editSessionTag: function(session_recording_model, session_tags) {
        var view = new View_Session_Replay_Tags({
            model: session_recording_model,
            session_tags: session_tags,
        });

        Modal.open({
            title: 'Tag Session',
            content: view,
            button: {
                Save: function() {
                    view.trigger('submit');
                    Modal.close();
                }
            }
        });
    },

    openSurveyResponse: function(response_model, user_data, model_list) {
        if (Cache.account.get('is_expired')) {
            Modals.expiredAccount();
            return;
        }

        if (response_model.isExpired()) {
            Modals.expiredSurvey();
            return;
        }

        if (this.survey_response_sidebar_view) {
            this.survey_response_sidebar_view.remove();
        }

        this.survey_response_sidebar_view = new View_Survey_Response_Sidebar({
            model: response_model,
            user_data: user_data,
            model_list: model_list
        });

        this.survey_response_sidebar_view.render().$el.appendTo($(document.body));

        this.survey_response_sidebar_view.on('remove', () => {
            this.survey_response_sidebar_view = undefined;
        });
    },

    openFeedbackSidebar: function(feedback_id, layout, hide_expand) {
        var feedback_model = Cache.feedback.get(feedback_id);

        if (Cache.account.get('is_expired')) {
            Modals.expiredAccount();
            return;
        }

        if (feedback_model && feedback_model.isExpired()) {
            Modals.expiredFeedback();
            return;
        }

        if (this.feedback_sidebar_view) {
            this.feedback_sidebar_view.remove();
        }

        this.feedback_sidebar_view = new View_Feedback_Sidebar({
            feedback_id  : feedback_id,
            layout       : layout,
            hide_expand  : hide_expand,
        });

        this.feedback_sidebar_view.render().$el.appendTo($(document.body));

        this.feedback_sidebar_view.on('remove', () => {
            this.feedback_sidebar_view = undefined;
            Router.removeQueryString('feedback_id', {trigger: false});
        });

        this.feedback_sidebar_view.on('feedback:expired', () => {
            Modals.expiredFeedback();
        });

        Router.addQueryString('feedback_id', feedback_id, {trigger: false});
    },

    openDevtools: function(model) {
        var view = new View_Dev_Tools({
            feedback_id: model.id,
            show_event: true,
            open_by_default: true,
        });

        var bar = Bottombar.open({
            content: view,
            classname: 'region-devtools',
            draggable: true,
        });

        bar.addClass('bottombar-devtools');
    },

    openIntegrationLogSidebar: function(model) {
        var view = new View_Integration_Log_Sidebar({model: model});

        var on_remove = function() {
            Sidebar.close();
        };

        Sidebar.open({
            html_title: 'Log Details',
            content: view,
            width: 480,
            onclose: function() {
                view.stopListening(model, 'remove', on_remove);
                view.remove();
            },
            onopen: function() {
                view.listenTo(model, 'remove', on_remove);
            }
        });
    },

    openFeedbackEmail: function(feedback_id) {
        var modal = Modal.open({
            title: 'Original Email',
            width: 800,
            nopadding: true,
            content: '<div class="modal-feedback-email-source loader"></div>'
        });

        var showError = function() {
            var iframe = $('<iframe sandbox>').get(0);
            iframe.srcdoc = 'Original email not found.';
            modal.find('.modal-feedback-email-source').html(iframe);
        };

        Cache.app.request({
            action: 'feedback/getOriginalContent',
            data: {id: feedback_id},
            cache: 120,
            complete: () => {
                modal.find('.loader').removeClass('loader');
            },
            success: (response) => {
                if (response.content) {
                    var iframe = $('<iframe sandbox>').get(0);
                    iframe.srcdoc =
                        '<style>body {margin:0; padding:32px; font-family: Arial, sans-serif; font-size: 14px;}</style>' +
                        '<div>' + response.content + '</div>';

                    modal.find('.modal-feedback-email-source').html(iframe);
                } else {
                    showError();
                }
            },
            error: () => {
                showError();
            }
        });
    },

    // only used for design feedback (deprecated)
    openFeedback: function(feedback_id, open_console, feedback_model, close_sidebar) {
        if (typeof close_sidebar === 'undefined') {
            close_sidebar = true;
        }

        if (Cache.account.get('is_expired')) {
            Modals.expiredAccount();
            return;
        }

        feedback_model = feedback_model || Cache.feedback.get(feedback_id);

        if (!feedback_model) {
            return;
        }

        if (feedback_model.isExpired()) {
            Modals.expiredFeedback();
            return;
        }

        if (feedback_model.get('load_type') === 'upload' && !Cache.account.hasFeature('image_feedback')) {
            Modals.unlockFeature();
            return;
        }

        if (close_sidebar) {
            Sidebar.close();
        }

        var viewer_url = '/viewer/' + feedback_model.get('account_id') + '/' + feedback_model.get('project_id') + '/' + feedback_model.get('share_key') + '/?in_app=1';

        if (feedback_model.get('load_type') === 'upload') {
            viewer_url += '&type=design';
        } else {
            viewer_url += '&type=web';
        }

        if (open_console) {
            viewer_url += '&cl=1';
        }

        $(document.body).css('overflow', 'hidden');

        var overlay = $('<div>').attr('id', 'feedback_viewer_iframe_overlay').appendTo($(document.body));

        var _onMessage = function(e) {
            if (typeof e.originalEvent.data !== 'object') {
                return;
            }

            if (e.originalEvent.data.action === 'close') {
                _onOverlayClose();
            }
        };

        var _onOverlayClose = function(e) {
            var iframe_window = overlay.find('iframe').get(0).contentWindow;

            var _removeOverlay = function() {
                overlay.remove();
                $(document.body).css('overflow', '');
                $(document).off('keyup', _documentClick);

                Router.off('route',      _onOverlayClose);
                $(window).off('message', _onMessage);
            };

            // check hasUnsavedChanges because people can ESC before the iframe is fully loaded
            if (iframe_window && typeof iframe_window.hasUnsavedChanges !== 'undefined') {
                var _removeIframe = function() {
                    var updated_approval_ids = iframe_window.updated_approval_ids;

                    if (updated_approval_ids) {
                        delete iframe_window.updated_approval_ids;
                    }

                    if (updated_approval_ids) {
                        updated_approval_ids.forEach(function(feedback_id) {
                            var feedback_model = Cache.feedback.get(feedback_id);

                            if (feedback_model) {
                                Cache.app.request({
                                    action:  'feedback\\approver/getData',
                                    data: {feedback_id: feedback_id},
                                    success: function(response) {
                                        _.each(Cache.feedback_approver.where({feedback_id: feedback_id}), function(model) {
                                            Cache.feedback_approver.remove(model);
                                        });

                                        Cache.feedback_approver.add(response);
                                    }
                                });

                                Cache.app.request({
                                    action:  'feedback\\screenshot/getData',
                                    data: {feedback_id: feedback_id},
                                    success: function(response) {
                                        Cache.feedback_screenshot.set(response);
                                    }
                                });
                            }
                        });
                    }
                };

                if (iframe_window.hasUnsavedChanges()) {
                    Modal.confirm('You have unsaved comments. Are you sure you want to leave this page?', function() {
                        _removeIframe();
                        _removeOverlay();
                    }, this, 'Yes, leave');

                    return;
                } else {
                    _removeIframe();
                }
            }

            _removeOverlay();

        };

        var _documentClick = function(e) {
            if (e.which === 27) {
                _onOverlayClose();
            }
        };

        overlay.html('<iframe id="feedback_viewer_iframe" src="' + viewer_url + '"></iframe>');
        overlay.find('#feedback_viewer_close').on('click', _onOverlayClose);

        Router.on('route', _onOverlayClose);
        $(window).on('message', _onMessage);
        $(document).on('keyup', _documentClick);
    },

    approveFeatureRequest: function(feedback, on_success) {
        var msg = '<p>Are you sure you want to publish the idea to your ideas portal?</p>';

        if (feedback.get('feedback_type') !== Constants.FEEDBACK_FEATURE_REQUEST) {
            var feedback_type = '';
            switch (feedback.get('feedback_type')) {
                case Constants.FEEDBACK_BUG:
                    feedback_type = 'Bug';
                    break;
                case Constants.FEEDBACK_GENERAL:
                    feedback_type = 'General Feedback';
                    break;
            }

            msg = '<p>Are you sure you want to publish the <b>' + feedback_type + '</b> to your ideas portal as an <b>Idea</b>?</p>';
        }

        Modal.confirm(msg, function() {
            Cache.app.request({
                action: 'feedback/approveForPortal',
                data: {
                    feedback_id: feedback.id
                },
                success: function() {
                    feedback.set({
                        is_portal_approved: true,
                        is_shared: true,
                        feedback_type: Constants.FEEDBACK_FEATURE_REQUEST
                    });

                    UI.success('Idea published');

                    if (on_success) {
                        on_success();
                    }
                }
            });
        }, this, 'Yes, publish');
    },

    unapproveFeatureRequest: function(feedback, on_success) {
        Modal.confirm('<p>Are you sure you want to unpublish this idea and remove it from the ideas portal?</p>', function() {
            Cache.app.request({
                action: 'feedback/approveForPortal',
                data: {
                    feedback_id: feedback.id
                },
                success: function() {
                    feedback.set('is_portal_approved', false);
                    UI.success('Idea unpublished');

                    if (on_success) {
                        on_success();
                    }
                }
            });
        }, this, 'Yes, unpublish');
    },

    editFeedback: function(feedback_id) {
        var feedback_model = Cache.feedback.get(feedback_id);

        var workflow_options = '';
        Cache.workflow.where({project_id: feedback_model.get('project_id')}).forEach((workflow_model) => {
            workflow_options += '<option value="' + workflow_model.id + '">' + workflow_model.escape('name') + '</option>';
        });

        var assignee_options = '<option value="0">Unassigned</option>';
        Cache.app.getUsersByProject(feedback_model.get('project_id'), [Constants.ADMIN, Constants.ASSIGNEE]).forEach((user) => {
            assignee_options += '<option value="' + user.id + '">' + user.escape('name') + '</option>';
        });

        var edit_form = '<form class="compact">' +
                            '<button type="submit" class="hidden"></button>' +
                            '<div>' +
                                '<span class="helper">Status</span>' +
                                '<select name="workflow" class="compact" required>' + workflow_options + '</select>' +
                            '</div>' +
                            '<div>' +
                                '<span class="helper">Priority</span>' +
                                '<select name="priority" class="compact" required>' +
                                    '<option value="urgent">Urgent</option>' +
                                    '<option value="high">High</option>' +
                                    '<option value="neutral">Neutral</option>' +
                                    '<option value="low">Low</option>' +
                                '</select>' +
                            '</div>' +
                            '<div>' +
                                '<span class="helper">Assign To</span>' +
                                '<select name="user_id" class="compact" required>' + assignee_options + '</select>' +
                            '</div>' +
                        '</form>';

        var dialog = Modal.open({
            title: 'Edit Feedback',
            content: edit_form,
            button: {
                'Save': function() {
                    dialog.find('button[type="submit"]').click();
                }
            }
        });

        var form = dialog.find('form');
        var form_data = _.extend({}, feedback_model.attributes);
        Form.setData(form, form_data);

        form.on('submit', function(e) {
            var form_data = Form.getData(form);

            Cache.app.request({
                action:  'feedback/edit',
                data:    _.extend({id: feedback_model.id}, form_data),
                context: this,
                success: function(response) {
                    feedback_model.set({
                        workflow : form_data.workflow,
                        user_id  : form_data.user_id,
                        priority : form_data.priority
                    });

                    Modal.close();
                    UI.success('Feedback details updated');
                }
            });
        });
    },

    deleteUserIdentification: function(user_model) {
        var message = '<p>Deleting this user will permanently delete their identified data from your account. Are you sure you want to proceed?</p>' ;

        Modal.confirm(message, function() {
            Cache.app.request({
                action: 'user_identification/deleteUser',
                data: {id: user_model.id},
                success: function() {
                    Modal.close();
                    UI.success('User deleted');

                    Cache.user_identification.remove(user_model);

                    Cache.feedback.where({user_identification_id: user_model.id}).forEach(function(model) {
                        model.set('user_identification_id', 0);
                    });

                    Cache.session_recording.where({user_identification: user_model.get('identification')}).forEach(function(model) {
                        model.set('user_identification', '');
                    });
                }
            });
        }, this, 'Yes, delete', 'Delete user ' + user_model.get('identification'), 'secondary');
    },

    deleteUserIdentificationKey: function(user_identification_id, key) {
        var user_model = Cache.user_identification.get(user_identification_id);

        Modal.open({
            title: 'Delete Property',
            content: '<p>Are you sure you want to delete the property <b>"' + Util.htmlEntities(key) + '"</b> from user ' + user_model.escape('identification') + '?</p>',
            button_html: '<div class="float-left"><input type="checkbox"><label>Delete it from other users too</label></div>',
            button_class: 'secondary',
            button: {
                'Yes, delete': function(e, modal) {
                    var delete_all = modal.find('input:checkbox').prop('checked') ? true : false;

                    Cache.app.request({
                        action: 'user_identification/deleteKey',
                        data: {
                            id: user_identification_id,
                            key: key,
                            delete_all: delete_all
                        },
                        success: function() {
                            Modal.close();
                            UI.success('User data deleted');

                            if (delete_all) {
                                delete Cache.user_properties[key];

                                Cache.user_identification.each(function(model) {
                                    var props = model.get('props');
                                    delete props[key];
                                    model.set('props', props)
                                    model.trigger('change'); // object change doesn't trigger change event
                                });
                            } else {
                                var props = user_model.get('props');
                                delete props[key];
                                user_model.set('props', props);
                                user_model.trigger('change');
                            }
                        }
                    });
                }
            }
        });
    },

    openUserIdentification: function(user_identification) {
        user_identification = user_identification.toString();

        var open_sidebar = (model) => {
            var view = new View_User_Identification({model: model});

            var on_remove = function() {
                Sidebar.close();
            };

            Sidebar.open({
                html_title: '<span class="badge-id">' + model.escape('identification') + '</span>',
                content: view,
                width: 480,
                onclose: function() {
                    view.stopListening(model, 'remove', on_remove);
                    view.remove();
                },
                onopen: function() {
                    view.listenTo(model, 'remove', on_remove);
                }
            });
        };

        var model = Cache.user_identification.findWhere({identification: user_identification});

        if (model) {
            open_sidebar(model);
        } else {
            Cache.app.request({
                action: 'user_identification/search',
                data: {
                    identification: [user_identification]
                },
                success: (response) => {
                    Cache.user_identification.add(response.data);
                    model = Cache.user_identification.findWhere({identification: user_identification});

                    if (model) {
                        open_sidebar(model);
                    } else {
                        UI.error('User not found');
                    }
                }
            });
            return;
        }
    },

    createUserSegment: function() {
        var active_total = Cache.user_segment.where({is_archived: false}).length;

        if (Cache.account.getUserSegmentLimit() <= active_total) {
            Modals.unlockFeature('Upgrade your plan to have more active User Segments.');
            return;
        }

        var view = new View_User_Segment_Edit();

        var sidebar = Sidebar.open({
            title: 'User Segment',
            width: 480,
            content: view,
            theme: Cache.app.isAdmin() ? 'sidebar-sticky-bottom' : '',
            onopen: () => {
                sidebar.find('input:first').focus();
            }
        });

        view.on('Submit::Success', () => {
            Sidebar.close();
        });
    },

    copyUserSegment: function(user_segment_id) {
        var active_total = Cache.user_segment.where({is_archived: false}).length;

        if (Cache.account.getUserSegmentLimit() <= active_total) {
            Modals.unlockFeature('Upgrade your plan to have more active User Segments.');
            return;
        }

        var segment_model =  Cache.user_segment.get(user_segment_id);

        Modal.open({
            title: 'Duplicate Segment',
            content: '<p>Are you sure you want to duplicate segment <b>' + segment_model.escape('segment_name') + '</b>?</p>',
            button: {
                'Yes, duplicate': function() {
                    Modal.close();

                    Cache.app.request({
                        action: 'user_segment/copy',
                        data: {
                            id: user_segment_id
                        },
                        success: (response) => {
                            Cache.user_segment.add({...response,
                                count_user: segment_model.get('count_user'),
                                usage_project: 0
                            });

                            UI.success('User segment copied');
                        }
                    });

                }
            }
        });
    },

    deleteUserSegment: function(user_segment_id) {
        Modal.confirm('Are you sure you want to delete the user segment?', function(e) {
            Cache.app.request({
                action: 'user_segment/delete',
                data: {
                    id: user_segment_id
                },
                success: () => {
                    Cache.user_segment.remove(user_segment_id);
                    UI.success('User segment deleted');
                }
            });
        }, this, 'Yes, delete', undefined, 'secondary');
    },

    deactivateUserSegment: function(user_segment_id) {
        Modal.confirm('Are you sure you want to deactivate the user segment?', function(e) {
            Cache.app.request({
                action: 'user_segment/update',
                data: {
                    id: user_segment_id,
                    is_archived: true
                },
                success: (response) => {
                    Cache.user_segment.get(user_segment_id).set(response);
                    UI.success('User segment deactivated');
                }
            });
        }, this, 'Yes, deactivate', undefined, 'secondary');
    },

    reactivateUserSegment: function(user_segment_id) {
        var active_total = Cache.user_segment.where({is_archived: false}).length;

        if (Cache.account.getUserSegmentLimit() <= active_total) {
            Modals.unlockFeature('Upgrade your plan to have more active User Segments.');
            return;
        }

        Modal.confirm('Are you sure you want to reactivate the user segment?', function(e) {
            Cache.app.request({
                action: 'user_segment/update',
                data: {
                    id: user_segment_id,
                    is_archived: false
                },
                success: (response) => {
                    Cache.user_segment.get(user_segment_id).set(response);
                    UI.success('User segment deactivated');
                }
            });
        }, this, 'Yes, reactivate', undefined, 'secondary');
    },

    viewUserSegment: function(user_segment_id) {
        var view;

        if (user_segment_id === 0) {
            // all users
            view = new View_User_Segment_Overview();
        } else {
            var model = Cache.user_segment.get(user_segment_id);

            if (!model) {
                return;
            }

            view = new View_User_Segment_Overview({model: model});
        }

        Sidebar_Bg.open({
            title: user_segment_id === 0 ? 'All Users' : model.get('segment_name'),
            width: 480,
            content: view
        });
    },

    editUserSegment: function(user_segment_id) {
        var model = Cache.user_segment.get(user_segment_id);

        if (!model) {
            return;
        }

        var view = new View_User_Segment_Edit({model: model});

        Sidebar.open({
            title: 'User Segment',
            width: 480,
            content: view,
            theme: Cache.app.isAdmin() ? 'sidebar-sticky-bottom' : ''
        });

        view.on('Submit::Success', () => {
            Sidebar.close();
        });
    },

    referAccount: function() {
        var account_refer_view = new View_Account_Refer;

        Modal.open({
            width: 700,
            nopadding: true,
            notitle: true,
            content: account_refer_view,
            onclose: function() {
                if (account_refer_view) {
                    account_refer_view.remove();
                }

                Router.removeQueryString('referral_code');
            }
        });

        Router.addQueryString('referral_code', 1);
    },

    forgotPassword: function() {
        var modal = Modal.open({
            width: 500,
            notitle: true,
            content: '<form class="compact padding-32 padding-0-phone">' +
                            '<h3 class="text-align-center font-weight-semibold">Forgot Password</h3>' +
                            '<div class="divider-12"></div>' +
                            '<div class="banner-success" style="display:none;"></div>' +
                            '<div>' +
                                '<span class="helper">Email Address</span>' +
                                '<input type="email" name="email" required>' +
                            '</div>' +
                            '<div class="text-align-right margin-top-48">' +
                                '<div class="text-info text-medium float-left margin-top-14">Click here to <a class="sign-in text-info" href="#">Sign in</a>.</div>' +
                                '<button class="primary">Request Reset Link</button>' +
                            '</div>' +
                        '</form>'
        });

        Form.setPlaceholder(modal.find('form'));
        modal.find('input:first').focus();

        modal.find('form').on('submit', function(e) {
            var form_data = Form.getData(modal.find('form'));

            modal.find('form input').prop('disabled', true);
            modal.find('button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'app/forgotPassword',
                data: form_data,
                context: this,
                anon: true,
                success: function(response) {
                    modal.find('.banner-success').html('If an account exists for <b>' + Util.htmlEntities(form_data.email) + '</b>, you will get an email with instructions on resetting your password.').show();
                },
                complete: function() {
                    modal.find('form input').prop('disabled', false);
                    modal.find('button:submit').prop('disabled', false).removeClass('loading');
                }
            });
        });

        modal.find('.sign-in').on('click', function(e) {
            e.preventDefault();
            Modals.signIn();
        });
    },

    passwordReset: function(reset_key) {
        var modal = Modal.open({
            width: 500,
            notitle: true,
            content: '<form class="compact padding-32 padding-0-phone">' +
                            '<input type="hidden" name="key" value="' + Util.htmlEntities(reset_key) + '">' +
                            '<h3 class="text-align-center font-weight-semibold">Reset Password</h3>' +
                            '<div class="divider-12"></div>' +
                            '<div class="banner-danger" style="display:none;"></div>' +
                            '<div>' +
                                '<span class="helper">New Password</span>' +
                                '<input type="password" name="password" required>' +
                            '</div>' +
                            '<div class="text-align-right margin-top-48">' +
                                '<div class="text-info text-medium float-left margin-top-14">Know your password? <a class="sign-in text-info" href="#">Sign in</a>.</div>' +
                                '<button class="primary">Reset Password</button>' +
                            '</div>' +
                        '</form>'
        });

        Form.setPlaceholder(modal.find('form'));
        modal.find('input:first').focus();

        modal.find('form').on('submit', function(e) {
            var form_data = Form.getData(modal.find('form'));

            modal.find('button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'app/resetPortalPassword',
                data: form_data,
                context: this,
                anon: true,
                success: function(response) {
                    if (response.error_msg) {
                        modal.find('.banner-danger').text(response.error_msg).show();
                    } else {
                        UI.success('Password reset successfully');
                        Modal.close();
                    }
                },
                complete: function() {
                    modal.find('button:submit').prop('disabled', false).removeClass('loading');
                }
            });
        });
    },

    signIn: function(on_success) {
        var modal = Modal.open({
            width: 500,
            notitle: true,
            content: '<div class="portal-sign-in-modal">' +
                        '<div class="form" data-step="1">' +
                            '<form class="compact padding-32 padding-0-phone">' +
                                '<h3 class="text-align-center font-weight-semibold">Sign in to your account</h3>' +
                                '<div class="divider-12"></div>' +
                                '<div class="banner-danger" style="display:none;"></div>' +
                                '<div>' +
                                    '<span class="helper">Email Address</span>' +
                                    '<input type="email" name="email" class="compact" required></div>' +
                                '<div>' +
                                    '<span class="helper">Password</span>' +
                                    '<input type="password" name="password" class="compact" maxlength="255" class="login-password" required>' +
                                '</div>' +
                                '<div class="text-align-right margin-top-48">' +
                                    '<a class="forgot-password text-info text-medium float-left margin-top-14" href="#">Forgot password?</a>' +
                                    '<button type="submit" class="primary" style="width:130px;">Sign in</button>' +
                                '</div>' +
                            '</form>' +
                        '</div>' +
                        '<div class="form padding-32 padding-0-phone" data-step="2">' +
                            '<p class="text-align-center">Your login code has been sent to <strong class="2fa-email"></strong>.</p>' +
                            '<p class="text-align-center">Enter the code to continue.</p>' +
                            '<div class="email-confirmation">' +
                                '<div class="code-wrapper">' +
                                    '<div class="code-container">' +
                                        '<form class="code-form">' +
                                            '<div class="code-input code-input-6">' +
                                                '<input type="text" maxlength="1">' +
                                                '<input type="text" maxlength="1">' +
                                                '<input type="text" maxlength="1">' +
                                                '<input type="text" maxlength="1">' +
                                                '<input type="text" maxlength="1">' +
                                                '<input type="text" maxlength="1">' +
                                            '</div>' +
                                        '</form>' +
                                    '</div>' +
                                    '<div class="confirm-code-loader loader loader-small loader-primary"></div>' +
                                    '<div class="code-error-msg"><i class="fad fa-exclamation-circle"></i> <span></span></div>' +
                                    '<div class="code-resend"><a href="#" class="primary">Didn\'t receive the code? Resend.</a></div>' +
                                '</div>' +
                            '</div>' +
                        '</div>'+
                    '</div>',
        });

        Form.setPlaceholder(modal.find('form'));
        modal.find('input:first').focus();

        modal.find('form').on('submit', function(e) {
            var form_data = Form.getData(modal.find('form'));

            modal.find('form').find('input').prop('disabled', true);
            modal.find('button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'app/portalLogin',
                data  : form_data,
                anon  : true,
                success: (response) => {
                    if (response.error_msg) {
                        modal.find('.banner-danger')
                            .text(response.error_msg)
                            .show();
                        return;
                    }

                    if (response.authenticated === false) {
                        modal.find('.banner-danger')
                            .text('You entered an incorrect email, password, or both.')
                            .show();
                        return;
                    }

                    if (response['2fa']) {
                        modal.find('.form[data-step="1"]').hide();
                        modal.find('.form[data-step="2"]').find('.2fa-email').text(form_data.email);
                        modal.find('.form[data-step="2"]').show().find('input:first').focus();
                        return;
                    }

                    if (on_success) {
                        on_success();
                        return;
                    }

                    window.location.reload();
                },
                complete: () => {
                    modal.find('form').find('input').prop('disabled', false);
                    modal.find('button:submit').prop('disabled', false).removeClass('loading');
                }
            });
        });

        modal.find('.email-confirmation .code-form').on('submit', (e) => {
            e.preventDefault();

            var confirmation_code = '';

            modal.find('.email-confirmation .code-input input').each(function() {
                var val = $(this).val();

                confirmation_code += val;
            });

            var form_data = Form.getData(modal.find('form'));

            modal.find('.email-confirmation input').prop('disabled', true);
            modal.find('.confirm-code-loader').show();

            modal.find('.form[data-step="2"] .code-error-msg').hide();

            Cache.app.request({
                action: 'app/portalLogin',
                data: {
                    email   : form_data.email,
                    password: form_data.password,
                    code    : confirmation_code
                },
                anon: true,
                success: (response) => {
                    if (response.error_msg) {
                        modal.find('.email-confirmation input').prop('disabled', false);
                        modal.find('.confirm-code-loader').hide();

                        modal.find('.form[data-step="2"] .code-error-msg').show().find('span').html(response.error_msg);
                        return;
                    }

                    if (response.authenticated === false) {
                        modal.find('.email-confirmation input').prop('disabled', false);
                        modal.find('.confirm-code-loader').hide();

                        modal.find('.form[data-step="2"] .code-error-msg').show().find('span').html('Invalid code');
                        return;
                    }

                    if (on_success) {
                        on_success();
                        return;
                    }

                    window.location.reload();
                }
            });
        });

        modal.find('.email-confirmation .code-resend a').on('click', () => {
            var form_data = Form.getData(modal.find('form'));

            Cache.app.request({
                action: 'app/portalLogin',
                data: {
                    email    : form_data.email,
                    password : form_data.password,
                },
                anon: true,
                success: (response) => {
                    if (!response) {
                        return;
                    }

                    if (response.error_msg) {
                        modal.find('.email-confirmation input').prop('disabled', false);
                        modal.find('.confirm-code-loader').hide();

                        modal.find('.form[data-step="2"] .code-error-msg').show().find('span').html(response.error_msg);

                        return;
                    }

                    UI.success('We\'ve sent you a new login code.');
                }
            });

            modal.find('.email-confirmation .code-resend').html('&nbsp;');
        });

        modal.find('.forgot-password').on('click', function(e) {
            e.preventDefault();
            Modals.forgotPassword();
        });
    },

    portalSignup: function() {
        var form =
        '<form class="compact padding-32 padding-0-phone">' +
            '<h3 class="text-align-center font-weight-semibold">Sign up for Userback</h3>' +
            '<div class="text-align-center text-info">We use Userback to collect feedback from great people like you. Sign up to post your ideas or vote.</div>' +
            '<div class="divider-12"></div>' +
            '<div class="banner-danger" style="display:none;">Wrong password</div>' +
            '<div>' +
                '<span class="helper">Name</span>' +
                '<input type="text" name="display_name" class="compact" maxlength="100" data-nonempty="true" required>' +
            '</div>' +
            '<div>' +
                '<span class="helper">Email Address</span>' +
                '<input type="email" name="email" class="compact" required>' +
            '</div>' +
            '<div>' +
                '<span class="helper">Password</span>' +
                '<input type="password" name="password" class="compact" required>' +
            '</div>' +
            '<div class="text-align-center margin-top-48 margin-bottom-0">' +
                '<button class="primary" style="width:130px;">Sign Up</button>' +
                '<div class="margin-top-24 text-info">' +
                    'Already have an account? <a href="#" class="sign-in primary">Sign in</a>' +
                '</div>' +
            '</div>' +
        '</form>';

        var modal = Modal.open({
            width: 500,
            notitle: true,
            content: form
        });

        Form.setPlaceholder(modal.find('form'));
        modal.find('form input:first').focus();

        modal.find('.sign-in').on('click', function(e) {
            e.preventDefault();
            this.signIn();
        }.bind(this));

        modal.find('form').on('submit', function(e) {
            var form_data = Form.getData(modal.find('form'));

            modal.find('.banner-danger').hide();

            modal.find('input').prop('disabled', true);
            modal.find('button:submit').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'app/portalRegister',
                data: form_data,
                context: this,
                anon: true,
                success: function(response) {
                    if (response.error_msg) {
                        modal.find('.banner-danger')
                            .text(response.error_msg)
                            .show();

                        modal.find('input').prop('disabled', false);
                        modal.find('button:submit').prop('disabled', false).removeClass('loading');
                    } else {
                        // TODO: auto log in
                        // log in
                        Cache.app.request({
                            action: 'app/portalLogin',
                            data: {
                                email    : form_data.email,
                                password : form_data.password
                            },
                            context: this,
                            anon: true,
                            success: function(response) {
                                if (response.authenticated === false) {
                                    // just signed up but couldnt log in
                                } else {
                                    window.location.reload();
                                }
                            }
                        });


                    }
                },
                error: function() {
                    modal.find('.banner-danger')
                        .text('Error occured, please try again.')
                        .show();

                    modal.find('input').prop('disabled', false);
                    modal.find('button:submit').prop('disabled', false).removeClass('loading');
                }
            });
        });
    },

    portalGuest: function(on_close, hide_login) {
        var is_embed = Router.getQueryString('embed') === 'widget';

        var guest_form =
        '<form class="form-fluid padding-32 padding-0-phone">' +
            '<h3 class="text-align-center font-weight-semibold">Tell us who you are</h3>' +
            '<div class="divider-12"></div>' +
            '<div class="row">' +
                '<div class="field-label">Your name</div>' +
                '<input type="text" name="name" class="solid medium" maxlength="100" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Your email</div>' +
                '<input type="email" name="email" class="solid medium" required>' +
            '</div>' +
            '<div class="divider-12"></div>' +
            '<div>' +
                '<button type="submit" class="primary medium fluid">Submit</button>' +
                (hide_login === true || is_embed ? '' :
                '<div class="margin-top-24 text-info text-align-center">' +
                    'Already have an account? <a href="#" class="sign-in primary">Sign in</a>' +
                '</div>') +
            '</div>' +
        '</form>';

        var dialog = Modal.open({
            width: 480,
            notitle: true,
            content: guest_form,
            theme: 'mobile-fullsize',
            onclose: function() {
                if (on_close) {
                    on_close();
                }
            }
        });

        if (Cache.guest_user) {
            Form.setData(dialog.find('form'), {
                email : Cache.guest_user.get('email'),
                name  : Cache.guest_user.get('name')
            });
        }

        dialog.find('form input:first').focus();

        dialog.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData(dialog.find('form'));

            dialog.find('button:submit').addClass('loading').prop('disabled', true);

            if (is_embed) {
                var session_info = btoa(JSON.stringify({
                    email: form_data.email,
                    name : form_data.name
                }));

                var url = new URL(window.location.href);
                url.searchParams.set('gl', session_info);

                Router.navigate(url.pathname + url.search + url.hash, {trigger: true});
            } else {
                Cache.app.request({
                    action: 'app/guestLogin',
                    data: form_data,
                    success: function() {
                        Cache.setGuestUser(form_data.email, form_data.name);
                        Modal.close();
                        Cache.app.dispatcher.trigger('Portal:guestUpdate');
                    },
                    complete: function() {
                        dialog.find('button:submit').removeClass('loading').prop('disabled', false);
                    }
                });
            }
        });

        dialog.find('.sign-in').on('click', function(e) {
            e.preventDefault();
            Modals.signIn(function() {
                window.location.href = Cache.portal.at(0).getUrl();
            });
        });
    },

    viewerGuest: function(callback) {
        var guest_form = '<form class="compact padding-32 padding-0-phone">' +
                                '<h3 class="text-align-center font-weight-semibold">Tell us who you are</h3>' +
                                '<div class="divider-12"></div>' +
                                '<button type="submit" class="hidden"></button>' +
                                '<div>' +
                                    '<span class="helper">Your name</span>' +
                                    '<input type="text" name="name" class="compact" required>' +
                                '</div>' +
                                '<div>' +
                                    '<span class="helper">Your email</span>' +
                                    '<input type="email" name="email" class="compact" required>' +
                                '</div>' +
                                '<div class="text-align-center margin-top-48 margin-bottom-0">' +
                                '<button class="primary" style="width:130px;">Submit</button>' +
                            '</div>' +
                            '</form>';

        var dialog = Modal.open({
            width: 500,
            notitle: true,
            content: guest_form
        });

        if (Cache.guest_user) {
            Form.setData(dialog.find('form'), {
                email : Cache.guest_user.get('email'),
                name  : Cache.guest_user.get('name')
            });
        }

        Form.setPlaceholder(dialog.find('form'));

        dialog.find('form input:first').focus();

        dialog.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData(dialog.find('form'));

            dialog.find('button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'app/guestLogin',
                data: form_data,
                success: function() {
                    Cache.setGuestUser(form_data.email, form_data.name);
                    Modal.close();

                    if (callback) {
                        callback(form_data.anon_email, form_data.anon_name);
                    }

                    Cache.app.dispatcher.trigger('Viewer:guestUpdate');
                },
                complete: function() {
                    dialog.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    deletePromoCode: function(code, on_success) {
        Modal.confirm('Are you sure you want to delete the code <b>' + code + '</b>?', function() {
            Cache.app.request({
                action: 'admin/deletePromoCode',
                data: {code: code},
                success: function(response) {
                    Modal.close();
                    UI.success('Promo code deleted');

                    on_success();
                }
            });
        });
    },

    createPromoCode: function(on_success) {
        var form = '<form>' +
                        '<div>' +
                            '<span class="helper placeholder">Code</span>' +
                            '<input type="text" name="code" maxlength="100" required>' +
                        '</div>' +
                        '<div>' +
                            '<span class="helper">Discount</span>' +
                            '<input type="number" min="1" max="99" value="20" name="discount" maxlength="100" required>' +
                        '</div>' +
                        '<div>' +
                            '<span class="helper placeholder">Offer Description</span>' +
                            '<input type="text" name="offer_text" required>' +
                        '</div>' +
                        '<div>' +
                            '<span class="helper">Expiry Date</span>' +
                            '<input type="date" name="expiry_date" placeholder="dd/mm/yyyy" required>' +
                        '</div>' +
                        '<div>' +
                            '<input type="radio" name="promo_code_type" value="' + Constants.PROMO_CODE_LIFE_TIME + '" checked><label>Life Time</label>' +
                            '<input type="radio" name="promo_code_type" value="' + Constants.PROMO_CODE_SINGLE + '"><label>First Invoice Only</label>' +
                        '</div>' +
                        '<div>' +
                            '<input type="radio" name="promo_plan_type" value="0" checked><label>Both</label>' +
                            '<input type="radio" name="promo_plan_type" value="' + Constants.MONTHLY + '"><label>Monthly Plan Only</label>' +
                            '<input type="radio" name="promo_plan_type" value="' + Constants.ANNUALLY + '"><label>Annual Plan Only</label>' +
                        '</div>' +
                        '<div class="text-align-right"><button class="primary">Add</button></div>' +
                    '</form>';
        var dialog = Modal.open({
            title: 'Create Promo Code',
            content: form,
        });

        dialog.find('input:first').focus();

        dialog.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData($(this));

            dialog.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'admin/createPromoCode',
                data: form_data,
                success: function(response) {
                    Modal.close();
                    UI.success('Promo code created');

                    on_success();
                },
                complete: function() {
                    dialog.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    modifyPromoCode: function(code, offer_text, expiry_date, on_success) {
        var form = '<form>' +
                        '<div>' +
                            '<span class="helper placeholder">Offer Description</span>' +
                            '<input type="text" name="offer_text" required>' +
                        '</div>' +
                        '<div>' +
                            '<span class="helper">Expiry Date</span>' +
                            '<input type="date" name="expiry_date" placeholder="dd/mm/yyyy" required>' +
                        '</div>' +
                        '<button class="primary">Edit</button>' +
                    '</form>';

        var dialog = Modal.open({
            title: 'Edit Promo Code',
            content: form,
        });

        Form.setData(dialog.find('form'), {
            offer_text: offer_text,
            expiry_date: expiry_date
        });

        dialog.find('input:first').focus();

        dialog.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData($(this));

            dialog.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'admin/editPromoCode',
                data: _.extend({code: code}, form_data),
                success: function(response) {
                    Modal.close();
                    UI.success('Promo code updated');

                    on_success();
                },
                complete: function() {
                    dialog.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    deletePartnerCode: function(code, on_success) {
        Modal.confirm('Are you sure you want to delete the partner code <b>' + code + '</b>?', function() {
            Cache.app.request({
                action: 'admin/deletePartnerCode',
                data: {code: code},
                success: function(response) {
                    Modal.close();
                    UI.success('Partner code deleted');
                    on_success();
                }
            });
        });
    },

    createPartnerCode: function(on_success) {
        var form = '<form class="form-fluid">' +
                        '<div class="row">' +
                            '<div class="field-label">Account ID</div>' +
                            '<input type="text" name="account_id" required>' +
                        '</div>' +
                        '<div class="row">' +
                            '<div class="field-label">Description</div>' +
                            '<input type="text" name="description">' +
                        '</div>' +
                        '<button class="submit hidden"></button>' +
                    '</form>';
        var dialog = Modal.open({
            title: 'Create Partner Code',
            content: form,
            button: {
                Add: () => {
                    dialog.find('form').submit();
                }
            }
        });

        dialog.find('input:first').focus();
        dialog.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData($(this));

            dialog.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'admin/createPartnerCode',
                data: form_data,
                success: function(response) {
                    Modal.close();
                    UI.success('Promo code created');

                    on_success();
                },
                complete: function() {
                    dialog.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    modifyPartnerCode: function(model) {
        var form = '<form class="form-fluid">' +
                        '<div class="row">' +
                            '<div class="field-label">Description</div>' +
                            '<input type="text" name="description" required>' +
                        '</div>' +
                        '<button class="submit hidden"></button>' +
                    '</form>';

        var dialog = Modal.open({
            title: 'Edit Partner Code',
            content: form,
            button: {
                Edit: () => {
                    dialog.find('form').submit();
                }
            }
        });

        Form.setData(dialog.find('form'), {
            description: model.get('description')
        });

        dialog.find('input:first').focus();

        dialog.find('form').on('submit', function(e) {
            e.preventDefault();

            var form_data = Form.getData($(this));

            dialog.find('button.primary').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'admin/modifyPartnerCode',
                data: _.extend({code: model.get('code')}, form_data),
                success: function(response) {
                    model.set(form_data);

                    Modal.close();
                    UI.success('Partner code updated');
                },
                complete: function() {
                    dialog.find('button.primary').removeClass('loading').prop('disabled', false);
                }
            });
        });
    },

    previewConfirmationEmail: function(email_html) {
        var html_title = 'Email Preview';

        if (Cache.app.isAdmin()) {
            html_title += '<a class="navigation text-info text-medium text-transform-none font-weight-regular margin-right-24" href="/account/branding" style="float: right;"><i class="fa-solid fa-pen-to-square margin-right-4"></i>Email Branding</a>';
        }

        var modal = Sidebar.open({
            html_title: html_title,
            content: '<iframe></iframe>' +
                     '<div class="mask-light loader"></div>',
            width: 950,
            nopadding: true
        });

        Cache.app.request({
            action: 'feedback\\Confirmation/view',
            data: {
                email_html: email_html,
            },
            success: function(response) {
                modal.find('.mask-light').remove();

                var iframe = modal.find('iframe').get(0);
                iframe = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
                iframe.document.open();
                iframe.document.write(response);
                iframe.document.close();
            }
        });
    },

    previewAutoreplyEmail: function(comment_content) {
        var modal = Sidebar.open({
            html_title: 'Auto-reply Preview',
            content: '<iframe></iframe>' +
                     '<div class="mask-light loader"></div>',
            width: 950,
            nopadding: true
        });

        Cache.app.request({
            action: 'feedback\\autoreply/view',
            data: {
                content: comment_content,
            },
            success: function(response) {
                modal.find('.mask-light').remove();

                var iframe = modal.find('iframe').get(0);
                iframe = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
                iframe.document.open();
                iframe.document.write(response);
                iframe.document.close();
            }
        });
    },

    previewReplyTemplate: function(content) {
        var modal = Sidebar.open({
            html_title: 'Reply Template Preview',
            content: '<iframe></iframe>' +
                        '<div class="mask-light loader"></div>',
            width: 950,
            nopadding: true
        });

        Cache.app.request({
            action: 'feedback\\Comment_Template/view',
            data: {
                content: content,
            },
            success: function(response) {
                modal.find('.mask-light').remove();

                var iframe = modal.find('iframe').get(0);
                iframe = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
                iframe.document.open();
                iframe.document.write(response);
                iframe.document.close();
            }
        });
    },
};

export default Modals;
